var do_debug = false;
function do_console(data){
	if(do_debug == true) {
		debugger;
		console.log(data);
	}
}
/* Test Parameters */
var test_ca = false;
if(window.location.href.toString().trim().indexOf('test_ca') !== -1) {
	test_ca = true;	
	do_console('test_ca' + test_ca);
}

var Shopify = Shopify || {};
// ---------------------------------------------------------------------------
// Money format handler
// ---------------------------------------------------------------------------

Shopify.formatMoney = function (cents, format) {
	if (typeof cents == 'string') { cents = cents.replace('.', ''); }
	var value = '';
	var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
	var formatString = (format || this.money_format);

	function defaultOption(opt, def) {
		return (typeof opt == 'undefined' ? def : opt);
	}

	function formatWithDelimiters(number, precision, thousands, decimal) {
		precision = defaultOption(precision, 2);
		thousands = defaultOption(thousands, ',');
		decimal = defaultOption(decimal, '.');

		if (isNaN(number) || number == null) { return 0; }

		number = (number / 100.0).toFixed(precision);

		var parts = number.split('.'),
			dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
			cents = parts[1] ? (decimal + parts[1]) : '';

		return dollars + cents;
	}

	switch (formatString.match(placeholderRegex)[1]) {
		case 'amount':
			value = formatWithDelimiters(cents, 2);
			break;
		case 'amount_no_decimals':
			value = formatWithDelimiters(cents, 0);
			break;
		case 'amount_with_comma_separator':
			value = formatWithDelimiters(cents, 2, '.', ',');
			break;
		case 'amount_no_decimals_with_comma_separator':
			value = formatWithDelimiters(cents, 0, '.', ',');
			break;
	}

	return formatString.replace(placeholderRegex, value);
};

function findGetParameter(parameterName) {
    var result = null,
        tmp = [];
    location.search
        .substr(1)
        .split("&")
        .forEach(function (item) {
          tmp = item.split("=");
          if (tmp[0] === parameterName) result = decodeURIComponent(tmp[1]);
        });
    return result;
}

function adjust_sub_options(){
	let freq_val = $("#frequency-select").val().toString().trim().toLowerCase();
	let variant_name = "";
	let new_freq_val = "";
	if( $(`.product-cart-box [name="id"]:checked`).length > 0 ){
	variant_name = $(`.product-cart-box [name="id"]:checked`).attr('data-variant-title').trim().toLowerCase();	
	new_freq_val = variant_name + "/" + freq_val;
	}else{
		new_freq_val = freq_val;
	}


	$('.product-info .subscription-freq option').prop('selected',false);
	$('.product-info .subscription-freq option').each(function(ix,em){
	  let current_lower_val = $(em).text().trim().toLowerCase();
	  debugger;
	  if( current_lower_val.indexOf(new_freq_val) !== -1 ) {
		// $(em).attr('selected','selected');
		$(em).prop('selected',true);
		$('.product-info .subscription-freq').trigger('change');
	  }else{
		$(em).prop('selected',false);
		$(em).removeProp('selected')
	  }
	});
}

$(document).ready(function(){
	let selected_variant = findGetParameter('variant');
	if(selected_variant != null){
		adjust_sub_options()
	}
})

function sendOneSignalTags(productName, productImageURL) {
	//let productName = "Teami Clean, 2-in-1 Silicone Bottle Brush";//Replace with the name of item
	//let productImageURL = "https://cdn.shopify.com/s/files/1/0191/6439/7668/products/Teami_Cleancopy.png?v=1596568143";//Replace with the url to the image
	//Use this example method when user adds item to cart	
	if (typeof OneSignal != "undefined") {
		OneSignal.push(function () {
			var timestamp = Math.floor(Date.now() / 1000);
			OneSignal.sendTags({
				cart_update: timestamp,
				product_name: productName,
				product_image: productImageURL,
			}).then(function (tagsSent) {

			});
		});
	}

}



var cart_items_object = [];
var is_DOM_Ready = false;
jQuery(document).ready(function (e) {
	// jQuery( "#addtocart" ).on( "submit", function( event ) {
	// 	event.preventDefault();
	// 	var $this = jQuery( this );
	// 	if ( $this.hasClass( "is-uploading" ) ) {} else {
	// 		event.preventDefault();
	// 		jQuery( "#crtbtn1" ).attr( "disabled", "disabled" );
	// 		jQuery( "#addtocart" ).addClass( "is-uploading" );
	// 		var totalquantity = parseInt( jQuery( "#item_Quantity", $this ).val() );
	// 		var varianttoadd = jQuery( "select[data-variant-select]", $this ).val();
	// 		var product_id = jQuery( "input[name='id']", $this ).val();
	// 		var data_to_send = {
	// 			'quantity': totalquantity,
	// 			'id': product_id,
	// 			'variant_id': varianttoadd
	// 		}
	// 		if(jQuery("#is_subscribed_yes").is(':checked')) {
	// 			// updated data_to_send
	// 			var subscription_variant_id = subscription_product_info.variant_to_duplicate[product_id];
	// 			var selectedfrequency = jQuery('.fre_option').children("option:selected").attr("data-fre");
	// 			//var selectedfrequency = jQuery("#shipping_interval_frequency_box input[name='shipping_interval_frequency']:checked").val();
	// 			var line_properties = {};
	// 			line_properties.subscription_id = subscription_product_info.subscription_id;				
	// 			line_properties.shipping_interval_frequency = selectedfrequency;
	// 			line_properties.shipping_interval_unit_type = subscription_product_info.shipping_interval_unit;
	// 			data_to_send = {
	// 				'quantity': totalquantity,
	// 				'id': subscription_variant_id,
	// 				properties: line_properties
	// 			}

	// 		}
	// 		jQuery.ajax( {
	// 			url: '/cart/add.js',
	// 			method: "POST",
	// 			dataType: "JSON",
	// 			data:data_to_send,
	// 			success: function( data ) {
	// 				sendOneSignalTags(data.product_title,data.image);
	// 				update_cart_popup();
	// 				jQuery( ".nav-item.nav-shop .badge" ).show();
	// 				jQuery( ".nav-shop-mobile .badge" ).show();
	// 				var valueToUpdate = parseInt( jQuery( ".nav-item.nav-shop .badge" ).text() ) +
	// 					totalquantity;
	// 				jQuery( ".nav-shop-mobile .badge" ).text( valueToUpdate.toString() );
	// 				jQuery( ".nav-item.nav-shop .badge" ).text( valueToUpdate.toString() );
	// 				jQuery( "#crtbtn1" ).removeAttr( "disabled" );
	// 				jQuery( "#addtocart" ).removeClass( "is-uploading" );
	// 			},
	// 			error: function( data ) {
	// 				if ( typeof data.responseJSON.description !== "undefined" ) {
	// 					var message = data.responseJSON.description;
	// 				} else {
	// 					var message = "Please try again later!";
	// 				}
	// 				swal( {
	// 					title: "Oops!!",
	// 					text: message,
	// 					icon: "error",
	// 					className: "add-ajax-outofstock",
	// 					buttons: false,
	// 					timer: 1500
	// 				} );
	// 				jQuery( "#crtbtn1" ).removeAttr( "disabled" );
	// 				jQuery( "#addtocart" ).removeClass( "is-uploading" );
	// 			}
	// 		} );
	// 	}
	// } );
	jQuery("#addtocart").on("submit", function (event) {
		event.preventDefault();
		var $this = jQuery(this);
		if ($this.hasClass("is-uploading")) { } else {
			event.preventDefault();
			jQuery("#crtbtn1").attr("disabled", "disabled");
			jQuery("#addtocart").addClass("is-uploading");
			var totalquantity = parseInt(jQuery("#item_Quantity", $this).val());
			//var varianttoadd = jQuery( "select[data-variant-select]", $this ).val();
			debugger
			var product_id = jQuery("input[name='id']", $this).val();
			if(product_id == ''){
				product_id = jQuery("input[name='id']", $this).attr('first-var-id');
			}
			if($(`#addtocart #is_subscribed_yes:checked`).length > 0) {
				let selling_plan = $("#addtocart select#frequency-select option:selected").attr(`data-subscription-id-to-add`);
				data_to_send = {
					'quantity': totalquantity,
					'id': product_id,
					'selling_plan' : selling_plan
					/*
					properties: line_properties
					*/
				}
			} else {
				data_to_send = {
					'quantity': totalquantity,
					'id': product_id
				}
			}
			/*
			if (jQuery(".subscription_value.product_add .subscription-freq").length) {
				jQuery(".subscription_value.product_add .subscription-freq option:selected").each(function (ix, em) {
					var sub_val = jQuery(em).val();
					if (sub_val == 'subscribe-save') {
						/ *
						if (jQuery(".form-check-wrapper").length) {
							var product_id_to_add = jQuery(em).attr('data-subscription-id');
						}
						var subscription_variant_id = jQuery(em).attr("data-subscription-id-to-add");
						var selectedfrequency = jQuery(em).attr("data-freq");
						var selectedfrequencyunit = jQuery(em).attr('data-unit');
						var line_properties = {};
						line_properties.subscription_id = subscription_variant_id;
						line_properties.shipping_interval_frequency = selectedfrequency;
						line_properties.shipping_interval_unit_type = selectedfrequencyunit;
						line_properties.selling_plan_id = $(this).attr('selling_plan_id')
						* /
						let selling_plan = $("#addtocart select#frequency-select option:selected").attr(`data-subscription-id-to-add`);
						data_to_send = {
							'quantity': totalquantity,
							'id': product_id,
							'selling_plan' : selling_plan
							/ *
							properties: line_properties
							* /
						}
					} else {
						data_to_send = {
							'quantity': totalquantity,
							'id': product_id
						}
					}
				});
			} else {
				var data_to_send = {
					'quantity': totalquantity,
					'id': product_id
				}
			}*/
			if (jQuery("#crtbtn1.easeter_popup_product").length) {
				if (jQuery('.subscription_value.product_add .subscription-freq').length) {
					jQuery(".subscription_value.product_add .subscription-freq option:selected").each(function (ix, ex) {
						var sub_val = jQuery(ex).val();
						if (sub_val == 'onetime') {
							var $this = jQuery('#crtbtn1.easeter_popup_product');
							data_url = $this.attr('data-url');
							jQuery('#easter_popup_overlay_product').fadeIn();
							jQuery('#easter_popup').fadeIn();
							jQuery('body').addClass("is_easterpopup_open");
							jQuery('body').addClass("overflow-hidden");

							var easter_image = $this.attr("data-e-image");
							var discount_code = $this.attr("data-e-dcode");
							var easter_desc = $this.attr("data-e-desc");
							var easter_howto = $this.attr("data-e-redeem");
							var hover_info_text = $this.attr("data-e-info");

							jQuery("#easter_popup .popup_modal .popup-body .popup_code .popup_img img").attr("src", easter_image);
							jQuery("#easter_popup .popup_modal .popup-body .popup_code .popup_code_text p span b").text(discount_code);
							jQuery("#easter_popup .popup_modal .popup-body .popup_code .popup_code_text p.deal span").text(easter_desc);
							jQuery("#easter_popup .popup_modal .popup-body .popup_code .popup_code_text .prod_info h2").text(easter_howto);
							jQuery("#easter_popup .popup_modal .popup-body .popup_code .popup_code_text .prod_info .icon_info .eag-note").text(hover_info_text);
						} else {
							do_console(212);
							jQuery.ajax({
								url: '/cart/add.js',
								method: "POST",
								dataType: "JSON",
								data: data_to_send,
								success: function (data) {
									update_cart_popup();
									if(typeof window.customer_email !== 'undefined') {
										window.liQ = window.liQ || [];
										window.liQ.push({
										"event": "addToCart",
										"email": window.customer_email
										});
									}
									jQuery(".nav-item.nav-shop .badge").show();
									jQuery(".nav-shop-mobile .badge").show();
									jQuery(".nav-item.nav-shop .badge").show();
									jQuery(".nav-shop-mobile .badge").show();
									var valueToUpdate = parseInt(jQuery(".nav-item.nav-shop .badge").text()) +
										totalquantity;
									jQuery(".nav-shop-mobile .badge").text(valueToUpdate.toString());
									jQuery(".nav-item.nav-shop .badge").text(valueToUpdate.toString());
									jQuery("#crtbtn1").removeAttr("disabled");
									jQuery("#addtocart").removeClass("is-uploading");
								},
								error: function (data) {
									if (typeof data.responseJSON.description !== "undefined") {
										var message = data.responseJSON.description;
									} else {
										var message = "Please try again later!";
									}
									swal({
										title: "Oops!!",
										text: message,
										icon: "error",
										className: "add-ajax-outofstock",
										buttons: false,
										timer: 1500
									});
									jQuery("#crtbtn1").removeAttr("disabled");
									jQuery("#addtocart").removeClass("is-uploading");
								}
							});
						}
					});
				} else {
					var $this = jQuery('#crtbtn1.easeter_popup_product');
					data_url = $this.attr('data-url');
					jQuery('#easter_popup_overlay_product').fadeIn();
					jQuery('#easter_popup').fadeIn();
					jQuery('body').addClass("is_easterpopup_open");
					jQuery('body').addClass("overflow-hidden");

					var easter_image = $this.attr("data-e-image");
					var discount_code = $this.attr("data-e-dcode");
					var easter_desc = $this.attr("data-e-desc");
					var easter_howto = $this.attr("data-e-redeem");
					var hover_info_text = $this.attr("data-e-info");

					jQuery("#easter_popup .popup_modal .popup-body .popup_code .popup_img img").attr("src", easter_image);
					jQuery("#easter_popup .popup_modal .popup-body .popup_code .popup_code_text p span b").text(discount_code);
					jQuery("#easter_popup .popup_modal .popup-body .popup_code .popup_code_text p.deal span").text(easter_desc);
					jQuery("#easter_popup .popup_modal .popup-body .popup_code .popup_code_text .prod_info h2").text(easter_howto);
					jQuery("#easter_popup .popup_modal .popup-body .popup_code .popup_code_text .prod_info .icon_info .eag-note").text(hover_info_text);
				}
			} else {
				do_console(279);
				debugger;
				do_console(data_to_send);
				jQuery.ajax({
					url: '/cart/add.js',
					method: "POST",
					dataType: "JSON",
					data: data_to_send,
					success: function (data) {
						update_cart_popup();
						if(typeof window.customer_email !== 'undefined') {
							window.liQ = window.liQ || [];
							window.liQ.push({
							"event": "addToCart",
							"email": window.customer_email
							});
						}
						jQuery(".nav-item.nav-shop .badge").show();
						jQuery(".nav-shop-mobile .badge").show();
						jQuery(".nav-item.nav-shop .badge").show();
						jQuery(".nav-shop-mobile .badge").show();
						var valueToUpdate = parseInt(jQuery(".nav-item.nav-shop .badge").text()) +
							totalquantity;
						jQuery(".nav-shop-mobile .badge").text(valueToUpdate.toString());
						jQuery(".nav-item.nav-shop .badge").text(valueToUpdate.toString());
						//swal("", "Product added to the cart", "success");
						// swal( {
						// 	title: "",
						// 	text: "Product added to the cart",
						// 	icon: "success",
						// 	buttons: false,
						// 	timer: 1500
						// } );
						jQuery("#crtbtn1").removeAttr("disabled");
						jQuery("#addtocart").removeClass("is-uploading");
					},
					error: function (data) {
						if (typeof data.responseJSON.description !== "undefined") {
							var message = data.responseJSON.description;
						} else {
							var message = "Please try again later!";
						}
						swal({
							title: "Oops!!",
							text: message,
							icon: "error",
							className: "add-ajax-outofstock",
							buttons: false,
							timer: 1500
						});
						jQuery("#crtbtn1").removeAttr("disabled");
						jQuery("#addtocart").removeClass("is-uploading");
					}
				});
			}
		}
	});
	/* Home page Starts*/
	if (jQuery(".template-index").length > 0) {
		jQuery("[data-home-slide]").fadeIn(100);
		jQuery('.single-slider-auto').slick({
			lazyLoad: 'ondemand',
			slidesToShow: 1,
			slidesToScroll: 1,
			autoplay: true,
			autoplaySpeed: 5000,		
			speed: 1000,
			pauseOnHover:false,
            pauseOnFocus:false,
			dots: true,
			arrow: true,
			prevArrow: '<button type="button" class="arrow-prev"><i class="fal fa-angle-left"></i></button>',
			nextArrow: '<button type="button" class="arrow-next"><i class="fal fa-angle-right"></i></button>',
			responsive: [{
				breakpoint: 550,
				settings: {
					arrows: false
				}
			}]
		});
	}
	/* Home Page ends */
	jQuery.fn.reviewfy = function () {
		var product_id = jQuery(this).attr("data-review-product-id");
		var product_review_details = reviews[product_id];
		if (typeof product_review_details === 'undefined') {
			return false;
		}
		var rating = product_review_details.rating;
		var stringToPut = "";
		for (i = 1; i <= 5; i++) {
			if (rating > 0) {
				if (rating == 0.5) {
					stringToPut += '<i class="fas fa-star-half"></i>';
				} else {
					stringToPut += '<i class="fas fa-star"></i>';
				}
			} else {
				// stringToPut += '<i class="far fa-star"></i>';
			}
			rating = rating - 1;
		}
		if (jQuery(this).hasClass('has-count')) {
			stringToPut += '<span class="rating-count">' + product_review_details.totalreviews +
				' Reviews</span>';
		}
		jQuery(this).html(stringToPut);
		return true;
	};

	function create_review_markup_reviews_page(rating, rating_name, rating_date,
		rating_date_preformatted, total_review_count, rating_content) {
		var return_string = "";
		return_string =
			'<div class="review-item" itemscope itemtype="http://data-vocabulary.org/Review-aggregate">\
            <meta itemprop="rating" content="' +
			rating + '" />\
            <meta itemprop="count" content="' +
			total_review_count +
			'" />\
            <div class="user col-lg-6">\
                <i class="far fa-smile t-color"></i>\
                <div class="rating">';
		for (i = 1; i <= 5; i++) {
			if (rating > 0) {
				if (rating == 0.5) {
					return_string += '<i class="fas fa-star-half"></i>';
				} else {
					return_string += '<i class="fas fa-star"></i>';
				}
			} else { }
			rating = rating - 1;
		}
		return_string +=
			'</div>\
                <p>Reviewed<br/> on \
                <time itemprop="dtreviewed" datetime="' +
			rating_date_preformatted + '">' + rating_date +
			'</time>\
                <br/> by <b><span itemprop="itemreviewed">' +
			rating_name +
			'</span></b></p>\
            </div>\
            <div class="content col-lg-6">\
                <p>' +
			rating_content + '</p>\
            </div>\
        </div>';
		return return_string;
	}

	function create_review_markup(rating, rating_name, rating_date,
		rating_date_preformatted, total_review_count, rating_content) {
		var return_string = "";
		return_string +=
			'<div class="review-item" \
        itemscope="" itemtype="http://data-vocabulary.org/Review-aggregate">\
        <meta itemprop="rating" content="' +
			rating + '">\
        <meta itemprop="count" content="' +
			total_review_count +
			'">\
        <div class="user col-lg-6">\
          <i class="far fa-smile t-color"></i>\
          <div class="rating">';
		for (i = 1; i <= 5; i++) {
			if (rating > 0) {
				if (rating == 0.5) {
					return_string += '<i class="fas fa-star-half"></i>';
				} else {
					return_string += '<i class="fas fa-star"></i>';
				}
			} else { }
			rating = rating - 1;
		}
		return_string +=
			'</div>\
                <p>Reviewed<br> on \
                <time itemprop="dtreviewed" datetime="' +
			rating_date_preformatted + '">\
                ' + rating_date +
			'</time><br> by <b>\
                <span itemprop="itemreviewed">' +
			rating_name +
			'</span></b></p>\
            </div>\
            <div class="content col-lg-6">\
            <p>' +
			rating_content + '</p>\
            </div>\
        </div>';
		return return_string;
	}

	function show_spinner() {
		jQuery("#loadingspinner").fadeIn(100);
	}

	function hide_spinner() {
		jQuery("#loadingspinner").fadeOut(100);
	}
	jQuery("[data-review-product-id]").each(function (ix, em) {
		jQuery(em).reviewfy();
	});

	function update_reviews_on_dom(show_loader) {
		if (show_loader == true) {
			show_spinner();
		}
		var product_id_for_reviews = jQuery("#review-filter-product").val();
		jQuery("#ProductID").val(product_id_for_reviews);
		var ajax_url = app_url + "/reviews/index/" + product_id_for_reviews +
			"?limit=9&ajax=true&page=1";
		jQuery.ajax({
			url: ajax_url,
			method: "GET",
			type: "JSON",
			success: function (data) {
				var content_for_reviews = "";
				var reviews_ajax = data[product_id_for_reviews];
				jQuery(reviews_ajax.reviews).each(function (ix, em) {
					content_for_reviews += create_review_markup_reviews_page(em.rating,
						em.by, em.date, em.date_time, data.totalreviews, em.text);
				});
				jQuery("[data-page-reviews]").html(content_for_reviews);
				if (show_loader == true) {
					hide_spinner();
				}
				jQuery("[data-page-reviews]").attr('data-page-reviews-current-page', 1);
			}
		});
	}
	/* Reviews page on DOM ready*/
	if (jQuery("[data-page-reviews]").length > 0) {
		//Just to load when the DOM is ready
		update_reviews_on_dom(false);
		jQuery(document).on('change', '#review-filter-product', function (e) {
			var product_id_for_reviews = jQuery("#review-filter-product").val();
			jQuery("#ProductID").val(product_id_for_reviews);
		});
		jQuery(document).on('click', '[data-reviews-load-more]', function (e) {
			e.preventDefault();
			var current_reviews_page = parseInt(jQuery("[data-page-reviews]").attr(
				'data-page-reviews-current-page'));
			var page_to_call = current_reviews_page;
			var reviews_per_page = 3;
			if (current_reviews_page == 1) {
				//We make call for page 4 with count 3
				page_to_call = 4;
			} else {
				//We make call for current-page + 1 with count 3
				page_to_call = current_reviews_page + 1;
			}
			var product_id_for_reviews = jQuery("#review-filter-product").val();
			var ajax_url = app_url + "/reviews/index/" + product_id_for_reviews +
				"?limit=" + reviews_per_page + "&ajax=true&page=" + page_to_call;
			show_spinner();
			jQuery.ajax({
				url: ajax_url,
				method: "GET",
				type: "JSON",
				success: function (data) {
					var content_for_reviews = "";
					var reviews_ajax = data[product_id_for_reviews];
					jQuery(reviews_ajax.reviews).each(function (ix, em) {
						content_for_reviews += create_review_markup_reviews_page(em.rating,
							em.by, em.date, em.date_time, data.totalreviews, em.text);
					});
					jQuery("[data-page-reviews]").append(content_for_reviews);
					jQuery("[data-page-reviews]").attr('data-page-reviews-current-page',
						page_to_call);
					hide_spinner();
				},
				error: function (data) {
					hide_spinner();
				}
			});
		});
		jQuery(document).on('click', '[data-reviews-filter-button]', function (e) {
			e.preventDefault();
			//To load when Filter Reviews button is clicked
			update_reviews_on_dom(true);
		});
	}
	/* Lifestyle Blog Page */
	if (jQuery("[data-loadblogs]").length > 0) {
		jQuery(document).on('click', '[data-loadblogs]', function (e) {
			e.preventDefault();
			var $this = e.target;
			var total_blog_count = jQuery("[data-total-blog-count]").attr(
				'data-total-blog-count');
			var page_to_call = parseInt(jQuery($this).attr(
				'data-loadblogs-current-page')) + 1;
			var url_to_call = jQuery($this).attr('data-loadblogs-url') + '/?page=' +
				page_to_call;
			show_spinner();
			jQuery.ajax({
				url: url_to_call,
				method: "GET",
				dataType: "html",
				success: function (data) {
					var markup_data = data;
					jQuery(markup_data).find(".forajax .blog_single_landing").each(
						function (ix, em) {
							jQuery(em).insertAfter("#blogcont .blog_single_landing:last");
						});
					jQuery($this).attr('data-loadblogs-current-page', page_to_call);
					var current_blog_count = jQuery("#blogcont").find(
						".blog_single_landing").length;
					if (current_blog_count == total_blog_count) {
						jQuery("[data-loadblogs]").fadeOut(10);
					}
					hide_spinner();
				},
				error: function (error) {
					hide_spinner();
				}
			});
			/* jQuery.ajax ends */
		});
	}
	/* Lifestyle Blog Page ends */
	/* Press page Podcast Blog  */
	if (jQuery("[data-loadpodcastblogs]").length > 0) {
		jQuery(document).on('click', '[data-loadpodcastblogs]', function (e) {
			e.preventDefault();
			var $this = e.target;
			var total_blog_count = jQuery("[data-total-podcastblog-count]").attr(
				'data-total-podcastblog-count');
			var page_to_call = parseInt(jQuery($this).attr(
				'data-loadpodcastblogs-current-page')) + 1;
			var url_to_call = jQuery($this).attr('data-loadpodcastblogs-url') +
				'/?page=' + page_to_call;
			show_spinner();
			jQuery.ajax({
				url: url_to_call,
				method: "GET",
				dataType: "html",
				success: function (data) {
					var markup_data = data;
					jQuery(markup_data).find(".forajax_new .blog_single_landing").each(
						function (ix, em) {
							jQuery(em).insertAfter("#blog_cont .blog_single_landing:last");
						});
					jQuery($this).attr('data-loadpodcastblogs-current-page', page_to_call);
					var current_blog_count = jQuery("#blog_cont").find(
						".blog_single_landing").length;
					if (current_blog_count == total_blog_count) {
						jQuery("[data-loadpodcastblogs]").fadeOut(10);
					}
					hide_spinner();
				},
				error: function (error) {
					hide_spinner();
				}
			});
			/* jQuery.ajax ends */
		});
	}
	/*  Press page Podcast Blog ends */
	/* Product Page Review section */
	if (jQuery("[data-review-pagination]").length > 0) {
		var first_reviews_set = reviews_single[current_product_id];
		if (typeof first_reviews_set === 'undefined') { } else {
			var content_for_reviews = "";
			jQuery(first_reviews_set.reviews).each(function (ix, em) {
				content_for_reviews += create_review_markup(em.rating, em.by, em.date,
					em.date_time, first_reviews_set.totalreviews, em.text);
			});
			jQuery("[data-review-pagination]").find('#reviews-cont').html(
				content_for_reviews);
			var reviews_pagination = "";
			if (first_reviews_set.pagelength > 1) {
				reviews_pagination += '<div class="pagination" id="rev-pag"><ul>';
				for (i = 1; i <= first_reviews_set.pagelength; i++) {
					if (i > 5) {
						continue;
					}
					if (i == 1) {
						reviews_pagination +=
							'<li class="active"><a href="#" data-review-pagination-number="' + i +
							'" >' + i + '</a>';
					} else {
						reviews_pagination += '<li><a href="#" data-review-pagination-number="' +
							i + '" >' + i + '</a>';
					}
				}
				reviews_pagination += "</ul></div>";
				jQuery(".reviews-cta .reviews-pagination").html(reviews_pagination);
			}
		}
		jQuery(document).on("click", "[data-review-pagination-number]", function (e) {
			e.preventDefault();
			var $this = e.target;
			var page_number = parseInt(jQuery($this).attr(
				'data-review-pagination-number'));
			var ajax_url = app_url + "/reviews/index/" + current_product_id +
				"?limit=3&ajax=true&page=" + page_number;
			show_spinner();
			jQuery.ajax({
				url: ajax_url,
				method: "GET",
				type: "JSON",
				success: function (data) {
					var content_for_reviews = "";
					jQuery(data[current_product_id].reviews).each(function (ix, em) {
						content_for_reviews += create_review_markup(em.rating, em.by,
							em.date, em.date_time, first_reviews_set.totalreviews, em.text
						);
					});
					jQuery("[data-review-pagination]").find('#reviews-cont').html(
						content_for_reviews);
					var reviews_pagination = "";
					if (data[current_product_id].pagelength > 1) {
						reviews_pagination += '<div class="pagination" id="rev-pag"><ul>';
						if (page_number < 4) {
							for (i = 1; i <= data[current_product_id].pagelength; i++) {
								if (i > 5) {
									continue;
								}
								if (i == page_number) {
									reviews_pagination +=
										'<li class="active">\
                                    <a href="#" data-review-pagination-number="' +
										i + '" >' + i + '</a>';
								} else {
									reviews_pagination +=
										'<li>\
                                    <a href="#" data-review-pagination-number="' +
										i + '" >' + i + '</a>';
								}
							}
						} else if ((page_number + 2) <= data[current_product_id].pagelength) {
							for (i = (page_number - 2); i <= (page_number + 2); i++) {
								if (i == page_number) {
									reviews_pagination +=
										'<li class="active">\
                                    <a href="#" data-review-pagination-number="' +
										i + '" >' + i + '</a>';
								} else {
									reviews_pagination +=
										'<li>\
                                    <a href="#" data-review-pagination-number="' +
										i + '" >' + i + '</a>';
								}
							}
						} else {
							for (i = (data[current_product_id].pagelength - 4); i <=
								data[current_product_id].pagelength; i++) {
								if (i == page_number) {
									reviews_pagination +=
										'<li class="active">\
                                    <a href="#" data-review-pagination-number="' +
										i + '" >' + i + '</a>';
								} else {
									reviews_pagination +=
										'<li>\
                                    <a href="#" data-review-pagination-number="' +
										i + '" >' + i + '</a>';
								}
							}
						}
						reviews_pagination += "</ul></div>";
						jQuery(".reviews-cta .reviews-pagination").html(reviews_pagination);
					}
					hide_spinner();
				},
				error: function (data) {
					hide_spinner();
				}
			});
		});
	}
	/* if (jQuery("[data-review-pagination]").length > 0) { ends */
	/* Store Locator JS starts */
	if (jQuery('[data-store-locators]').length > 0) {
		var country_options = "";
		country_options += "<option value='-1'>ALL COUNTRIES</option>";
		for (key in store_locators) {
			if (key == "United States") {
				country_options += "<option selected='selected' value='" + key + "'>" +
					key + "</option>";
			} else {
				country_options += "<option value='" + key + "'>" + key + "</option>";
			}
		}
		jQuery("#SCountry").html(country_options);
		var select_SCountry = jQuery('#SCountry');
		select_SCountry.html(select_SCountry.find('option').sort(function (x, y) {
			return jQuery(x).text() > jQuery(y).text() ? 1 : -1;
		}));
		jQuery("#SCountry").val("United States");
		var us_states = Array();
		var stores = "";
		jQuery(store_locators['United States']).each(function (ix, em) {
			if (us_states.indexOf(em.state) === -1) {
				us_states.push(em.state);
			}
			if (em.state === "FL") {
				stores += '<div class="col-6"> \
                            <h2>' + em
						.store_name + '</h2>\
                            <p>' + em.store_details +
					'</p>\
                        </div>';
			}
		});
		jQuery("#wlocations .row").html(stores);
		var state_options = "";
		state_options += "<option value='FL' selected='selected'>State</option>";
		jQuery(us_states).each(function (ix, em) {
			state_options += "<option value='" + em + "'>" + em + "</option>";
		});
		jQuery("#SState").html(state_options);
		var select_SState = jQuery('#SState');
		select_SState.html(select_SState.find('option').sort(function (x, y) {
			return jQuery(x).text() > jQuery(y).text() ? 1 : -1;
		}));
		jQuery("#SState option[selected='selected']").detach().prependTo('#SState');
		jQuery("#SState").val("FL");
		jQuery(document).on("change", "#SCountry", function (e) {
			var current_selected_country = jQuery("#SCountry").val();
			if (current_selected_country == "United States") {
				jQuery("#SState").fadeIn(50);
			} else {
				jQuery("#SState").fadeOut(50);
			}
		});
		jQuery(document).on('click', "[data-store-locators-search-button]", function (
			e) {
			show_spinner();
			e.preventDefault();
			var stores = "";
			//Clear Markers array
			markers = [];
			//Clear Clustere's Markers
			markerCluster.clearMarkers();
			//For Bounds
			var bounds = new google.maps.LatLngBounds();
			var current_selected_country = jQuery("#SCountry").val();
			if (current_selected_country == -1) {
				jQuery("[data-store-locators-current-country]").html("All Stores");
			} else {
				jQuery("[data-store-locators-current-country]").html(
					current_selected_country);
			}
			if (current_selected_country == "United States") {
				var state_value = jQuery("#SState").val();
				jQuery(store_locators['United States']).each(function (ix, em) {
					if (em.state === state_value) {
						stores +=
							'<div class="col-6"> \
                                        <h2>' +
							em.store_name +
							'</h2>\
                                        <p>' + em.store_details +
							'</p>\
                                    </div>';
						var marker = new google.maps.Marker({
							position: new google.maps.LatLng(em.lat, em.lng)
						});
						var infoWin = new google.maps.InfoWindow();
						google.maps.event.addListener(marker, 'click', function (evt) {
							infoWin.setContent(em.marker_store_details);
							infoWin.open(map, marker);
						})
						var bound = new google.maps.LatLng(em.lat, em.lng);
						bounds.extend(bound);
						markers.push(marker);
					}
				});
			} else if (current_selected_country == -1) {
				var state_value = "FL"
				jQuery(store_locators['United States']).each(function (ix, em) {
					//WHEN ALL COUNTRIES SELECTED
					//SHOW STORES FROM US/FL
					if (em.state === state_value) {
						stores +=
							'<div class="col-6"> \
                                        <h2>' +
							em.store_name +
							'</h2>\
                                        <p>' + em.store_details +
							'</p>\
                                    </div>';
					}
				});
				for (country in store_locators) {
					jQuery(store_locators[country]).each(function (ix, em) {
						var marker = new google.maps.Marker({
							position: new google.maps.LatLng(em.lat, em.lng)
						});
						var infoWin = new google.maps.InfoWindow();
						google.maps.event.addListener(marker, 'click', function (evt) {
							infoWin.setContent(em.marker_store_details);
							infoWin.open(map, marker);
						})
						var bound = new google.maps.LatLng(em.lat, em.lng);
						bounds.extend(bound);
						markers.push(marker);
					});
				}
			} else {
				jQuery(store_locators[current_selected_country]).each(function (ix, em) {
					stores +=
						'<div class="col-6"> \
                                    <h2>' +
						em.store_name + '</h2>\
                                    <p>' +
						em.store_details + '</p>\
                                </div>';
					var marker = new google.maps.Marker({
						position: new google.maps.LatLng(em.lat, em.lng)
					});
					var infoWin = new google.maps.InfoWindow();
					google.maps.event.addListener(marker, 'click', function (evt) {
						infoWin.setContent(em.marker_store_details);
						infoWin.open(map, marker);
					})
					var bound = new google.maps.LatLng(em.lat, em.lng);
					bounds.extend(bound);
					markers.push(marker);
				});
			}
			jQuery("#wlocations .row").html(stores);
			markerCluster.addMarkers(markers, false);
			markerCluster.getMap().fitBounds(bounds);
			if (markers.length == 1) {
				markerCluster.getMap().setZoom(14);
			}
			hide_spinner();
		});
	}
	/* Locators Page ends */
	/* FAQs Page begins */
	if (jQuery("[data-faq-accordion-list]").length > 0) {
		var list_markup = "";
		var counter = 0;
		var first_faq_cat = "";
		for (key in faqs) {
			if (counter == 0) {
				first_faq_cat = key;
			}
			list_markup += '<li><a data-faq-list-li data-faq-listname="' + key +
				'" href="#">\
            ' + key + '\
            </a></li>';
			counter++;
		}
		jQuery("[data-faq-accordion-list]").html(list_markup);
		var accordion_content = "";
		counter = 1;
		faqs[first_faq_cat].forEach(function (em, ix) {
			accordion_content +=
				'<div class="card">\
                                    <div class="card-header" id="heading' +
				counter +
				'">\
                                        <h5 class="mb-0">\
                                            <button class="collapsed" data-target="#collapse' +
				counter +
				'" data-toggle="collapse" >\
                                            ' +
				em.question +
				'\
                                            </button>\
                                        </h5>\
                                    </div>\
                                    <div class="collapse" data-parent="#accordion-faqs" id="collapse' +
				counter +
				'">\
                                        <div class="card-body">\
                                        ' +
				em.answer +
				'\
                                        </div>\
                                    </div>\
                                </div>';
			counter++;
		});
		jQuery("[data-faq-accordion-content]").html(accordion_content);
		jQuery(document).on('click', "[data-faq-list-li]", function (e) {
			show_spinner();
			e.preventDefault();
			var $this = e.target;
			var faq_cat_name = jQuery($this).attr('data-faq-listname');
			var accordion_content = "";
			counter = 1;
			faqs[faq_cat_name].forEach(function (em, ix) {
				accordion_content +=
					'<div class="card">\
                                        <div class="card-header" id="heading' +
					counter +
					'">\
                                            <h5 class="mb-0">\
                                                <button class="collapsed" data-target="#collapse' +
					counter +
					'" data-toggle="collapse" >\
                                                ' +
					em.question +
					'\
                                                </button>\
                                            </h5>\
                                        </div>\
                                        <div class="collapse" data-parent="#accordion-faqs" id="collapse' +
					counter +
					'">\
                                            <div class="card-body">\
                                            ' +
					em.answer +
					'\
                                            </div>\
                                        </div>\
                                    </div>';
				counter++;
			});
			jQuery("[data-faq-accordion-content]").html(accordion_content);
			hide_spinner();
		});
	}
	/* FAQs Page Ends */
	/* Retail partners Page */
	jQuery(document).on('click', '[data-retail-partners-form-open]', function (e) {
		e.preventDefault();
		jQuery("[data-retail-partners-form]").slideDown(400);
	});
	/* Retail partners Page Ends*/
	/* Single Product Page */
	if (jQuery("[data-featured-ingredients-block]").length > 0) {
		var featured_ingredients_markup = "";
		var prod_title = "";
		jQuery( featured_ingredients ).each( function( ix, em ) {
			var img_url = app_uploads_url + em.image;
			var ingredient_name = em.name;
			var ingredient_info = em.description;
           
            prod_title += '<div class="col-6 col-sm-6 ing-block">\
								<div class="image">\
								<img src="' + img_url + '" data-src="' + img_url +'">\
								<h5 class="mobile_title">' + ingredient_name + '</h5>\
								</div>\
								<div class="ingre_wrapper">\
								<h5>' + ingredient_name +'</h5>';
            if(typeof ingredient_info !== 'undefined'){
               prod_title += '<div class="ing_info"><p>' + ingredient_info +'</p></div>';
            }
            prod_title += '</div></div>';            
		
		} );
		jQuery("[data-featured-ingredients-row]").html(prod_title);
	}

	

	if (jQuery("[data-product-page-quantity]").length > 0) {
		jQuery(document).on('change', '#item_Quantity', function (e) {
			/*
			if ( parseInt( jQuery( "#item_Quantity" ).val() ) > 1 || parseInt( jQuery(
					"#item_Quantity" ).val() ) < 3 ) {
				jQuery( "[data-type='minus']" ).removeAttr( 'disabled' );
				jQuery( "[data-type='plus']" ).removeAttr( 'disabled' );
			} else {
				jQuery( "[data-type='minus']" ).attr( 'disabled', 'disabled' );
				jQuery( "[data-type='plus']" ).removeAttr( 'disabled' );
			}
			*/
		});
		jQuery(document).on('change', '#quantitym', function (e) {
			var $this = e.target;
			jQuery("input[name='quantity']").val(jQuery($this).val());
		});
	}

jQuery(document).on('click', "[data-type='minus']", function (e) {
		do_console(1058);
		e.preventDefault();
		var current_val = jQuery(e.target).parents('.input-group').eq(0).find('[name="quantity"]').val();
		var update_val = parseInt(current_val) - 1;
		if (update_val < 1) {
			jQuery(e.target).parents('.input-group').eq(0).find('[name="quantity"]').val(1);
		} else {
			jQuery(e.target).parents('.input-group').eq(0).find('[name="quantity"]').val(update_val);
		}
		jQuery(e.target).parents('.input-group').eq(0).find('[name="quantity"]').trigger('change');
	});

	jQuery(document).on('click', "[data-type='plus']", function (e) {
		do_console(1070);
    e.preventDefault();
		var current_val = jQuery(e.target).parents('.input-group').eq(0).find('[name="quantity"]').val();
		var update_val = parseInt(current_val) + 1;
		if (update_val > 8) {
			jQuery(e.target).parents('.input-group').eq(0).find('[name="quantity"]').val(3);
		} else {
			jQuery(e.target).parents('.input-group').eq(0).find('[name="quantity"]').val(update_val);
		}
		jQuery(e.target).parents('.input-group').eq(0).find('[name="quantity"]').trigger('change');
	});




	if (jQuery("[data-single-product-faqs]").length > 0) {
		var single_product_faq_markup = "";
		var count = 1;
		jQuery(single_product_faqs).each(function (ix, em) {
			single_product_faq_markup +=
				'<div class="col-lg-6">\
            <div class="faqs-header" id="faqsH' +
				count +
				'">\
              <h5 class="mb-0">\
                <button class="btn" \
                data-toggle="collapse" \
                data-target="#faqs' +
				count +
				'" aria-expanded="true" aria-controls="faqs' +
				count +
				'">\
                  ' +
				em.question +
				'\
                  <i class="far fa-plus-circle"></i>\
                </button>\
              </h5>\
            </div>\
            <div id="faqs' +
				count +
				'" class="collapse show" aria-labelledby="faqsH' +
				count +
				'" data-parent="#accordion">\
              <div class="faqs-body">\
              ' +
				em.answer +
				'\
              </div>\
            </div>\
          </div>';
			count++;
		});
		jQuery("[data-single-product-faqs]").html(single_product_faq_markup);
	}
	// WHEN COLOR & SIZE BOTH OPTIONS ARE PRESENT
	if (jQuery("[data-product-size-color]").length > 0 || jQuery(
		"[data-product-size-color-flavor]").length > 0) {
		jQuery(document).on('change',
			'[data-add-to-cart] [name="color"],[data-add-to-cart] [name="size"],[data-add-to-cart] [name="flavor"]',
			function (e) {
				var selected_size = jQuery('[data-add-to-cart] [name="size"]:checked').val();
				var selected_color = jQuery('[data-add-to-cart] [name="color"]:checked').val();
				var is_flavor_option_present = false;
				if (jQuery("[data-product-size-color-flavor]").length > 0) {
					is_flavor_option_present = true;
				}
				var selected_flavor = "";
				if (is_flavor_option_present) {
					selected_flavor = jQuery('[data-add-to-cart] [name="flavor"]:checked').val();
				}
				jQuery(".form-check").removeAttr('disabled');
				jQuery(".form-check input").removeAttr('disabled');
				if (is_flavor_option_present) {

					if (selected_size) {
						jQuery("[data-variants] option:disabled[data-size-display='" +
							selected_size + "'][data-flavor-display='" + selected_flavor + "']")
							.each(function (ix, em) {
								var $this = jQuery(em);
								var color = jQuery($this).attr('data-color');
								jQuery("#color-" + color).attr('disabled', 'disabled');
								jQuery("#color-" + color).find('input').attr('disabled', 'disabled');
							});
						jQuery(".color-group .form-check:not([disabled])").each(function (ix, em) {
							var current_color = jQuery(em).find('.form-check-input').val();
							if (jQuery("[data-variant-select] option[data-size-display='" +
								selected_size + "'][data-color-display='" + current_color +
								"'][data-flavor-display='" + selected_flavor + "']").length == 0) {
								jQuery(em).attr('disabled', 'disabled');
								jQuery(em).find('input').attr('disabled', 'disabled');
							}
						});
						jQuery("[data-variants] option:disabled[data-color-display='" +
							selected_color + "'][data-flavor-display='" + selected_flavor + "']")
							.each(function (ix, em) {
								var $this = jQuery(em);
								var size = jQuery($this).attr('data-size');
								jQuery("#size-" + size).attr('disabled', 'disabled');
								jQuery("#size-" + size).find('input').attr('disabled', 'disabled');
							});
						jQuery(".size-group-new .form-check:not([disabled])").each(function (ix,
							em) {
							var current_size = jQuery(em).find('.form-check-input').val();
							if (jQuery("[data-variant-select] option[data-size-display='" +
								current_size + "'][data-color-display='" + selected_color +
								"'][data-flavor-display='" + selected_flavor + "']").length == 0) {
								jQuery(em).attr('disabled', 'disabled');
								jQuery(em).find('input').attr('disabled', 'disabled');
							}
						});
						jQuery("[data-variants] option:disabled[data-color-display='" +
							selected_color + "'][data-size-display='" + selected_size + "']").each(
								function (ix, em) {
									var $this = jQuery(em);
									var flavor = jQuery($this).attr('data-flavor');
									jQuery("#flavor-" + flavor).attr('disabled', 'disabled');
									jQuery("#flavor-" + flavor).find('input').attr('disabled',
										'disabled');
								});
						jQuery(".flavor-group-new .form-check:not([disabled])").each(function (ix,
							em) {
							var current_flavor = jQuery(em).find('.form-check-input').val();
							if (jQuery("[data-variant-select] option[data-size-display='" +
								selected_size + "'][data-color-display='" + selected_color +
								"'][data-flavor-display='" + current_flavor + "']").length == 0) {
								jQuery(em).attr('disabled', 'disabled');
								jQuery(em).find('input').attr('disabled', 'disabled');
							}
						});
					} else {
						jQuery("[data-variants] option:disabled[data-flavor-display='" +
							selected_flavor + "']").each(function (ix, em) {
								var $this = jQuery(em);
								var color = jQuery($this).attr('data-color');
								jQuery("#color-" + color).attr('disabled', 'disabled');
								jQuery("#color-" + color).find('input').attr('disabled', 'disabled');
							});
						jQuery(".color-group .form-check:not([disabled])").each(function (ix, em) {
							var current_color = jQuery(em).find('.form-check-input').val();
							if (jQuery("[data-variant-select] option[data-flavor-display='" +
								selected_flavor + "'][data-color-display='" + current_color + "']")
								.length == 0) {

								jQuery(em).attr('disabled', 'disabled');
								jQuery(em).find('input').attr('disabled', 'disabled');
							}
						});
						jQuery("[data-variants] option:disabled[data-color-display='" +
							selected_color + "']").each(function (ix, em) {
								var $this = jQuery(em);
								var size = jQuery($this).attr('data-flavor');
								jQuery("#flavor-" + size).attr('disabled', 'disabled');
								jQuery("#flavor-" + size).find('input').attr('disabled', 'disabled');
							});
						jQuery(".flavor-group-new .form-check:not([disabled])").each(function (ix,
							em) {
							var current_size = jQuery(em).find('.form-check-input').val();
							if (jQuery("[data-variant-select] option[data-flavor-display='" +
								current_size + "'][data-color-display='" + selected_color + "']")
								.length == 0) {
								jQuery(em).attr('disabled', 'disabled');
								jQuery(em).find('input').attr('disabled', 'disabled');
							}
						});
					}
				} else {
					jQuery("[data-variants] option:disabled[data-size-display='" +
						selected_size + "']").each(function (ix, em) {
							var $this = jQuery(em);
							var color = jQuery($this).attr('data-color');
							jQuery("#color-" + color).attr('disabled', 'disabled');
							jQuery("#color-" + color).find('input').attr('disabled', 'disabled');
						});
					jQuery(".color-group .form-check:not([disabled])").each(function (ix, em) {
						var current_color = jQuery(em).find('.form-check-input').val();
						if (jQuery("[data-variant-select] option[data-size-display='" +
							selected_size + "'][data-color-display='" + current_color + "']")
							.length == 0) {
							//do_console("[data-variant-select] option[data-size-display='"+selected_size+"'][data-color-display='"+current_color+"']" + " Unavailable");
							jQuery(em).attr('disabled', 'disabled');
							jQuery(em).find('input').attr('disabled', 'disabled');
						}
					});
					jQuery("[data-variants] option:disabled[data-color-display='" +
						selected_color + "']").each(function (ix, em) {
							var $this = jQuery(em);
							var size = jQuery($this).attr('data-size');
							jQuery("#size-" + size).attr('disabled', 'disabled');
							jQuery("#size-" + size).find('input').attr('disabled', 'disabled');
						});
					jQuery(".size-group-new .form-check:not([disabled])").each(function (ix,
						em) {
						var current_size = jQuery(em).find('.form-check-input').val();
						if (jQuery("[data-variant-select] option[data-size-display='" +
							current_size + "'][data-color-display='" + selected_color + "']")
							.length == 0) {
							jQuery(em).attr('disabled', 'disabled');
							jQuery(em).find('input').attr('disabled', 'disabled');
						}
					});
				}
				var selected_variant_title = selected_size + " / " + selected_color;
				if (is_flavor_option_present) {
					if (selected_size) {
						selected_variant_title += " / " + selected_flavor;
					}
					else {
						var selected_variant_title = selected_color;
						selected_variant_title += " / " + selected_flavor;
					}
				}
				jQuery("[data-variant-select]").find('option').each(function (ix, em) {
					var loop_variant_text = jQuery(em).html().trim();
					debugger;
					if (selected_variant_title.trim() == loop_variant_text) {
						var selected_variant_id = jQuery(em).attr('value');
						jQuery("[data-variant-select]").val(selected_variant_id);
						debugger;
						jQuery(em).prop('selected', true);
						jQuery("[data-variant-select]").trigger('change');
						if (jQuery(em).attr('disabled') == 'disabled') {
							jQuery("#text-color").text("Not available.");
						} else {
							jQuery("#text-color").text(selected_variant_title);
						}
						return;
					}
				});
			});
		jQuery(document).on('change', '[data-variant-select]', function (e) {
			var em = jQuery('[data-variant-select] option:selected');
			//var product_id = jQuery( em ).val();
			var show_selected_image = jQuery(em).attr('data-variant-image');
			var show_selected_image_srcset = jQuery(em).attr('data-variant-srcset');

			var price_to_update = jQuery(em).attr('data-price');
			jQuery("#proprice").html(price_to_update);
			jQuery("#proprice2").html(price_to_update);

			//jQuery( "[name='id']" ).val( product_id );
			var product_id = '';
			if (jQuery('.subscription_value.product_add .subscription-freq').length) {
				jQuery(".subscription_value.product_add .subscription-freq option:selected").each(function (ix, ex) {
					var sub_val = jQuery(ex).val();
					if (sub_val == 'subscribe-save') {
						//product_id = jQuery(em).attr('data-subs-id');
						product_id = jQuery(em).val();
						jQuery(".hidden_input_value").val(product_id);

					} else {
						product_id = jQuery(em).val();
						jQuery(".hidden_input_value").val(product_id);
						jQuery(".hidden_input_value").attr('data-single-product', product_id);
					}
				});
			} else {
				product_id = jQuery(em).val();
				jQuery(".hidden_input_value").val(product_id);
				jQuery(".hidden_input_value").attr('data-single-product', product_id);
			}
			product_id_onetime = jQuery(em).val();
			jQuery(".hidden_input_value").attr('data-single-product', product_id_onetime);
			update_rechargeprice(product_id);
			if (is_DOM_Ready == true) {
				jQuery("#product-content-slider0").slick('slickGoTo', 0);
				jQuery("#product-content-slider0 .slick-active").find('img').attr('src',
					show_selected_image);
				jQuery("#product-content-slider0 .slick-active").find('img').attr(
					'srcset', show_selected_image_srcset);
			}
			window.history.replaceState(null, null, "?variant=" + product_id);
		});
		var em = jQuery('[data-variant-select] option:selected');
		var show_selected_image = jQuery(em).attr('data-variant-image');
		var show_selected_image_srcset = jQuery(em).attr('data-variant-srcset');
		jQuery("#product-content-slider0").slick('slickGoTo', 0);
		jQuery("#product-content-slider0 .slick-active").find('img').attr('src',
			show_selected_image);
		jQuery("#product-content-slider0 .slick-active").find('img').attr('srcset',
			show_selected_image_srcset);
		var default_selected_size = jQuery(em).attr('data-size')
		jQuery("[data-variants] option:disabled[data-size='" + default_selected_size +
			"']").each(function (ix, em) {
				var $this = jQuery(em);
				var color = jQuery($this).attr('data-color');
				jQuery("#color-" + color).attr('disabled', 'disabled');
				jQuery("#color-" + color).find('input').attr('disabled', 'disabled');
			});
		jQuery('[data-add-to-cart] [name="color"]').trigger('change');
	}
	// WHEN SIZE & SIGN BOTH OPTIONS ARE PRESENT
	if (jQuery("[data-product-size-sign]").length > 0) {
		jQuery('[data-select-sign]').selectric();
		jQuery(document).on('change',
			'[data-add-to-cart] [name="sign"],[data-add-to-cart] [name="size"]',
			function (e) {
				var selected_size = jQuery('[data-add-to-cart] [name="size"]:checked').val();
				var selected_color = jQuery('[data-add-to-cart] [name="sign"]').val();
				jQuery(".form-check").removeAttr('disabled');
				jQuery(".form-check input").removeAttr('disabled');
				jQuery("[data-select-sign] option").removeAttr('disabled');
				jQuery("[data-variants] option:disabled[data-size-display='" + selected_size +
					"']").each(function (ix, em) {
						var $this = jQuery(em);
						var color = jQuery($this).attr('data-sign');
						jQuery("#sign-" + color).attr('disabled', 'disabled');
						jQuery("#sign-" + color).find('input').attr('disabled', 'disabled');
					});
				jQuery("[data-sign-group] option:not([disabled])").each(function (ix, em) {
					var current_sign = jQuery(em).text().trim();
					if (jQuery("[data-variant-select] option[data-size-display='" +
						selected_size + "'][data-sign-display='" + current_sign + "']").length ==
						0) {
						jQuery(em).attr('disabled', 'disabled');
					}
				});
				jQuery("[data-variants] option:disabled[data-sign-display='" +
					selected_color + "']").each(function (ix, em) {
						var $this = jQuery(em);
						var size = jQuery($this).attr('data-size');
						jQuery("#size-" + size).attr('disabled', 'disabled');
						jQuery("#size-" + size).find('input').attr('disabled', 'disabled');
					});
				jQuery("[data-size-group] .form-check:not([disabled])").each(function (ix,
					em) {
					var current_size = jQuery(em).find('.form-check-input').val();
					if (jQuery("[data-variant-select] option[data-size-display='" +
						current_size + "'][data-sign-display='" + selected_color + "']").length ==
						0) {
						jQuery(em).attr('disabled', 'disabled');
						jQuery(em).find('input').attr('disabled', 'disabled');
					}
				});
				jQuery('[data-select-sign]').data('selectric').refresh();
				var selected_variant_title = selected_size + " / " + selected_color;
				jQuery("[data-variant-select]").find('option').each(function (ix, em) {
					var loop_variant_text = jQuery(em).html().trim();
					debugger;
					if (selected_variant_title.trim() == loop_variant_text) {
						var selected_variant_id = jQuery(em).attr('value');
						jQuery("[data-variant-select]").val(selected_variant_id);
						jQuery(em).prop('selected', true);
						jQuery("[data-variant-select]").trigger('change');
						if (jQuery(em).attr('disabled') == 'disabled') {
							jQuery("#text-color").text("Not available.");
						} else {
							jQuery("#text-color").text(selected_variant_title);
						}
						return;
					}
				});
			});
		jQuery(document).on('change', '[data-variant-select]', function (e) {
			var em = jQuery('[data-variant-select] option:selected');
			//var product_id = jQuery( em ).val();
			var show_selected_image = jQuery(em).attr('data-variant-image');
			var show_selected_image_srcset = jQuery(em).attr('data-variant-srcset');
			var price_to_update = jQuery(em).attr('data-price');
			jQuery("#proprice").html(price_to_update);
			jQuery("#proprice2").html(price_to_update);
			//jQuery( "[name='id']" ).val( product_id );
			var product_id = '';
			if (jQuery('.subscription_value.product_add .subscription-freq').length) {
				jQuery(".subscription_value.product_add .subscription-freq option:selected").each(function (ix, ex) {
					var sub_val = jQuery(ex).val();
					if (sub_val == 'subscribe-save') {
						//product_id = jQuery(em).attr('data-subs-id');
						product_id = jQuery(em).val();
						jQuery(".hidden_input_value").val(product_id);

					} else {
						product_id = jQuery(em).val();
						jQuery(".hidden_input_value").val(product_id);
						jQuery(".hidden_input_value").attr('data-single-product', product_id);
					}
				});
			} else {
				product_id = jQuery(em).val();
				jQuery(".hidden_input_value").val(product_id);
				jQuery(".hidden_input_value").attr('data-single-product', product_id);
			}
			product_id_onetime = jQuery(em).val();
			jQuery(".hidden_input_value").attr('data-single-product', product_id_onetime);
			update_rechargeprice(product_id);
			var sliderToMoveTo = jQuery("#product-content-slider0 .slide-item img[src='" +
				show_selected_image + "']").parents('.slide-item').eq(0).attr(
					'data-slick-index');
			jQuery("#product-content-slider0").slick('slickGoTo', 0);
			jQuery("#product-content-slider0 .slick-active").find('img').attr('src',
				show_selected_image);
			jQuery("#product-content-slider0 .slick-active").find('img').attr(
				'srcset', show_selected_image_srcset);
			window.history.replaceState(null, null, "?variant=" + product_id);
		});
		// dhara 12-june comment this code
		// var em = jQuery('[data-variant-select] option:selected');
		// var show_selected_image = jQuery(em).attr('data-variant-image');
		// jQuery("#product-content-slider0").slick('slickGoTo', 0);
		// jQuery("#product-content-slider0 .slick-active").find('img').attr('src', show_selected_image);
		var default_selected_size = jQuery(em).attr('data-size')
		jQuery("[data-variants] option:disabled[data-size='" + default_selected_size +
			"']").each(function (ix, em) {
				var $this = jQuery(em);
				var color = jQuery($this).attr('data-color');
				jQuery("#color-" + color).attr('disabled', 'disabled');
				jQuery("#color-" + color).find('input').attr('disabled', 'disabled');
			});
		jQuery('[data-add-to-cart] [name="color"]').trigger('change');
	}
	// WHEN SINGLE OPTION IS PRESENT
	if (jQuery("[data-product-single-variant-option]").length > 0) {
		jQuery(document).on('change', '[data-variant-select]', function (e) {
			var em = jQuery('[data-variant-select] option:selected');
			//var product_id = jQuery( em ).val();
			var product_id = '';
			if (jQuery('.subscription_value.product_add .subscription-freq').length) {
				jQuery(".subscription_value.product_add .subscription-freq option:selected").each(function (ix, ex) {
					var sub_val = jQuery(ex).val();
					if (sub_val == 'subscribe-save') {
						//product_id = jQuery(em).attr('data-subs-id');
						product_id = jQuery(em).val();
						jQuery(".hidden_input_value").val(product_id);

					} else {
						product_id = jQuery(em).val();
						jQuery(".hidden_input_value").val(product_id);
						jQuery(".hidden_input_value").attr('data-single-product', product_id);
					}
				});
			} else {
				product_id = jQuery(em).val();
				jQuery(".hidden_input_value").val(product_id);
				jQuery(".hidden_input_value").attr('data-single-product', product_id);
			}
			product_id_onetime = jQuery(em).val();
			jQuery(".hidden_input_value").attr('data-single-product', product_id_onetime);
			update_rechargeprice(product_id);
			var show_selected_image = jQuery(em).attr('data-variant-image').trim();
			var show_selected_image_srcset = jQuery(em).attr('data-variant-srcset');
			var price_to_update = jQuery(em).attr('data-price');
			jQuery("#proprice").html(price_to_update);
			jQuery("#proprice2").html(price_to_update);
			if (show_selected_image != -1) {
				jQuery("#product-content-slider0").slick('slickGoTo', 0);
				jQuery("#product-content-slider0 .slick-active").find('img').attr('src',
					show_selected_image);
				jQuery("#product-content-slider0 .slick-active").find('img').attr(
					'srcset', show_selected_image_srcset);
			}
			window.history.replaceState(null, null, "?variant=" + product_id);
		});
		jQuery(document).on('change', '[data-variant-radio-select]', function (e) {
			do_console('test 1517');
			
			
			var em = jQuery('[data-variant-radio-select]:checked');
			var product_id = '';
			if (jQuery('.subscription_value.product_add .subscription-freq').length) {
				jQuery(".subscription_value.product_add .subscription-freq option:selected").each(function (ix, ex) {
					debugger
					var sub_val = jQuery(ex).val();
					if (sub_val == 'subscribe-save') {
						adjust_sub_options();
						//product_id = jQuery(em).attr('data-subs-id');
						product_id = jQuery(em).val();
						jQuery(".hidden_input_value").val(product_id);
					} else {
						product_id = jQuery(em).val();
						jQuery(".hidden_input_value").val(product_id);
						jQuery(".hidden_input_value").attr('data-single-product', product_id);
					}
				});
			} else {
				product_id = jQuery(em).val();
				jQuery(".hidden_input_value").val(product_id);
				jQuery(".hidden_input_value").attr('data-single-product', product_id);
			}
			product_id_onetime = jQuery(em).val();
			jQuery(".hidden_input_value").attr('data-single-product', product_id_onetime);
			update_rechargeprice(product_id);
			//do_console(product_id);

			var show_selected_image = jQuery(em).attr('data-variant-image').trim();
			var show_selected_image_srcset = jQuery(em).attr('data-variant-srcset');
			debugger;
			var price_to_update = jQuery(em).attr('data-price');
			var variant_title = jQuery(em).attr('data-variant-title');
			var pre_order_text = jQuery('#crtbtn1').attr('data-pre-text');
			if (jQuery(em).attr('data-is-not-available') == 'not-available') {
				if (typeof pre_order_text !== typeof undefined && pre_order_text !== false) {
					jQuery("#crtbtn1").text(pre_order_text);
				} else {
					jQuery("#crtbtn1").text("Out Of stock");
				}
				jQuery("#crtbtn1").attr('disabled', 'disabled');
				//do_console("is not avialable");
			}
			else {
				if (typeof pre_order_text !== typeof undefined && pre_order_text !== false) {
					jQuery("#crtbtn1").text(pre_order_text);
				} else {
					if (jQuery('.subscription_value.product_add .subscription-freq').length) {
						do_console('there is subs');
						jQuery(".subscription_value.product_add .subscription-freq option:selected").each(function (ix, ex) {
							var sub_val = jQuery(ex).val();
							if (sub_val == 'onetime') {
								var variant_orig_price =parseInt(jQuery(em).attr('data-price').replace('.','').replace(',',''));
								console.log('value is onetime' + variant_orig_price);
								debugger
								variant_orig_price = Shopify.formatMoney(variant_orig_price,theme.moneyFormat);
								jQuery('.sub_wrap_new_ui .subscribe_wrapper .subscribe_one_purchase .subscribe_price .one_time_price').text(variant_orig_price);
								jQuery('#crtbtn1').html("Add to Cart " + "<span id='AddToCartText-product-template'>(" + variant_orig_price + ")</span>");
							} else {
								var pro_disc_price = jQuery(ex).attr('data-discount-price');
								jQuery('#crtbtn1').html("Subscribe and Save " + "<span id='AddToCartText-product-template'>(" + pro_disc_price + ")</span>");
							}
						});
					} else {
						let current_price = parseInt($(`.product-cart-box [name="id"]:checked`).attr('data-price').replace('.','').replace(',',''));
						current_price = Shopify.formatMoney(current_price,theme.moneyFormat);
						do_console('there is no subs');
						debugger
						jQuery("#crtbtn1").html("Add To Cart "+ "<span id='AddToCartText-product-template'>(" + current_price + ")</span>");
					}
				}
				jQuery("#crtbtn1").removeAttr('disabled');
				//do_console("is-avialable");
				if (jQuery(em).attr('disabled') == 'disabled') {
					jQuery("#text-color").text("Not available.");
				} else {
					jQuery("#text-color").text(variant_title);
				}
			}
			jQuery("#proprice").html(price_to_update);
			jQuery("#proprice2").html(price_to_update);
			if (show_selected_image != -1) {
				jQuery("#product-content-slider0").slick('slickGoTo', 0);
				jQuery("#product-content-slider0 .slick-active").find('img').attr('src',
					show_selected_image);
				jQuery("#product-content-slider0 .slick-active").find('img').attr(
					'srcset', show_selected_image_srcset);
			}
			window.history.replaceState(null, null, "?variant=" + product_id);
		});
		/* chnage price and image sponge product */
	}
	jQuery(document).on('change', '[data-variant-sponge-radio-select ]', function (
		e) {
		var em = jQuery('[data-variant-sponge-radio-select ]:checked');
		var product_id = '';
		if (jQuery('.subscription_value.product_add .subscription-freq').length) {
			jQuery(".subscription_value.product_add .subscription-freq option:selected").each(function (ix, ex) {
				var sub_val = jQuery(ex).val();
				if (sub_val == 'subscribe-save') {
					//product_id = jQuery(em).attr('data-subs-id');
					product_id = jQuery(em).val();
					jQuery(".hidden_input_value").val(product_id);
				} else {
					product_id = jQuery(em).val();
					jQuery(".hidden_input_value").val(product_id);
					jQuery(".hidden_input_value").attr('data-single-product', product_id);
				}
			});
		} else {
			product_id = jQuery(em).val();
			jQuery(".hidden_input_value").val(product_id);
			jQuery(".hidden_input_value").attr('data-single-product', product_id);
		}
		update_rechargeprice(product_id);
		var show_selected_image = jQuery(em).attr('data-variant-image').trim();
		var show_selected_image_srcset = jQuery(em).attr('data-variant-srcset').trim();
		var price_to_update = jQuery(em).attr('data-price');
		var variant_title = jQuery(em).attr('data-variant-title');
		var sliderToMoveTo = jQuery("#product-content-slider0 .slide-item img[src='" +
			show_selected_image + "']").parents('.slide-item').eq(0).attr(
				'data-slick-index');
		if (jQuery(em).attr('disabled') == 'disabled') {
			jQuery("#text-color").text("Not available.");
		} else {
			jQuery("#text-color").text(variant_title);
		}
		jQuery("#proprice").html(price_to_update);
		jQuery("#proprice2").html(price_to_update);
		if (show_selected_image != -1) {
			jQuery("#product-content-slider0").slick('slickGoTo', 0);
			jQuery("#product-content-slider0 .slick-active").find('img').attr('src',
				show_selected_image);
			jQuery("#product-content-slider0 .slick-active").find('img').attr(
				'srcset', show_selected_image_srcset);
		}
		window.history.replaceState(null, null, "?variant=" + product_id);
		$(`[name="subscribe_and_save"]:checked`).trigger('change');
	});
	/* Single Product Page Ends */
	/* All Collection Page */
	if (jQuery("[data-collection-all-url]").length > 0) {
		jQuery(document).on('change', "[data-collection-all-url]", function (e) {
			$em = e.target;
			var url_to_move_to = jQuery($em).attr('data-collection-all-url')
			window.location = url_to_move_to;
		});
	}
	/* Cart page */
	if (jQuery("body.template-cart [data-cart-section]").length > 0) {
		/*
		jQuery(document).on('change', "[name='updates[]']", function (e) {
			//jQuery( "[name='update']" ).trigger( 'click' );
			jQuery("form.cart")[0].submit();
		});
		*/
		jQuery(document).on('change','[data-itemkey]',function(e){
			let em = jQuery(e.target);
			let key = jQuery(em).attr('data-itemkey');
			let quantity = jQuery(em).val();
			let current_item = {};
			current_item[key] = quantity;
			jQuery.ajax({
			  url: "/cart/update.js",
			  data: { 'updates': current_item },
			  method: "POST",
			  dataType: "JSON",
			  success: function (data) {
				window.location = "/cart";
			  }, error: function (error) {
				
			  }
			});
		});

		jQuery(document).on('click', '.cart-h3', function (e) {
			var $this = e.target;
			var url_to_move = jQuery($this).attr('data-product-url');
			window.location = (url_to_move);
		});
	}
	/* Cart page ends */
	/* blog page */
	jQuery(".blog-post").find("p").each(function (ix, em) {
		if (jQuery(em).html() == "&nbsp;") {
			jQuery(em).remove();
		}
	});
	/* blog page ends */
	/* recipe page */
	if (jQuery(".ingredients-directions").length > 0) {
		jQuery(".ingredients-directions").find('h4').each(function (ix, em) {
			if (jQuery(em).parents('.checkbox-cont').eq(0).length > 0) {
				jQuery(em).insertAfter(jQuery(em).parents('.checkbox-cont').eq(0));
			}
		});
	}
	/* recipe page ends */
	/* Product Review submit */
	jQuery(document).on('click', '[data-submit="product_review"]', function (e) {
		if (jQuery("#rating-form")[0].checkValidity()) {
			show_spinner();
			e.preventDefault();
			jQuery.ajax({
				type: 'post',
				url: app_url + '/feajax/add_review',
				dataType: "json",
				data: jQuery('#rating-form').serialize(),
				success: function (data) {
					if (data.success == "true") {
						jQuery("#rev2").show(200);
						jQuery("#rev1").hide(200);
					}
					hide_spinner();
				},
				error: function (data) {
					hide_spinner();
					jQuery("#rev2").html("<h5>Error occured.<br/>Please try later.</h5>");
					jQuery("#rev2").show(200);
					jQuery("#rev1").hide(200);
					jQuery(
						"#rating-form input[type='text'], #rating-form input[type='email'], #rating-form textarea"
					).val("");
				}
			});
			/* jQuery.ajax ends */
		}
	});
	/* Product Review submit */
	/* Retail Partners Application Form submit */
	jQuery(document).on('click', '[data-submit-retailes-application]', function (e) {
		if (jQuery("[data-retailers-application]")[0].checkValidity()) {
			if (grecaptcha.getResponse() == "") {
				e.preventDefault();
				alert("Please Fill captcha");
			} else {
				show_spinner();
				e.preventDefault();
				jQuery.ajax({
					type: 'post',
					url: app_url + '/feajax/add_retail_partner',
					dataType: "json",
					data: jQuery('[data-retailers-application]').serialize(),
					success: function (data) {
						if (data.success == "true") {
							jQuery('.retail_partner_ref_no').text(data.reference_id);
							jQuery(".aplication-form-thankyou").show(200);
							jQuery(".aplication-form").hide(200);
							jQuery(
								"[data-retailers-application] input, [data-retailers-application] textarea, [data-retailers-application] radio"
							).val("");
							jQuery("[data-retailers-application] input[type='radio']").prop(
								'checked', false);
							grecaptcha.reset();
						}
						hide_spinner();
					},
					error: function (data) {
						hide_spinner();
					}
				});
			}
			/* jQuery.ajax ends */
		}
	});
	/* Retail Partners Application Form submit */
	/* Contact Form submit */
	jQuery(document).on('click', '[data-contact-form-submit]', function (e) {
		if (jQuery("[data-contact-form]")[0].checkValidity()) {
			if (grecaptcha.getResponse() == "") {
				e.preventDefault();
				alert("Please Fill captcha");
			} else {
				show_spinner();
				e.preventDefault();
				jQuery.ajax({
					type: 'post',
					url: app_url + '/feajax/add_contact_us',
					dataType: "json",
					data: jQuery('[data-contact-form]').serialize(),
					success: function (data) {
						if (data.success == "true") {
							jQuery('.contact_ref_no').text(data.reference_id);
							jQuery(".contact-thankyou").show(200);
							jQuery("#contactfrm").hide(200);
							jQuery("[data-contact-form] input, [data-contact-form] textarea").val(
								"");
							jQuery("[data-contact-form] select").val(-1);
							grecaptcha.reset();
						}
						hide_spinner();
					},
					error: function (data) {
						hide_spinner();
					}
				});
			}
			/* jQuery.ajax ends */
		}
	});
	/* Contact Form submit */
	/* Single Variant Product addition javascript */
	jQuery(".prouct-item a.image").on('click', function (e) {
		var currentEm = e.target;
		if (jQuery(currentEm).hasClass('add-to')) {
			e.preventDefault;
		}
	});
	/**
	 * jQuery Bar Rating Plugin v1.2.2
	 * http://github.com/antennaio/jquery-bar-rating
	 * Copyright (c) 2012-2016 Kazik Pietruszewski
	 * This plugin is available under the MIT license.
	 * http://www.opensource.org/licenses/mit-license.php
	 */
	! function (t) {
		"function" == typeof define && define.amd ? define(["jquery"], t) :
			"object" == typeof module && module.exports ? module.exports = t(require(
				"jquery")) : t(jQuery)
	}(function (t) {
		var e = function () {
			function e() {
				var e = this,
					n = function () {
						var n = ["br-wrapper"];
						"" !== e.options.theme && n.push("br-theme-" + e.options.theme),
							e.$elem.wrap(t("<div />", {
								"class": n.join(" ")
							}))
					},
					i = function () {
						e.$elem.unwrap()
					},
					a = function (n) {
						return t.isNumeric(n) && (n = Math.floor(n)), t(
							'option[value="' + n + '"]', e.$elem)
					},
					r = function () {
						var n = e.options.initialRating;
						return n ? a(n) : t("option:selected", e.$elem)
					},
					o = function () {
						var n = e.$elem.find('option[value="' + e.options.emptyValue + '"]');
						return !n.length && e.options.allowEmpty ? (n = t("<option />", {
							value: e.options.emptyValue
						}), n.prependTo(e.$elem)) : n
					},
					l = function (t) {
						var n = e.$elem.data("barrating");
						return "undefined" != typeof t ? n[t] : n
					},
					s = function (t, n) {
						null !== n && "object" == typeof n ? e.$elem.data("barrating", n) :
							e.$elem.data("barrating")[t] = n
					},
					u = function () {
						var t = r(),
							n = o(),
							i = t.val(),
							a = t.data("html") ? t.data("html") : t.text(),
							l = null !== e.options.allowEmpty ? e.options.allowEmpty : !!n.length,
							u = n.length ? n.val() : null,
							d = n.length ? n.text() : null;
						s(null, {
							userOptions: e.options,
							ratingValue: i,
							ratingText: a,
							originalRatingValue: i,
							originalRatingText: a,
							allowEmpty: l,
							emptyRatingValue: u,
							emptyRatingText: d,
							readOnly: e.options.readonly,
							ratingMade: !1
						})
					},
					d = function () {
						e.$elem.removeData("barrating")
					},
					c = function () {
						return l("ratingText")
					},
					f = function () {
						return l("ratingValue")
					},
					g = function () {
						var n = t("<div />", {
							"class": "br-widget"
						});
						return e.$elem.find("option").each(function () {
							var i, a, r, o;
							i = t(this).val(), i !== l("emptyRatingValue") && (a = t(
								this).text(), r = t(this).data("html"), r && (a = r), o =
								t("<a />", {
									href: "#",
									"data-rating-value": i,
									"data-rating-text": a,
									html: e.options.showValues ? a : ""
								}), n.append(o))
						}), e.options.showSelectedRating && n.append(t("<div />", {
							text: "",
							"class": "br-current-rating"
						})), e.options.reverse && n.addClass("br-reverse"),
							e.options.readonly && n.addClass("br-readonly"), n
					},
					p = function () {
						return l("userOptions").reverse ? "nextAll" : "prevAll"
					},
					h = function (t) {
						a(t).prop("selected", !0), l("userOptions").triggerChange && e.$elem
							.change()
					},
					m = function () {
						t("option", e.$elem).prop("selected", function () {
							return this.defaultSelected
						}), l("userOptions").triggerChange && e.$elem.change()
					},
					v = function (t) {
						t = t ? t : c(), t == l("emptyRatingText") && (t = ""),
							e.options.showSelectedRating && e.$elem.parent().find(
								".br-current-rating").text(t)
					},
					y = function (t) {
						return Math.round(Math.floor(10 * t) / 10 % 1 * 100)
					},
					b = function () {
						e.$widget.find("a").removeClass(function (t, e) {
							return (e.match(/(^|\s)br-\S+/g) || []).join(" ")
						})
					},
					w = function () {
						var n, i, a = e.$widget.find('a[data-rating-value="' + f() + '"]'),
							r = l("userOptions").initialRating,
							o = t.isNumeric(f()) ? f() : 0,
							s = y(r);
						if (b(), a.addClass("br-selected br-current")[p()]().addClass(
							"br-selected"), !l("ratingMade") && t.isNumeric(r)) {
							if (o >= r || !s) return;
							n = e.$widget.find("a"), i = a.length ? a[l("userOptions").reverse ?
								"prev" : "next"]() : n[l("userOptions").reverse ? "last" :
									"first"](), i.addClass("br-fractional"), i.addClass(
										"br-fractional-" + s)
						}
					},
					$ = function (t) {
						return l("allowEmpty") && l("userOptions").deselectable ? f() ==
							t.attr("data-rating-value") : !1
					},
					x = function (n) {
						n.on("click.barrating", function (n) {
							var i, a, r = t(this),
								o = l("userOptions");
							return n.preventDefault(), i = r.attr("data-rating-value"), a =
								r.attr("data-rating-text"), jQuery(r) && (i = l(
									"emptyRatingValue"), a = l("emptyRatingText")),
								s("ratingValue", i), s("ratingText", a), s("ratingMade", !0),
								h(i), v(a), w(), o.onSelect.call(e, f(), c(), n), !1
						})
					},
					C = function (e) {
						e.on("mouseenter.barrating", function () {
							var e = t(this);
							b(), e.addClass("br-active")[p()]().addClass("br-active"), v(
								e.attr("data-rating-text"))
						})
					},
					O = function (t) {
						e.$widget.on("mouseleave.barrating blur.barrating", function () {
							v(), w()
						})
					},
					R = function (e) {
						e.on("touchstart.barrating", function (e) {
							e.preventDefault(), e.stopPropagation(), t(this).click()
						})
					},
					V = function (t) {
						t.on("click.barrating", function (t) {
							t.preventDefault()
						})
					},
					S = function (t) {
						x(t), e.options.hoverState && (C(t), O(t))
					},
					T = function (t) {
						t.off(".barrating")
					},
					j = function (t) {
						var n = e.$widget.find("a");
						l("userOptions").fastClicks && R(n), t ? (T(n), V(n)) : S(
							n)
					};
				this.show = function () {
					l() || (n(), u(), e.$widget = g(), e.$widget.insertAfter(e.$elem),
						w(), v(), j(e.options.readonly), e.$elem.hide())
				}, this.readonly = function (t) {
					"boolean" == typeof t && l("readOnly") != t && (j(t), s(
						"readOnly", t), e.$widget.toggleClass("br-readonly"))
				}, this.set = function (t) {
					var n = l("userOptions");
					0 !== e.$elem.find('option[value="' + t + '"]').length && (s(
						"ratingValue", t), s("ratingText", e.$elem.find(
							'option[value="' + t + '"]').text()), s("ratingMade", !0), h(
								f()), v(c()), w(), n.silent || n.onSelect.call(this, f(), c()))
				}, this.clear = function () {
					var t = l("userOptions");
					s("ratingValue", l("originalRatingValue")), s("ratingText", l(
						"originalRatingText")), s("ratingMade", !1), m(), v(c()), w(),
						t.onClear.call(this, f(), c())
				}, this.destroy = function () {
					var t = f(),
						n = c(),
						a = l("userOptions");
					T(e.$widget.find("a")), e.$widget.remove(), d(), i(), e.$elem.show(),
						a.onDestroy.call(this, t, n)
				}
			}
			return e.prototype.init = function (e, n) {
				return this.$elem = t(n), this.options = t.extend({}, t.fn.barrating
					.defaults, e), this.options
			}, e
		}();
		t.fn.barrating = function (n, i) {
			return this.each(function () {
				var a = new e;
				if (t(this).is("select") || t.error(
					"Sorry, this plugin only works with select fields."), a.hasOwnProperty(
						n)) {
					if (a.init(i, this), "show" === n) return a.show(i);
					if (a.$elem.data("barrating")) return a.$widget = t(this).next(
						".br-widget"), a[n](i)
				} else {
					if ("object" == typeof n || !n) return i = n, a.init(i, this), a
						.show();
					t.error("Method " + n + " does not exist on jQuery.barrating")
				}
			})
		}, t.fn.barrating.defaults = {
			theme: "",
			initialRating: null,
			allowEmpty: null,
			emptyValue: "",
			showValues: !1,
			showSelectedRating: !0,
			deselectable: !0,
			reverse: !1,
			readonly: !1,
			fastClicks: !0,
			hoverState: !0,
			silent: !1,
			triggerChange: !0,
			onSelect: function (t, e, n) { },
			onClear: function (t, e) { },
			onDestroy: function (t, e) { }
		}, t.fn.barrating.BarRating = e
	});
	jQuery("#review-rating").barrating({
		theme: "fontawesome-stars"
	});
	/* Loyalty page Js */
	jQuery('#f-tryagain').on('click', function () {
		displaydiv('reg-step-2', 1);
		displaydiv('reg-step-3', 0)
	});
	var getUrlParameter = function getUrlParameter(sParam) {
		var sPageURL = window.location.search.substring(1),
			sURLVariables = sPageURL.split('&'),
			sParameterName,
			i;
		for (i = 0; i < sURLVariables.length; i++) {
			sParameterName = sURLVariables[i].split('=');
			if (sParameterName[0] === sParam) {
				return sParameterName[1] === undefined ? true : decodeURIComponent(
					sParameterName[1]);
			}
		}
	}
	var coupon_code = getUrlParameter('CouponCode');
	jQuery(".coupon_code_loyalty").attr("value", coupon_code);
	jQuery(".twitter-share-btn").attr('href', encodeURI(
		'https://twitter.com/intent/tweet?url=https://www.teamiblends.com/&text=I will be starting my @teamiblends 30 Days detox. It helps to increase my energy, boost my metabolism, and most importantly decrease cravings, flatten my tummy and it also tastes great! Don’t forget to use my code “' +
		coupon_code +
		'” for discount your purchase! %23thankyouteami&via=teamiblends'));
	jQuery(".facebook-share-btn").attr('href',
		'https://www.facebook.com/sharer/sharer.php?u=www.teamiblends.com&quote=I%20will%20be%20starting%20my%20@teamiblends%2030%20Days%20detox.%20It%20helps%20to%20increase%20my%20energy,%20boost%20my%20metabolism,%20and%20most%20importantly%20decrease%20cravings,%20flatten%20my%20tummy%20and%20it%20also%20tastes%20great!%20Don%E2%80%99t%20forget%20to%20use%20my%20code%20%E2%80%9C' +
		coupon_code +
		'%E2%80%9D%20for%20discount%20your%20purchase!%20%23thankyouteami');
	/* Document.ready ends */
	is_DOM_Ready = true;
});
/* Loyalty page Js */
function loadingspinner(x) {
	if (x == 1) {
		displaydiv('loadingspinner', 1)
	} else {
		displaydiv('loadingspinner', 0)
	}
}

function addHidden(theForm, key, value) {
	var input = document.createElement('input');
	input.type = 'hidden';
	input.name = key;
	input.value = value;
	theForm.appendChild(input)
}

function displaydiv(id, x) {
	if (x == 0) {
		var dd = 'none'
	} else {
		var dd = 'block'
	}
	document.getElementById(id).style.display = dd
}

function loyaltyRegister(x) {
	if (x == 1) {
		fixemail('RegEmail');
		fixemail('RegPayPal');
		jQuery(".contact-section #RegEmail").val(jQuery(".contact-section #RegEmail").val()
			.toLowerCase());
		jQuery(".contact-section #RegPayPal").val(jQuery(".contact-section #RegPayPal").val()
			.toLowerCase());
		displaydiv('reg-step-1', 0);
		displaydiv('reg-step-2', 1)
	} else if (x == 2) {
		loadingspinner(1);
		var RegInstagram = jQuery('#RegInstagram').val();
		var RegYouTube = jQuery('#RegYouTube').val();
		jQuery.ajax({
			type: 'post',
			url: loyalty_app_url + '/auth/check_instagram_user',
			dataType: "json",
			data: {
				instagram_username: RegInstagram,
				youtube_link: RegYouTube
			},
			success: function (data) {
				if (data.error == "true") {
					loadingspinner(0);
					alert(data.message);
					return false;
				} else {
					jQuery("#f-username").text(data.user_data.username);
					jQuery("#f-followers").text(data.user_data.followers);
					jQuery("#f-image").attr('src', data.user_data.profile_image);
					jQuery("#IgUserID").val(data.user_data.instagram_id);
					jQuery("#IgImage").val(data.user_data.profile_image);
					jQuery("#IgFollowers").val(data.user_data.followers);
					jQuery("#IgFollowing").val(data.user_data.follow);
					jQuery("#IgMedia").val(data.user_data.media);
					displaydiv('reg-step-2', 0);
					displaydiv('reg-step-3', 1);
					loadingspinner(0);
				}
			},
			error: function (data) {
				hide_spinner();
			}
		});
	} else if (x == 3) {
		displaydiv('reg-step-3', 0);
		displaydiv('reg-step-4', 1)
	} else if (x == 4) {
		loadingspinner(1);
		var CouponCode = jQuery('#CouponCode').val();
		jQuery('#Coupon_code').val(CouponCode);
		jQuery.ajax({
			type: 'post',
			url: loyalty_app_url + '/auth/check_coupon_code',
			dataType: "json",
			data: {
				CouponCode: CouponCode
			},
			success: function (data) {
				if (data.error == "true") {
					alert(data.message);
					loadingspinner(0);
					return false;
				} else {
					jQuery.ajax({
						type: 'post',
						url: loyalty_app_url + '/auth/add_shopify_user',
						dataType: "json",
						data: jQuery('#loyalty-form-1,#loyalty-form-2').serialize(),
						success: function (data) {
							loadingspinner(0);
							if (data.error == "true") {
								alert(data.message)
							} else {
								loyalty_success_page_url + '?CouponCode=' + data.coupon_code
								window.location = loyalty_success_page_url + '?CouponCode=' +
									data.coupon_code;
								jQuery(".coupon_code_loyalty").attr("value", data.coupon_code);
							}
						},
						error: function (data) {
							loadingspinner(0);
						}
					});
				}
			},
			error: function (data) {
				loadingspinner(0);
			}
		});
	}
	return !1
}
/* Contact Form submit */
jQuery(document).on('click', '[data-tracking-form-submit]', function (e) {
	e.preventDefault();
	loadingspinner(1);
	jQuery.ajax({
		type: 'post',
		url: app_url + '/feajax/get_tracking_url',
		dataType: "json",
		data: jQuery('[data-track-form]').serialize(),
		success: function (data) {
			if (data.success == "true") {
				window.location = data.tracking_url;
			} else {
				alert(data.message);
				loadingspinner(0);
			}
		},
		error: function (data) {
			loadingspinner(0);
		}
	});
});
/* Single Product Ajax */
jQuery(document).ready(function () {
	jQuery('a.add-to.add-to-ajax-single-product').show();
	jQuery("a.add-to.add-to-ajax-single-product").on('click', function (e) {
		e.preventDefault;
		var currentElement = e.target;
		var product_id_to_add = jQuery(currentElement).attr(
			'data-product-id-to-add');
		if (product_id_to_add) {
			jQuery(currentElement).parents('.product-item').find('.product-ajax-loader').fadeIn(300);
			jQuery(currentElement).parents('.product-item').find(".subscription_value .subscription-freq option:selected").each(function (ix, em) {
				var sub_val = jQuery(this).val();
				debugger;
				if (sub_val == 'subscribe-save') {
					do_console(product_id_to_add);
					let parent = $(this).parents('.product-item');
					let selling_plan = $(parent).find(`select.subscription-freq option:selected`).attr('data-subscription-id-to-add');
					/*
					var selectedfrequency = jQuery(this).attr("data-freq");
					var selectedfrequencyunit = jQuery(this).attr('data-unit');
					var subscription_id = jQuery(currentElement).attr('data-subscription-id');
					//var selectedfrequency = jQuery("#shipping_interval_frequency_box input[name='shipping_interval_frequency']:checked").val();
					var line_properties = {};
					line_properties.subscription_id = subscription_id;
					line_properties.shipping_interval_frequency = selectedfrequency;
					line_properties.shipping_interval_unit_type = selectedfrequencyunit;
					line_properties.selling_plan_id = $(this).attr('selling_plan_id');
					*/
					data_to_send = {
						'quantity': 1,
						'id': product_id_to_add,
						"selling_plan" : selling_plan
					}
				} else {
					data_to_send = {
						'quantity': 1,
						'id': product_id_to_add
					}
				}
			});
			//MAKE AJAX CALLS
			do_console(2260);
			jQuery.ajax({
				url: '/cart/add.js',
				method: "POST",
				dataType: "JSON",
				data: data_to_send,
				success: function (data) {
					sendOneSignalTags(data.product_title, data.image);
					update_cart_popup();
					if(typeof window.customer_email !== 'undefined') {
						window.liQ = window.liQ || [];
						window.liQ.push({
						"event": "addToCart",
						"email": window.customer_email
						});
					}
					jQuery(currentElement).parents('.product-item').find(
						'.product-ajax-loader').fadeOut(300);
					//Update CART COUNT + 1
					//.nav-shop-mobile .badge
					//.nav-item.nav-shop .badge
					jQuery(".nav-item.nav-shop .badge").show();
					jQuery(".nav-shop-mobile .badge").show();
					var valueToUpdate = parseInt(jQuery(".nav-item.nav-shop .badge").text()) +
						1;
					jQuery(".nav-shop-mobile .badge").text(valueToUpdate.toString());
					jQuery(".nav-item.nav-shop .badge").text(valueToUpdate.toString());
					//do_console(valueToUpdate);
					// swal( {
					// 	title: "",
					// 	text: "Product added to the cart",
					// 	icon: "success",
					// 	buttons: false,
					// 	timer: 1500
					// } );
					jQuery(currentElement).parents('.product-item').find(
						'.add-to-ajax-single-product').find('i').removeClass(
							'fa-cart-plus').addClass('fa-check');
				},
				error: function (data) {
					jQuery(currentElement).parents('.product-item').find(
						'.product-ajax-loader').fadeOut(300);
					if (typeof data.responseJSON.description !== "undefined") {
						var message = data.responseJSON.description;
					} else {
						var message = "Please try again later!";
					}
					swal({
						title: "Oops!!",
						text: message,
						icon: "error",
						className: "add-ajax-outofstock",
						buttons: false,
						timer: 1500
					});
				}
			});
		}
		return false;
	});
});

jQuery(document).ready(function (e) {
	if (jQuery('.oos-klaviyo-activated').length > 0) {
		jQuery(document).on('change', ".klavio_form input[type='checkbox']", function (e) {
			if (jQuery(".klavio_form input[type='checkbox']:checked").length) {
				jQuery("#crtbtn1,#crtbtn2").removeClass("oos-klaviyo-activated");
			} else {
				jQuery("#crtbtn1,#crtbtn2").addClass("oos-klaviyo-activated");
			}
		});
	}
});

jQuery(document).on('click', '.oos-klaviyo-activated', function (e) {
	swal("", "Oops! Please select the terms & conditions box to add to cart!", "");
	return false;
});

/* Customer Login form*/
window.theme = theme || {};
theme.customerTemplates = (function () {
	var selectors = {
		RecoverHeading: '#RecoverHeading',
		RecoverEmail: '#RecoverEmail',
		LoginHeading: '#LoginHeading'
	};

	function initEventListeners() {
		this.$RecoverHeading = jQuery(selectors.RecoverHeading);
		this.$RecoverEmail = jQuery(selectors.RecoverEmail);
		this.$LoginHeading = jQuery(selectors.LoginHeading);
		// Show reset password form
		jQuery('#RecoverPassword').on('click', function (evt) {
			evt.preventDefault();
			showRecoverPasswordForm();
			this.$RecoverHeading.attr('tabindex', '-1').focus();
		}.bind(this));
		// Hide reset password form
		jQuery('#HideRecoverPasswordLink').on('click', function (evt) {
			evt.preventDefault();
			hideRecoverPasswordForm();
			this.$LoginHeading.attr('tabindex', '-1').focus();
		}.bind(this));
		this.$RecoverHeading.on('blur', function () {
			jQuery(this).removeAttr('tabindex');
		});
		this.$LoginHeading.on('blur', function () {
			jQuery(this).removeAttr('tabindex');
		});
	}
	/**
	 *
	 *  Show/Hide recover password form
	 *
	 */
	function showRecoverPasswordForm() {
		jQuery('#RecoverPasswordForm').removeClass('hide');
		jQuery('#CustomerLoginForm').addClass('hide');
		if (this.$RecoverEmail.attr('aria-invalid') === 'true') {
			this.$RecoverEmail.focus();
		}
	}

	function hideRecoverPasswordForm() {
		jQuery('#RecoverPasswordForm').addClass('hide');
		jQuery('#CustomerLoginForm').removeClass('hide');
	}
	/**
	 *
	 *  Show reset password success message
	 *
	 */
	function resetPasswordSuccess() {
		var $formState = jQuery('.reset-password-success');
		// check if reset password form was successfully submited.
		if (!$formState.length) {
			return;
		}
		// show success message
		jQuery('#ResetSuccess').removeClass('hide').focus();
	}
	/**
	 *
	 *  Show/hide customer address forms
	 *
	 */
	function customerAddressForm() {
		var $newAddressForm = jQuery('#AddressNewForm');
		var $newAddressFormButton = jQuery('#AddressNewButton');
		if (!$newAddressForm.length) {
			return;
		}
		// Initialize observers on address selectors, defined in shopify_common.js
		if (Shopify) {
			// eslint-disable-next-line no-new
			new Shopify.CountryProvinceSelector('AddressCountryNew',
				'AddressProvinceNew', {
				hideElement: 'AddressProvinceContainerNew'
			});
		}
		// Initialize each edit form's country/province selector
		jQuery('.address-country-option').each(function () {
			var formId = jQuery(this).data('form-id');
			var countrySelector = 'AddressCountry_' + formId;
			var provinceSelector = 'AddressProvince_' + formId;
			var containerSelector = 'AddressProvinceContainer_' + formId;
			// eslint-disable-next-line no-new
			new Shopify.CountryProvinceSelector(countrySelector, provinceSelector, {
				hideElement: containerSelector
			});
		});
		// Toggle new/edit address forms
		jQuery('.address-new-toggle').on('click', function () {
			var isExpanded = $newAddressFormButton.attr('aria-expanded') ===
				'true';
			$newAddressForm.toggleClass('hide');
			$newAddressFormButton.attr('aria-expanded', !isExpanded).focus();
		});
		jQuery('.address-edit-toggle').on('click', function () {
			var formId = jQuery(this).data('form-id');
			var $editButton = jQuery('#EditFormButton_' + formId);
			var $editAddress = jQuery('#EditAddress_' + formId);
			var isExpanded = $editButton.attr('aria-expanded') === 'true';
			$editAddress.toggleClass('hide');
			$editButton.attr('aria-expanded', !isExpanded).focus();
		});
		jQuery('.address-delete').on('click', function () {
			var $el = jQuery(this);
			var formId = $el.data('form-id');
			var confirmMessage = $el.data('confirm-message');
			// eslint-disable-next-line no-alert
			if (confirm(confirmMessage ||
				'Are you sure you wish to delete this address?')) {
				Shopify.postLink('/account/addresses/' + formId, {
					parameters: {
						_method: 'delete'
					}
				});
			}
		});
	}
	/**
	 *
	 *  Check URL for reset password hash
	 *
	 */
	function checkUrlHash() {
		var hash = window.location.hash;
		// Allow deep linking to recover password form
		if (hash === '#recover') {
			showRecoverPasswordForm.bind(this)();
		}
	}
	return {
		init: function () {
			initEventListeners();
			checkUrlHash();
			resetPasswordSuccess();
			customerAddressForm();
		}
	};
})();
theme.init = function () {
	theme.customerTemplates.init();
};
jQuery(theme.init);
/* stop video on slide chnage */
var slideWrapper = jQuery(".product-content-slider"),
	iframes = slideWrapper.find('.embed-player'),
	lazyCounter = 0;
// POST commands to YouTube or Vimeo API
function postMessageToPlayer(player, command) {
	if (player == null || command == null) return;
	player.contentWindow.postMessage(JSON.stringify(command), "*");
}
// When the slide is changing
function playPauseVideo(slick, control) {

	var currentSlide, slideType, startTime, player, video;
	currentSlide = slick.find(".slick-current");
	if (typeof currentSlide.attr('class') !== "undefined") {
		slideType = currentSlide.attr("class").split(" ")[1];
		player = currentSlide.find("iframe").get(0);
		startTime = currentSlide.data("video-start");
		if (slideType === "vimeo") {
			switch (control) {
				// case "play":
				//     if ((startTime != null && startTime > 0 ) && !currentSlide.hasClass('started')) {
				//     currentSlide.addClass('started');
				//     postMessageToPlayer(player, {
				//         "method": "setCurrentTime",
				//         "value" : startTime
				//     });
				//     }
				//     postMessageToPlayer(player, {
				//     "method": "play",
				//     "value" : 1
				//     });
				//     break;
				case "pause":
					postMessageToPlayer(player, {
						"method": "pause",
						"value": 1
					});
					break;
			}
		} else if (slideType === "youtube") {
			switch (control) {
				// case "play":
				//     postMessageToPlayer(player, {
				//     "event": "command",
				//     "func": "mute"
				//     });
				//     postMessageToPlayer(player, {
				//     "event": "command",
				//     "func": "playVideo"
				//     });
				//     break;
				case "pause":
					postMessageToPlayer(player, {
						"event": "command",
						"func": "pauseVideo"
					});
					break;
			}
		} else if (slideType === "video") {
			video = currentSlide.children("video").get(0);
			if (video != null) {
				if (control === "play") {
					video.play();
				} else {
					video.pause();
				}
			}
		}
	}// !== Undefined check 




}
// Resize player
function resizePlayer(iframes, ratio) {
	// if (!iframes[0]) return;
	// var win = jQuery(".product-content-slider"),
	//     width = win.width(),
	//     playerWidth,
	//     height = win.height(),
	//     playerHeight,
	//     ratio = ratio || 16/9;
	// iframes.each(function(){
	//     var current = jQuery(this);
	//     if (width / ratio < height) {
	//     playerWidth = Math.ceil(height * ratio);
	//     current.width(playerWidth).height(height).css({
	//         left: (width - playerWidth) / 2,
	//         top: 0
	//         });
	//     } else {
	//     playerHeight = Math.ceil(width / ratio);
	//     current.width(width).height(playerHeight).css({
	//         left: 0,
	//         top: (height - playerHeight) / 2
	//     });
	//     }
	// });
}
// DOM Ready
jQuery(function () {
	// Initialize
	slideWrapper.on("init", function (slick) {
		slick = jQuery(slick.currentTarget);
		setTimeout(function () {
			playPauseVideo(slick, "play");
		}, 1000);
		resizePlayer(iframes, 16 / 9);
	});
	slideWrapper.on("beforeChange", function (event, slick) {
		slick = jQuery(slick.$slider);
		playPauseVideo(slick, "pause");
	});
	slideWrapper.on("afterChange", function (event, slick) {
		slick = jQuery(slick.$slider);
		playPauseVideo(slick, "play");
	});
	slideWrapper.on("lazyLoaded", function (event, slick, image, imageSource) {
		lazyCounter++;
		if (lazyCounter === lazyImages.length) {
			lazyImages.addClass('show');
			// slideWrapper.slick("slickPlay");
		}
	});
});
// Resize event
jQuery(window).on("resize.slickVideoPlayer", function () {
	resizePlayer(iframes, 16 / 9);
});
// FTB App Code
jQuery(document).on('change', '#addtocart input,#addtocart select', function (e) {
	setTimeout(function () {
		var current_selected_value = jQuery("[name='id']").val();
		jQuery("select.cbb-recommendations-variant-select").find('option').each(
			function (ix, em) {
				var current_variant_id = jQuery(em).attr('data-variant-id');
				if (current_variant_id == current_selected_value) {
					var value_to_set = jQuery(em).val();
					jQuery("select.cbb-recommendations-variant-select").eq(0).val(
						value_to_set);
					jQuery("select.cbb-recommendations-variant-select").trigger('change');
				}
			});
	}, 200);
});
jQuery(document).ready(function (e) {
	jQuery("a.banner_info_icon").on('click', function (e) {
		e.preventDefault();
		var current_target = e.target;
		var popup_text = "";
		popup_text = jQuery("a.banner_info_icon").attr('data-swal-text');
		var popup_text_div = document.createElement('div');
		popup_text_div.innerHTML = popup_text;
		swal({
			title: "",
			content: popup_text_div,
			icon: "info",
			buttons: false,
			closeModal: true
		});
	});

	jQuery(".header-timer a.banner_info_icon").on('click', function (e) {
		e.preventDefault();
		var current_target = e.target;
		var popup_text = "";
		popup_text = jQuery(".header-timer a.banner_info_icon").attr('data-swal-text');
		var popup_text_div = document.createElement('div');
		popup_text_div.innerHTML = popup_text;
		swal({
			title: "",
			content: popup_text_div,
			icon: "info",
			buttons: false,
			closeModal: true
		});
	});

});
// Shipping Info Popup 
jQuery(".shipping_info_icon").on('click', function () {
	var popup_shippinginfo = "";
	popup_shippinginfo = jQuery(".free_shipping-text").attr('data-swal-info');
	var popup_shippinginfo_div = document.createElement('div');
	popup_shippinginfo_div.innerHTML = popup_shippinginfo;
	swal({
		title: "",
		content: popup_shippinginfo_div,
		button: "I GET IT!",
		closeModal: true
	});
});

jQuery(window).on('load', function () {
	if (jQuery(".product-icons .product-icons-row > div").length) {
		jQuery('.product-icons .product-icons-row').slick({
			lazyLoad: 'ondemand',
			dots: false,
			arrow: true,
			infinite: false,
			speed: 300,
			slidesToShow: 8,
			slidesToScroll: 1,
			responsive: [
				{
					breakpoint: 1024,
					settings: {
						slidesToShow: 6,
						slidesToScroll: 1
					}
				},
				{
					breakpoint: 767,
					settings: {
						slidesToShow: 4,
						slidesToScroll: 1
					}
				},
				{
					breakpoint: 480,
					settings: {
						slidesToShow: 4,
						slidesToScroll: 1
					}
				}
			]
		});
	}

	// if(typeof subscription_product_info  !== "undefined") {
	// 	// Get Price Of Subscribe product
	// 	var variant_to_dup_id = subscription_product_info.variant_to_duplicate;
	// 	var variant_to_dup_price = subscription_product_info.duplicate_to_price;
	// 	var current_p =  jQuery('[name="id"]').val();
	// 	var this_formate = jQuery(".subscribe_info_wrapper .subscribe_price p").data('money-format');
	// 	var New_variant_id = jQuery.map(variant_to_dup_id, function(value, key) {
	// 		if (key == current_p) {
	// 			return value;
	// 		}
	// 	});

	// 	jQuery(".subscription_offer_value .subscribe_info_wrapper .subscribe_price p").html(Shopify.formatMoney(variant_to_dup_price[New_variant_id],this_formate)); 
	// 	jQuery(".subscription_offer_value .subscribe_info_wrapper .subscribe_price p.discounted_price").append(' USD');
	// }

});

jQuery(document).ready(function (e) {
	jQuery('.product-cart-box .form-group').each(function () {
		var checked_val = jQuery(this).find('input:checked').next('label').text();

		jQuery(this).find('.form-check.init').html(checked_val);

		jQuery(this).children('.form-check:not(.init)').wrapAll("<div class='form-check-wrapper'></div>");
		jQuery(this).find("input[type='radio'][disabled]").closest('.form-check').addClass('d-none');
	});


	jQuery(".product-cart-box .form-group").on("click", ".init", function () {
		jQuery(this).closest(".form-group").children('.form-check-wrapper').slideToggle();
	});

	var allOptions = jQuery(this).closest(".form-group").children('.form-check:not(.init)');
	jQuery(".product-cart-box .form-group").on("click", ".form-check:not(.init)", function () {
		jQuery(this).closest(".form-group").children('.form-check:not(.init)').removeClass('selected');
		jQuery(this).addClass('selected');
		jQuery(this).closest(".form-group").children('.init').html(jQuery(this).find('label').html());
		jQuery(this).closest(".form-group").children('.form-check-wrapper').slideUp();
	});

});

//   Update Price Of Subscribe product on Variant change

function update_rechargeprice(product_id) {
	//   Change Accoriding Variant On change variant
	jQuery('.product-cart-box .form-check').each(function () {
		if (jQuery(this).find("input[type='radio']").is(':enabled')) {
			jQuery(this).find("input[type='radio']").closest('.form-check').removeClass('d-none');
		}
		else {
			jQuery(this).find("input[type='radio']").closest('.form-check').addClass('d-none');
		}
	});
}


// Show Extended Note on cart page
jQuery(document).ready(function () {
	if (typeof cart_page_selling_out != "undefined") {
		jQuery(".cart .item").each(function (ix, em) {
			var current_cart_item = jQuery(em);
			var current_cart_pid = jQuery(em).attr('data-productid');
			if (typeof cart_page_selling_out[current_cart_pid.toString()] !== "undefined") {
				var message_text = cart_page_selling_out[current_cart_pid];
				current_cart_item.find('span.cart-high-demand').html(message_text);
			}
		});
	}

});

// Product Image change when its on first index

jQuery('.product-nav-slider .slide-item.slick-active').on('click', function () {
	var current_slide = jQuery(this).attr('data-slick-index');
	var current_slide_img = jQuery(this).find('img').attr('data-srcset2x-img');
	if (current_slide == 0) {
		jQuery("#product-content-slider0").slick('slickGoTo', 0);
		jQuery("#product-content-slider0 .slick-active").find('img').attr('src',
			'');
		jQuery("#product-content-slider0 .slick-active").find('img').attr(
			'srcset', current_slide_img);
	}
});


// Product Image change when its on first index End

jQuery(document).ready(function () {
	jQuery('.form-check-input').on('click', function (e) {
		if (jQuery(this).parent().hasClass("selected")) {
			jQuery(this).trigger('change');
		}
	});
});


// Side Cart Popup Js Start

// Open Cart Popup

jQuery('.site-header__cart').on("click", function (e) {
	e.preventDefault();
	update_cart_popup();
	//do_console('G1');

});

jQuery(document).ready(function () {
	jQuery(".btn_checkout").on("click", function () {

		if (jQuery(".ajax_cart_data_html .item .cart_line_items") > 0) {

		}
		else {
			jQuery("form[name='checkout']").submit();
		}
	});
});
// Close Cart Popup

jQuery(document).ready(function () {
	jQuery('.close-cart-popup').on("click", function (e) {
		e.preventDefault();
		jQuery('.side-cart-popup').removeClass('open');
		jQuery('.modalOverlay').fadeOut();
		jQuery('body').removeClass('overflow-hidden');
	});


	jQuery(document).click(function (e) {
		var container = jQuery(".side-cart-popup");
		if (!container.is(e.target) && container.has(e.target).length === 0) {
			container.removeClass('open');
			jQuery('.modalOverlay').fadeOut();
			jQuery('body').removeClass('overflow-hidden');
		}
	});

	// Update Cart Quantity on Change
	if (jQuery("[data-cart-popup]").length > 0 && jQuery("body.template-cart").length == 0) {
		/* do_console("2421");*/
		jQuery(document).on('change', "[name='updates[]']", function (e) {
			jQuery("[name='update']").click(function (e) {
				e.stopPropagation();
			});
			var product_id_to_change = jQuery(this).attr("data-product-id");
			var selected_quntity = jQuery(this).children("option:selected").val();
			jQuery.ajax({
				url: shop_url + '/cart/change.js',
				method: "POST",
				dataType: "JSON",
				data: {
					'id': product_id_to_change,
					'quantity': selected_quntity
				},
				success: function (data) {
					update_cart_popup();
				}
			})
		});
	}
})

// Remove Item From Cart

jQuery(document).on('click', ".ajax_cart_data_html .remove-item", function (e) {
	e.preventDefault();
	var forloop_index = jQuery(this).attr("data-cart-remove");
	var item_quntity = 0;
	jQuery.ajax({
		url: shop_url + '/cart/change.js',
		method: "POST",
		dataType: "JSON",
		data: {
			'line': forloop_index,
			'quantity': item_quntity
		},
		success: function (data) {
			update_cart_popup();
			var selected_qunty = jQuery('.quantity_select .form-control.b-color').children("option:selected").val();
			var valueToUpdate = parseInt(jQuery(".nav-item.nav-shop .badge").text()) - selected_qunty;
			jQuery(".nav-shop-mobile .badge").text(valueToUpdate.toString());
			jQuery(".nav-item.nav-shop .badge").text(valueToUpdate.toString());
		}
	});
});



// Get Cart Value using Ajax

function update_cart_popup() {
	jQuery.ajax({
		url: '/cart?view=popup',
		method: "GET",
		success: function (data) {

			calcMaxHeightSideCart();

			var raw_data = data.trim();
			var json_data = JSON.parse(raw_data);
			var cart_json = json_data.cart_json;
			var cart_total_price = cart_json.items_subtotal_price;
			var did_get_free = false;
			freeshippingbar(cart_json);
			jQuery(".nav-shop-mobile .badge").text(json_data.cart_item_count);
			jQuery(".nav-item.nav-shop .badge").text(json_data.cart_item_count);
			//jQuery("div.ajax_cart_data_html").html(json_data.cart_html_markup);
			//jQuery("[data-cart-subtotal]").html(json_data.cart_sub_total);
			//jQuery("[data-cart-count]").text(json_data.cart_item_count);

			// if free product selected in settings 
			jQuery(cart_json.items).each(function (ix, em) {
				do_console('OP Cart Update');
				var timestamp = Math.floor(Date.now() / 1000);
				if (typeof OneSignal != "undefined") {
					OneSignal.push(function () {
						OneSignal.sendTags({
							cart_update: timestamp,
							product_name: em.product_title,
							product_image: em.image,
						}).then(function (tagsSent) {
							// Callback called when tags have finished sending
							do_console(tagsSent);
						});
					});
				}
			});

			if (jQuery('.Side_Cart_free_product').length) {
				var free_product_variant_id = jQuery('.Side_Cart_free_product').attr('data-productid');
				var fre_pro_min_amnt = parseFloat(jQuery('.Side_Cart_free_product').attr('data-min-amnt'));
				var new_cart_total = '';
				var cart_current_count = parseFloat(jQuery('.js-cart_subtotal .price').attr('data-cart-total-money'));
				var free_prod_price = jQuery('.Side_Cart_free_product').attr('data-pro-price');

				var this_formate = jQuery('.Side_Cart_free_product').attr('data-money-format');

				jQuery(cart_json.items).each(function (ix, em) {
					var item_id = em.product_id;
					if (item_id == free_product_variant_id) {
						did_get_free = true;
						new_cart_total = cart_current_count;
						do_console('when pro is not added=' + new_cart_total);

					} else {
						new_cart_total = cart_current_count - free_prod_price;
						do_console('product-adde-' + new_cart_total);
					}
				});

				if (did_get_free == false) {

					if (cart_total_price > fre_pro_min_amnt) {
						var free_product = jQuery('.Side_Cart_free_product').attr('data-free-product');
						data_to_send = {
							'quantity': 1,
							'id': free_product,
						}
						do_console(3012);
						jQuery.ajax({
							url: '/cart/add.js',
							method: "POST",
							dataType: "JSON",
							data: data_to_send,
							success: function (data) {
								sendOneSignalTags(data.product_title, data.image);
								if(typeof window.customer_email !== 'undefined') {
									window.liQ = window.liQ || [];
									window.liQ.push({
									"event": "addToCart",
									"email": window.customer_email
									});
								}
								jQuery.ajax({
									url: '/cart?view=popup',
									method: "GET",
									success: function (data) {
										var raw_data = data.trim();
										var json_data = JSON.parse(raw_data);
										jQuery("div.ajax_cart_data_html").html(json_data.cart_html_markup);
										jQuery("[data-cart-subtotal]").html(json_data.cart_sub_total);
										//jQuery("[data-cart-subtotal]").html(Shopify.formatMoney(new_cart_total,this_formate));
										jQuery("[data-cart-count]").text(json_data.cart_item_count);
										setTimeout(function () {
											jQuery('.side-cart-popup').addClass('open');
											jQuery('.modalOverlay').fadeIn();
											jQuery('body').addClass('overflow-hidden');
											do_console("Add to cart Done");
										}, 1000);
									},
								});
							},
							error: function (data) {
								if (typeof data.responseJSON.description !== "undefined") {
									var message = data.responseJSON.description;
								} else {
									var message = "Please try again later!";
								}
							}
						});
					} else {

						jQuery("div.ajax_cart_data_html").html(json_data.cart_html_markup);
						jQuery("[data-cart-subtotal]").html(json_data.cart_sub_total);
						//jQuery("[data-cart-subtotal]").html(Shopify.formatMoney(new_cart_total,this_formate));
						jQuery("[data-cart-count]").text(json_data.cart_item_count);
						setTimeout(function () {
							jQuery('.side-cart-popup').addClass('open');
							jQuery('.modalOverlay').fadeIn();
							jQuery('body').addClass('overflow-hidden');
							do_console("Cart Count is low-- Free Pro. Not Added");
						}, 1000);
					}
				} else {
					if (cart_total_price > fre_pro_min_amnt) {
						jQuery("div.ajax_cart_data_html").html(json_data.cart_html_markup);
						jQuery("[data-cart-subtotal]").html(json_data.cart_sub_total);
						//jQuery("[data-cart-subtotal]").html(Shopify.formatMoney(new_cart_total,this_formate));
						jQuery("[data-cart-count]").text(json_data.cart_item_count);

						setTimeout(function () {
							jQuery('.side-cart-popup').addClass('open');
							jQuery('.modalOverlay').fadeIn();
							jQuery('body').addClass('overflow-hidden');
							do_console("Cart Count is low-- Free Pro. Not Added");
						}, 1000);
					} else {
						var free_product = jQuery('.Side_Cart_free_product').attr('data-free-product');
						var data = { updates: {} };
						data.updates[free_product] = 0;
						jQuery.ajax({
							url: '/cart/update.js',
							method: "POST",
							dataType: "JSON",
							data: data,
							success: function (data) {
								jQuery.ajax({
									url: '/cart?view=popup',
									method: "GET",
									success: function (data) {
										var raw_data = data.trim();
										var json_data = JSON.parse(raw_data);
										jQuery("div.ajax_cart_data_html").html(json_data.cart_html_markup);
										jQuery("[data-cart-subtotal]").html(json_data.cart_sub_total);
										//jQuery("[data-cart-subtotal]").html(Shopify.formatMoney(new_cart_total,this_formate));
										jQuery("[data-cart-count]").text(json_data.cart_item_count);
										setTimeout(function () {
											jQuery('.side-cart-popup').addClass('open');
											jQuery('.modalOverlay').fadeIn();
											jQuery('body').addClass('overflow-hidden');
											do_console("Add to cart not done");
										}, 1000);
									},
								});
							},
							error: function (data) {
								if (typeof data.responseJSON.description !== "undefined") {
									var message = data.responseJSON.description;
								} else {
									var message = "Please try again later!";
								}
							}
						});
					}
				}
			} else {
				jQuery("div.ajax_cart_data_html").html(json_data.cart_html_markup);
				jQuery("[data-cart-subtotal]").html(json_data.cart_sub_total);
				jQuery("[data-cart-count]").text(json_data.cart_item_count);
				jQuery('.side-cart-popup').addClass('open');
				jQuery('.modalOverlay').fadeIn();
				jQuery('body').addClass('overflow-hidden');
			}

			jQuery("div.ajax_cart_data_html").find('.cart-h3').each(function (ix, em) {
				var name = jQuery(em).text();
				//do_console(name);
				var upsell_product = jQuery(".Single_product_wrapper .item .cart-h3").text();
				//do_console(upsell_product);
				if (name === upsell_product) {
					jQuery(".Single_product_wrapper").hide();
					do_console("is match");
				}
			});

			//jQuery('.side-cart-popup').addClass('open');	

			var promocode = '';
			// check cookie 
			if (getCookie("discount_code")) {
				promocode = getCookie("discount_code");
				//do_console("is there cookie");	
			} else {
				promocode = localStorage.getItem("couponname");
				//do_console("is there no cookie");	
			}
			jQuery('.loader_img').hide();
			jQuery('#promo-code').val("");
			jQuery(document).on('click', "#promo-code-apply-btn", function (event) {
				//do_console("is clicked");
				event.preventDefault();
				var delay = 3000;
				entered_promocode = jQuery('#promo-code').val();
				if (entered_promocode == "") {
					jQuery('.side-cart-popup').removeClass('open');
					jQuery('.modalOverlay').fadeOut();
					jQuery('body').removeClass('overflow-hidden');
					swal({
						icon: 'error',
						title: 'Oops...',
						text: 'Please enter a discount code'
					});
				} else {
					if (entered_promocode == promocode) {
						do_console("yes is matched");
						jQuery('.loader_img').show();
						jQuery(this).hide();
						setTimeout(function () {
							window.location = shop_url + "/cart";
						}, delay);
					} else {
						do_console("is matched");
						// set Cookie
						entered_promocode = jQuery('#promo-code').val();


						//setCookie("discount_code", entered_promocode);
						//var d = new Date();
						//d.setTime(d.getTime() + (24 * 60 * 60 * 1000));
						//var expires = "expires="+d.toUTCString();
						//document.cookie = "discount_code=" + entered_promocode + ";" + expires + ";path=/";  

						localStorage.setItem("couponname", entered_promocode);
						jQuery('.loader_img').show();
						jQuery(this).hide();
						setTimeout(function () {
							window.location = shop_url + "/cart";
						}, delay);
					}
				}
			});
			//    
			if (jQuery(".cart_line_items").length > 0) {
				jQuery("#cart-discount-data").hide();
			} else {
				jQuery("#cart-discount-data").show();
			}
			//jQuery('.modalOverlay').fadeIn();
			//jQuery('body').addClass('overflow-hidden');

			// fbt section

			if (jQuery('.side_cart_footer .fbt_wrapper').length) {
				var fbt = jQuery('.cbb-frequently-bought-container').html();
				if (jQuery('.cbb-frequently-bought-recommendations-container').length > 1) {

				} else {
					jQuery('.side_cart_footer .fbt_wrapper').append(fbt);
				}
			}
			calcMaxHeightSideCart();
		}
	});
}


// Side Cart Popup Js End


function calcMaxHeightSideCart() {
	// set window height
	if (jQuery('.side-cart-popup-banner-img').length > 0) {
		if (jQuery(window).width() > 767) {
			var hederheight = jQuery('.side-cart-popup-header').outerHeight();
			var bannerheight = jQuery('.side-cart-popup-banner-img').outerHeight();
			var footer_height = jQuery(".side_cart_footer").outerHeight();
			var window_height = jQuery(".side-cart-popup").outerHeight();

			var total_height = hederheight + bannerheight + footer_height;
			var items_height = window_height - total_height;
			jQuery(".ajax_cart_data_html").css({ "height": items_height });
		}
		else {
			var hederheight = jQuery('.side-cart-popup-header').outerHeight();
			var footer_height = jQuery(".side_cart_footer").outerHeight();
			var window_height = jQuery(".side-cart-popup").outerHeight();
			var total_height = hederheight + footer_height;
			var items_height = window_height - total_height;
			jQuery(".ajax_cart_data_html").css({ "height": items_height });
		}
	}
	else {
		var notesheight = jQuery('.side-cart-popup-notes').outerHeight();
		var hederheight = jQuery('.side-cart-popup-header').outerHeight();
		var footer_height = jQuery(".side_cart_footer").outerHeight();
		var window_height = jQuery(".side-cart-popup").outerHeight();

		var total_height = notesheight + hederheight + footer_height;

		var items_height = window_height - total_height;
		jQuery(".ajax_cart_data_html").css("height", items_height);
	}
};


jQuery(window).on('resize', function () {
	calcMaxHeightSideCart();
});

jQuery(document).ready(function () {
	calcMaxHeightSideCart();

	if (jQuery('[data-add-to-cart] [name="color"]').length) {
		jQuery('.form-check-input').on('click', function (e) {
			if (jQuery(this).parent().hasClass("selected")) {
				jQuery(this).trigger('change');
			}
		});
	}

	if (jQuery(window).height() < 800) {
		jQuery('.side-cart-popup .fbt_wrapper').hide();
	}

	// Easter Egg JS
	var data_url = "";

	jQuery(".easeter_popup").on("click", function (e) {
		e.preventDefault();
		data_url = jQuery(this).attr('data-url');
		jQuery('#easter_popup_overlay').fadeIn();
		jQuery('#easter_popup').fadeIn();
		jQuery('body').addClass("is_easterpopup_open");
		jQuery('body').addClass("overflow-hidden");

		var easter_image = jQuery(this).attr("data-e-image");
		var discount_code = jQuery(this).attr("data-e-dcode");
		var easter_desc = jQuery(this).attr("data-e-desc");
		var easter_howto = jQuery(this).attr("data-e-redeem");
		var hover_info_text = jQuery(this).attr("data-e-info");

		do_console(hover_info_text);

		jQuery("#easter_popup .popup_modal .popup-body .popup_code .popup_img img").attr("src", easter_image);
		jQuery("#easter_popup .popup_modal .popup-body .popup_code .popup_code_text p span b").text(discount_code);
		jQuery("#easter_popup .popup_modal .popup-body .popup_code .popup_code_text p.deal span").text(easter_desc);
		jQuery("#easter_popup .popup_modal .popup-body .popup_code .popup_code_text .prod_info h2").text(easter_howto);
		jQuery("#easter_popup .popup_modal .popup-body .popup_code .popup_code_text .prod_info .icon_info .eag-note").text(hover_info_text);

	});
	data_url

	// Collection page Close_Popup
	jQuery("#easter_popup .close_popup").click(function (e) {
		e.preventDefault();
		jQuery('#easter_popup_overlay').fadeOut();
		jQuery('#easter_popup').fadeOut();
		jQuery('body').removeClass("is_easterpopup_open");
		jQuery('body').removeClass("overflow-hidden");
		window.location.href = data_url;
	});

	// Collection page clode Overlay Popup
	jQuery('#easter_popup_overlay').click(function (e) {
		e.preventDefault();
		jQuery(this).hide();
		jQuery('#easter_popup').fadeOut();
		jQuery('body').removeClass("is_easterpopup_open");
		jQuery('body').removeClass("overflow-hidden");
		window.location.href = data_url;
	});

	if (jQuery(".popup_code_text .icon_info").length) {

		jQuery(".popup_code_text .icon_info a").hover(function () {
			jQuery(".eag-note").fadeIn();
		});
		jQuery(".popup_code_text .icon_info a").mouseout(function () {
			jQuery(".eag-note").fadeOut();
		});
	}

	// Product page Popup
	var data_pro_url = "";
	jQuery(".template-product .easeter_popup.you_may_also").on("click", function (e) {
		e.preventDefault();
		data_pro_url = jQuery(this).attr('data-url');
		jQuery('#easter_popup').addClass('yo_may_like');
		jQuery('#easter_popup_overlay_product').fadeIn();
	});
	// if(jQuery( ".easeter_popup_product" ).length ){
	// 	jQuery(document).on( "click", ".easeter_popup_product", function( e ){
	// 		e.preventDefault();
	// 		data_url = jQuery(this).attr('data-url');
	// 		jQuery('#easter_popup_overlay_product').fadeIn();  
	// 		jQuery('#easter_popup').fadeIn();
	// 		jQuery('body').addClass("is_easterpopup_open");
	// 		jQuery('body').addClass("overflow-hidden");

	// 		var easter_image = jQuery(this).attr("data-e-image");
	// 		var discount_code = jQuery(this).attr("data-e-dcode");
	// 		var easter_desc = jQuery(this).attr("data-e-desc");
	// 		var easter_howto = jQuery(this).attr("data-e-redeem");
	// 		var hover_info_text = jQuery(this).attr("data-e-info");

	// 		jQuery("#easter_popup .popup_modal .popup-body .popup_code .popup_img img"). attr("src", easter_image);
	// 		jQuery("#easter_popup .popup_modal .popup-body .popup_code .popup_code_text p span b").text(discount_code);
	// 		jQuery("#easter_popup .popup_modal .popup-body .popup_code .popup_code_text p.deal span").text(easter_desc);
	// 		jQuery("#easter_popup .popup_modal .popup-body .popup_code .popup_code_text .prod_info h2").text(easter_howto);
	// 		jQuery("#easter_popup .popup_modal .popup-body .popup_code .popup_code_text .prod_info .icon_info .eag-note").text(hover_info_text);

	// 	});
	// }

	// Product page Close_Popup
	jQuery("#easter_popup .close_product_popup").click(function (e) {
		if (jQuery('#easter_popup').hasClass('collection_popup')) {
			e.preventDefault();
			jQuery('#easter_popup').fadeOut();
			jQuery('body').removeClass("is_easterpopup_open");
			jQuery('body').removeClass("overflow-hidden");
			jQuery('#easter_popup').removeClass('collection_popup');
			jQuery('#easter_popup_overlay_product').fadeOut();
		} else if (jQuery('#easter_popup').hasClass('yo_may_like')) {
			e.preventDefault();
			jQuery('#easter_popup_overlay_product').fadeOut();
			jQuery('#easter_popup').fadeOut();
			jQuery('body').removeClass("is_easterpopup_open");
			jQuery('body').removeClass("overflow-hidden");
			jQuery('#easter_popup').removeClass('yo_may_like');
			window.location.href = data_pro_url;
		}
		else {
			var totalquantity = parseInt(jQuery("form#addtocart #item_Quantity").val());
			e.preventDefault();
			jQuery('#easter_popup_overlay_product').fadeOut();
			jQuery('#easter_popup').fadeOut();
			jQuery('body').removeClass("is_easterpopup_open");
			jQuery('body').removeClass("overflow-hidden");
			var product_id = jQuery("form#addtocart input[name='id']").val();

			if (jQuery(".subscription_value.product_add .subscription-freq").length) {
				jQuery(".subscription_value.product_add .subscription-freq option:selected").each(function (ix, em) {
					var sub_val = jQuery(em).val();
					if (sub_val == 'subscribe-save') {
						var subscription_variant_id = jQuery(em).attr("data-subscription-id-to-add");
						var selectedfrequency = jQuery(em).attr("data-freq");
						var selectedfrequencyunit = jQuery(em).attr('data-unit');
						var line_properties = {};
						line_properties.subscription_id = subscription_variant_id;
						line_properties.shipping_interval_frequency = selectedfrequency;
						line_properties.shipping_interval_unit_type = selectedfrequencyunit;
						line_properties.selling_plan_id = $(this).attr('selling_plan_id');
						data_to_send = {
							'quantity': totalquantity,
							'id': product_id,
							properties: line_properties
						}
					} else {
						data_to_send = {
							'quantity': totalquantity,
							'id': product_id
						}
					}
				});
			} else {
				var data_to_send = {
					'quantity': totalquantity,
					'id': product_id
				}
			}
			do_console(3424);
			jQuery.ajax({
				url: '/cart/add.js',
				method: "POST",
				dataType: "JSON",
				data: data_to_send,
				success: function (data) {
					sendOneSignalTags(data.product_title, data.image);
					if(typeof window.customer_email !== 'undefined') {
						window.liQ = window.liQ || [];
						window.liQ.push({
						"event": "addToCart",
						"email": window.customer_email
						});
					}
					update_cart_popup();
					jQuery(".nav-item.nav-shop .badge").show();
					jQuery(".nav-shop-mobile .badge").show();
					jQuery(".nav-item.nav-shop .badge").show();
					jQuery(".nav-shop-mobile .badge").show();
					var valueToUpdate = parseInt(jQuery(".nav-item.nav-shop .badge").text()) +
						totalquantity;
					jQuery(".nav-shop-mobile .badge").text(valueToUpdate.toString());
					jQuery(".nav-item.nav-shop .badge").text(valueToUpdate.toString());
					jQuery("#crtbtn1").removeAttr("disabled");
					jQuery("#addtocart").removeClass("is-uploading");
				},
				error: function (data) {
					if (typeof data.responseJSON.description !== "undefined") {
						var message = data.responseJSON.description;
					} else {
						var message = "Please try again later!";
					}
					swal({
						title: "Oops!!",
						text: message,
						icon: "error",
						className: "add-ajax-outofstock",
						buttons: false,
						timer: 1500
					});
				}
			});
		}
	});

	// Product page Close_overlay
	jQuery('#easter_popup_overlay_product').click(function (e) {
		if (jQuery('#easter_popup').hasClass('collection_popup')) {
			e.preventDefault();
			jQuery(this).hide();
			jQuery('#easter_popup').fadeOut();
			jQuery('body').removeClass("is_easterpopup_open");
			jQuery('body').removeClass("overflow-hidden");
			jQuery('#easter_popup').removeClass('collection_popup');
		} else if (jQuery('#easter_popup').hasClass('yo_may_like')) {
			e.preventDefault();
			jQuery('#easter_popup').fadeOut();
			jQuery('body').removeClass("is_easterpopup_open");
			jQuery('body').removeClass("overflow-hidden");
			jQuery('#easter_popup').removeClass('yo_may_like');
			jQuery('#easter_popup_overlay_product').fadeOut();
			window.location.href = data_pro_url;
		} else {
			var totalquantity = parseInt(jQuery("form#addtocart #item_Quantity").val());
			e.preventDefault();
			jQuery('#easter_popup_overlay_product').fadeOut();
			jQuery('#easter_popup').fadeOut();
			jQuery('body').removeClass("is_easterpopup_open");
			jQuery('body').removeClass("overflow-hidden");
			var product_id = jQuery("form#addtocart input[name='id']").val();

			if (jQuery(".subscription_value.product_add .subscription-freq").length) {
				jQuery(".subscription_value.product_add .subscription-freq option:selected").each(function (ix, em) {
					var sub_val = jQuery(em).val();
					if (sub_val == 'subscribe-save') {
						var subscription_variant_id = jQuery(em).attr("data-subscription-id-to-add");
						var selectedfrequency = jQuery(em).attr("data-freq");
						var selectedfrequencyunit = jQuery(em).attr('data-unit');
						var line_properties = {};
						line_properties.subscription_id = subscription_variant_id;
						line_properties.shipping_interval_frequency = selectedfrequency;
						line_properties.shipping_interval_unit_type = selectedfrequencyunit;
						line_properties.selling_plan_id = $(this).attr('selling_plan_id');
						data_to_send = {
							'quantity': totalquantity,
							'id': product_id,
							properties: line_properties
						}
					} else {
						data_to_send = {
							'quantity': totalquantity,
							'id': product_id
						}
					}
				});
			} else {
				var data_to_send = {
					'quantity': totalquantity,
					'id': product_id
				}
			}
			do_console(3525);
			jQuery.ajax({
				url: '/cart/add.js',
				method: "POST",
				dataType: "JSON",
				data: data_to_send,
				success: function (data) {
					sendOneSignalTags(data.product_title, data.image);
					update_cart_popup();
					if(typeof window.customer_email !== 'undefined') {
						window.liQ = window.liQ || [];
						window.liQ.push({
						"event": "addToCart",
						"email": window.customer_email
						});
					}
					jQuery(".nav-item.nav-shop .badge").show();
					jQuery(".nav-shop-mobile .badge").show();
					jQuery(".nav-item.nav-shop .badge").show();
					jQuery(".nav-shop-mobile .badge").show();
					var valueToUpdate = parseInt(jQuery(".nav-item.nav-shop .badge").text()) +
						totalquantity;
					jQuery(".nav-shop-mobile .badge").text(valueToUpdate.toString());
					jQuery(".nav-item.nav-shop .badge").text(valueToUpdate.toString());
					jQuery("#crtbtn1").removeAttr("disabled");
					jQuery("#addtocart").removeClass("is-uploading");
				},
				error: function (data) {
					if (typeof data.responseJSON.description !== "undefined") {
						var message = data.responseJSON.description;
					} else {
						var message = "Please try again later!";
					}
					swal({
						title: "Oops!!",
						text: message,
						icon: "error",
						className: "add-ajax-outofstock",
						buttons: false,
						timer: 1500
					});
				}
			});
		}
	});

	// Popup Show only on category Page
	if (jQuery('#category_easter_popup').length) {
		setTimeout(function () {
			jQuery('#easter_category_popup_overlay').fadeIn();
			jQuery('#category_easter_popup').fadeIn();
			jQuery('body').addClass("is_easterpopup_open");
			jQuery('body').addClass("overflow-hidden");
		}, 5000); // 5000 to load it after 5 seconds from page load
	}
	// Popup Close only on category Page
	jQuery("#category_easter_popup .close_category_popup").click(function (e) {
		e.preventDefault();
		jQuery('#easter_category_popup_overlay').fadeOut();
		jQuery('#category_easter_popup').fadeOut();
		jQuery('body').removeClass("is_easterpopup_open");
		jQuery('body').removeClass("overflow-hidden");
	});

	// category page close Overlay Popup
	jQuery('#easter_category_popup_overlay').click(function (e) {
		e.preventDefault();
		jQuery(this).hide();
		jQuery('#category_easter_popup').fadeOut();
		jQuery('body').removeClass("is_easterpopup_open");
		jQuery('body').removeClass("overflow-hidden");
	});

	// sidecart-js start
	if (jQuery("#banner_img").length) {
		jQuery(".side-cart-popup-notes").hide();
		var get_cart_img = jQuery("#banner_img").attr("data-image");
		var get_cart_url = jQuery("#banner_img").attr("data-url");
		jQuery(".side-cart-popup .side-cart-popup-banner-img img").attr("src", get_cart_img);
		if(get_cart_url.toString().trim() !== "") {
			jQuery(".side-cart-popup .side-cart-popup-banner-img img").wrap(`<a href="${get_cart_url.toString().trim()}"></a>`);
		}
	}
	else {

		jQuery(".side-cart-popup-banner-img").hide();

		var get_title = jQuery("#banner_text").attr("data-title");
		var get_title_color = jQuery("#banner_text").attr("data-title-color");

		var get_info = jQuery("#banner_text").attr("data-info");
		var get_info_color = jQuery("#banner_text").attr("data-info-color");

		var bg_popup_color = jQuery("#banner_text").attr("data-info-bg-color");

		jQuery(".side-cart-popup-notes").css({ "background-color": bg_popup_color });

		jQuery(".side-cart-popup-notes h2").text(get_title);
		jQuery(".side-cart-popup-notes h2").css({ "color": get_title_color });

		jQuery(".side-cart-popup-notes p").text(get_info);
		jQuery(".side-cart-popup-notes p").css({ "color": get_info_color });
	}
	// sidecart-js end


	// Show More Blog Btn Js

	jQuery(".show_hidden_tag").on("click", function (e) {
		e.preventDefault();
		jQuery(this).hide();
		jQuery(".filter_wrapper .blog_filtter .filtter_tag .is-hidden_tag").show();
	});

	// Show More Blog Btn Js End

	// Blog Post JS For CB Fonts Start

	jQuery("link").each(function (ix, em) {
		if (typeof jQuery(em).attr('href') !== 'undefined' && jQuery(em).attr('href').trim().indexOf('Quicksand') !== -1) {
			do_console('got inside');
			jQuery("section.blog-post").attr("style", "font-family:'Quicksand'");
		}
	});
	// Blog Post JS For CB Fonts End

});


// On Scroll Product Page

jQuery(window).on('scroll', function () {
	if (jQuery('#product-sticky').length > 0) {
		var window_top = jQuery(window).scrollTop();
		var btn_cart = jQuery("#crtbtn1").offset().top;
		var half_window_height = jQuery(window).height() / 1.2;
		var heder_height = jQuery(".navbar-custom").outerHeight();
		var top = jQuery('.product-about').offset().top - btn_cart;
		if (window_top > btn_cart) {
			jQuery('#product-sticky').fadeIn();
			jQuery('#product-sticky').addClass('issticky');
			jQuery('#product-sticky').css({ "top": heder_height });
		} else {
			jQuery('#product-sticky').fadeOut();
			jQuery('#product-sticky').removeClass('issticky');
		}
	}

});

// On Scroll Product Page End 


// Product Filter tag

jQuery(document).ready(function () {

	// Get Review Data
	var review_product_id = jQuery('.hidden_input_value').attr('data-productid');
	if (jQuery('.product-tag .tag a').length > 0) {
		for (var i = 1; i <= 4; i++) {
			jQuery.get('https://judge.me/reviews/reviews_for_widget?url=teamiblends-us.myshopify.com&shop_domain=teamiblends-us.myshopify.com&platform=shopify&page=' + i + '&per_page=100&product_id=' + review_product_id + '', function (data) {
				jQuery('.product-review-class').append(data.html);
			})
		}
	}

	// Check Review Tag

	// Check Review Tag

	jQuery('.product-tag .tag a').on('click', function (e) {
		e.preventDefault();
		jQuery("mark").each(function (ix, em) {
			jQuery(em).replaceWith(jQuery(em).html());
		});
		//jQuery(".jdgm-rev__cf-ans__value").removeClass("hightLight_text");
		jQuery(".product-review-class .jdgm-rev-widg__reviews").show();
		jQuery("#judgeme_product_reviews").hide();
		var tag_value = jQuery(this).attr('data-review-tag');
		tag_value = tag_value.toLowerCase();
		var count = 0;
		jQuery(".product-review-class .jdgm-rev-widg__reviews .jdgm-rev.jdgm-divider-top").each(function (index, element) {
			// Fetch Review Text
			var full_name = jQuery(element).find(".jdgm-rev__header .jdgm-rev__author-wrapper").attr("data-fullname");
			var find_name = jQuery(element).find(".jdgm-rev__header .jdgm-rev__author-wrapper .jdgm-rev__author");
			jQuery(find_name).text(full_name);

			var desc = jQuery(".jdgm-rev__cf-ans__value", jQuery(element)).text();
			desc = desc.toLowerCase();
			// Check if filter text is present			
			if (desc.indexOf(tag_value) > -1) {
				jQuery(element).show();
				count = count + 1;
				jQuery(".jdgm-rev__cf-ans__value", jQuery(element)).each(function (i, e) {
					var desc_text = jQuery(e).text();
					desc_text = desc_text.toLowerCase();
					if (desc_text.indexOf(tag_value) > -1) {
						//jQuery(e).addClass("hightLight_text");						
						var words = [];
						var words = desc_text.split(',');
						var w_l = words.length;
						var $new_string = "";

						if (words.length > 0) {
							jQuery(words).each(function (i, e) {
								if (e.indexOf(tag_value) > -1) {
									$new_string = "<mark>" + e + ",</mark>";
								}
								else {
									$new_string = $new_string + e;
									if (i !== (w_l - 1)) {
										$new_string = $new_string + ",";
									}
								}
							});
						}
						jQuery(e, jQuery(element)).html('').html($new_string);
					}
				});
			} else {
				jQuery(element).hide();

			}
		});
		if (count > 1) {
			jQuery(".error_msg").hide();
		} else {
			jQuery(".error_msg").show();
		}
	});

	// show all review
	jQuery(".show_all_reviews a").on("click", function (e) {
		e.preventDefault();
		jQuery(".product-review-class .jdgm-rev-widg__reviews").hide();
		jQuery("#judgeme_product_reviews").show();
		jQuery(".error_msg").hide();
	});

	// Upsell Side-Cart  Add Tocart Code

	jQuery(document).on('click', ".Add_single_product", function (e) {
		e.preventDefault();
		var totalquantity = 1;
		var variant_id = jQuery('.Single_product_wrapper .description').attr('data-variant-id');
		do_console(variant_id);
		do_console(totalquantity);
		var data_to_send = {
			'quantity': totalquantity,
			'id': variant_id
		}
		do_console(3774);
		jQuery.ajax({
			url: '/cart/add.js',
			method: "POST",
			dataType: "JSON",
			data: data_to_send,
			success: function (data) {
				sendOneSignalTags(data.product_title, data.image);
				if(typeof window.customer_email !== 'undefined') {
					window.liQ = window.liQ || [];
					window.liQ.push({
					"event": "addToCart",
					"email": window.customer_email
					});
				}
				update_cart_popup();
				jQuery('.Single_product_wrapper').hide();
			},
			error: function (data) {
				if (typeof data.responseJSON.description !== "undefined") {
					var message = data.responseJSON.description;
				} else {
					var message = "Please try again later!";
				}
			}
		});
	});

	jQuery(document).on('click', ".Add_single_product_cart", function (e) {
		e.preventDefault();
		var totalquantity = 1;
		var variant_id = jQuery('.Single_product_wrapper .description').attr('data-variant-id');
		do_console(variant_id);
		do_console(totalquantity);
		var data_to_send = {
			'quantity': totalquantity,
			'id': variant_id
		}
		do_console(3812);
		jQuery.ajax({
			url: '/cart/add.js',
			method: "POST",
			dataType: "JSON",
			data: data_to_send,
			success: function (data) {
				sendOneSignalTags(data.product_title, data.image);
				if(typeof window.customer_email !== 'undefined') {
					window.liQ = window.liQ || [];
					window.liQ.push({
					"event": "addToCart",
					"email": window.customer_email
					});
				}
				location.reload();
				jQuery('.Single_product_wrapper').hide();
			},
			error: function (data) {
				if (typeof data.responseJSON.description !== "undefined") {
					var message = data.responseJSON.description;
				} else {
					var message = "Please try again later!";
				}
			}
		});
	});

	// FAQ Page Back to top js

	if (jQuery('.back_srcoll').length) {
		var scrollTrigger = 100, // px
			backToTop = function () {
				var scrollTop = jQuery(window).scrollTop();
				if (scrollTop > scrollTrigger) {
					jQuery('.back_srcoll').addClass('show');
				} else {
					jQuery('.back_srcoll').removeClass('show');
				}
			};
		backToTop();
		jQuery(window).on('scroll', function () {
			backToTop();
		});
		jQuery('.back_srcoll').on('click', function (e) {
			e.preventDefault();
			jQuery('html,body').animate({
				scrollTop: 0
			}, 700);
		});
	}

	// FAQ PAge Form Search
	jQuery('#search_form').on('submit', function (e) {
		e.preventDefault();
		var searchWord = jQuery('#search_form input.form-control').val().toString().toLowerCase();
		jQuery("#accordion .card").each(function (ix, em) {
			if (jQuery(em).find(".card-link").text().trim().toLowerCase().indexOf(searchWord) != -1 || jQuery(em).find(".card-body").text().trim().toLowerCase().indexOf(searchWord) != -1) {
				jQuery(this).find('.collapse').addClass("show");
				var target = jQuery('.collapse.show');
				if (target.length) {
					event.preventDefault();
					jQuery('html, body').stop().animate({
						scrollTop: target.offset().top
					}, 1000);
				}
			} else {
				jQuery(this).find('.collapse').removeClass("show");
			}
		});
	});

	// FAQ PAge On click Scroll and open faq

	jQuery('.service_block').on('click', function (e) {
		var match_id = jQuery(this).attr('data-id');
		var is_true = false;
		jQuery("#accordion .card").each(function (ix, em) {
			var new_id = jQuery(this).attr('id');
			if (match_id == new_id) {
				jQuery(em).find('.collapse').addClass("show");
			} else {
				jQuery(em).find('.collapse').removeClass("show");
			}
		});
	});

	if (jQuery(window).width() < 991) {
		// do_console("is mobile");
		if (jQuery(".product-form__cart-submit.mobile-show").length) {
			jQuery(document).on('click', '.product-form__cart-submit.mobile-show', function (e) {
				var header_height = jQuery(".navbar-custom").outerHeight();
				var product_sticky_height = jQuery("#product-sticky").outerHeight();

				var top_height = header_height + product_sticky_height;
				e.preventDefault();
				jQuery(".mobile_popup").show();
				jQuery(".mobile_popup").css({ "top": top_height });
				jQuery(this).attr("disabled", "disabled");
			});
		}
		else {
			jQuery(".product_sticky_form").on("submit", function (e) {
				e.preventDefault();
				var $this = jQuery(this);
				var qnty = jQuery("#Quantity-product-template", $this).val();
				var totalquantity = parseInt(qnty);
				do_console(totalquantity);
				if (jQuery(".product-form__variants[data-variant-select-value]").length) {
					var varianttoadd = jQuery(".product-form__variants[data-variant-select-value]", $this).val();
				} else {
					var varianttoadd = jQuery("#variant_drfault").attr('data-varint-default');
				}
				var product_id = jQuery("#product-sticky .sticky-bar-inner").attr('data-productId');

				var data_to_send = {
					'quantity': totalquantity,
					'id': varianttoadd
				}
				do_console(3931);
				jQuery.ajax({
					url: '/cart/add.js',
					method: "POST",
					dataType: "JSON",
					data: data_to_send,
					success: function (data) {
						sendOneSignalTags(data.product_title, data.image);
						update_cart_popup();
						if(typeof window.customer_email !== 'undefined') {
							window.liQ = window.liQ || [];
							window.liQ.push({
							"event": "addToCart",
							"email": window.customer_email
							});
						}
					},
					error: function (data) {
						if (typeof data.responseJSON.description !== "undefined") {
							var message = data.responseJSON.description;
						} else {
							var message = "Please try again later!";
						}
					}
				});
			});
		}
	} else {
		jQuery(".product_sticky_form").on("submit", function (e) {
			e.preventDefault();
			var $this = jQuery(this);
			var qnty = jQuery("#Quantity-product-template", $this).val();
			var totalquantity = parseInt(qnty);
			do_console(totalquantity);
			if (jQuery(".product-form__variants[data-variant-select-value]").length) {
				var varianttoadd = jQuery(".product-form__variants[data-variant-select-value]", $this).val();
			} else {
				var varianttoadd = jQuery("#variant_drfault").attr('data-varint-default');
			}
			var product_id = jQuery("#product-sticky .sticky-bar-inner").attr('data-productId');

			var data_to_send = {
				'quantity': totalquantity,
				'id': varianttoadd
			}
			do_console(3976);
			jQuery.ajax({
				url: '/cart/add.js',
				method: "POST",
				dataType: "JSON",
				data: data_to_send,
				success: function (data) {
					sendOneSignalTags(data.product_title, data.image);
					update_cart_popup();
					if(typeof window.customer_email !== 'undefined') {
						window.liQ = window.liQ || [];
						window.liQ.push({
						"event": "addToCart",
						"email": window.customer_email
						});
					}
				},
				error: function (data) {
					if (typeof data.responseJSON.description !== "undefined") {
						var message = data.responseJSON.description;
					} else {
						var message = "Please try again later!";
					}
				}
			});
		});
	}

	jQuery('.product_sticky_form').on('submit', function (e) {
		e.preventDefault();
		var $this = jQuery(this);

		var qnty = jQuery("#Quantity-product-template", $this).val();
		var totalquantity = parseInt(qnty);
		do_console($this);
		if (jQuery(".product-form__variants[data-variant-select-value]", $this).length) {
			var varianttoadd = jQuery(".product-form__variants[data-variant-select-value]", $this).val();
		} else {
			var varianttoadd = jQuery("#variant_drfault").attr('data-varint-default');
		}
		var product_id = jQuery("#product-sticky .sticky-bar-inner").attr('data-productId');

		var data_to_send = {
			'quantity': totalquantity,
			'id': varianttoadd
		}
		do_console(4022);
		jQuery.ajax({
			url: '/cart/add.js',
			method: "POST",
			dataType: "JSON",
			data: data_to_send,
			success: function (data) {
				sendOneSignalTags(data.product_title, data.image);
				update_cart_popup();
				if(typeof window.customer_email !== 'undefined') {
					window.liQ = window.liQ || [];
					window.liQ.push({
					"event": "addToCart",
					"email": window.customer_email
					});
				}
				if (jQuery(window).width() < 991) {
					if (jQuery(".mobile_popup").length) {
						jQuery(".mobile_popup").hide();
						jQuery('.product-form__cart-submit.mobile-show').removeAttr("disabled", "disabled");
						jQuery(".product-form__cart-submit.mobile-show #AddToCartText-product-template").text("Add to Cart");
					}
				}
			},
			error: function (data) {
				if (typeof data.responseJSON.description !== "undefined") {
					var message = data.responseJSON.description;
				} else {
					var message = "Please try again later!";
				}
			}
		});
	});



	if (jQuery(".selector-wrapper.product-form__item").length > 1) {
		jQuery(".single-option-selector").on('change', function () {
			get_variant_id();
		});
	} else {
		jQuery(".single-option-selector").on('change', function () {
			get_single_variant_id();
		});
	}

	jQuery('.mobile_popup .close_popup a').on("click", function (e) {
		e.preventDefault();
		jQuery(".mobile_popup").hide();
		var preorder_text = jQuery("#AddToCart-product-template #AddToCartText-product-template").attr('data-preorder-btn');
		if (preorder_text) {
			jQuery(".product-form__cart-submit.mobile-show").removeAttr("disabled");
			jQuery(".product-form__cart-submit.mobile-show #AddToCartText-product-template").text(preorder_text);
		} else {
			jQuery(".product-form__cart-submit.mobile-show").removeAttr("disabled");
			jQuery(".product-form__cart-submit.mobile-show #AddToCartText-product-template").text("Add to Cart");
		}
	});

	if (jQuery(".product_sticky").length) {
		//IF single 
		if (jQuery(".product_sticky .single-option-selector").length == 1) {
			//DISABLE THE ONES NOT AVAILABLE
			jQuery(".product_sticky .single-option-selector").find('option').each(function (ix, em) {
				var option_val = jQuery(em).text().trim();
				do_console('option_val' + option_val);
				jQuery(".product_sticky select[name='product_variant']").find('option').each(function (ix2, em2) {
					var option_val_2 = jQuery(em2).text().trim().replace(" - Sold out", "");
					do_console('option_val_2' + option_val_2);
					if (option_val == option_val_2) {
						if (jQuery(em2).attr('disabled')) {
							jQuery(em).attr('disabled', 'disabled');
						} else {
							jQuery(em).removeAttr('disabled');
						}
					}
				});
			});
		} else if (jQuery(".product_sticky .single-option-selector").length == 2) {
			//DISABLE THE ONES NOT AVAILABLE
			function enable_disable_selection() {
				jQuery(".product_sticky .single-option-selector").eq(0).find('option').each(function (ix, em) {
					var option_val = jQuery(em).text().trim();
					var option_2_val = jQuery(".product_sticky .single-option-selector").eq(1).val();
					//do_console('option_val' + option_val);
					option_val = option_val + " / " + option_2_val;
					jQuery(".product_sticky select[name='product_variant']").find('option').each(function (ix2, em2) {
						var option_val_2 = jQuery(em2).text().trim().replace(" - Sold out", "");
						//do_console('option_val_2' + option_val_2);
						if (option_val == option_val_2) {
							if (jQuery(em2).attr('disabled')) {
								jQuery(em).attr('disabled', 'disabled');
							} else {
								jQuery(em).removeAttr('disabled');
							}
						}
					});
				});

				jQuery(".product_sticky .single-option-selector").eq(1).find('option').each(function (ix, em) {
					var option_val = jQuery(em).text().trim();
					var option_1_val = jQuery(".product_sticky .single-option-selector").eq(0).val();
					//do_console('option_val' + option_val);
					option_val = option_1_val + " / " + option_val;
					jQuery(".product_sticky select[name='product_variant']").find('option').each(function (ix2, em2) {
						var option_val_2 = jQuery(em2).text().trim().replace(" - Sold out", "");
						//do_console('option_val_2' + option_val_2);
						if (option_val == option_val_2) {
							if (jQuery(em2).attr('disabled')) {
								jQuery(em).attr('disabled', 'disabled');
							} else {
								jQuery(em).removeAttr('disabled');
							}
						}
					});
				});
			} //function ends
			enable_disable_selection();
			jQuery(document).on('change', ".product_sticky .single-option-selector", function (e) {
				enable_disable_selection();
			});


		}
	}

	// Recharge option on change change product price
	jQuery(document).on('change', '.subscribe_info input', function (e) {
		var original_price = jQuery('.subscribe_price').attr('data-pro-price');
		var d_price = jQuery('.subscribe_price.disc_price').attr('data-dis-price');
		if (this.value == 'Yes') {
			jQuery("#proprice").html(d_price);
		} else {
			jQuery("#proprice").html(original_price);
		}
	});

});


function get_variant_id() {

	var final_var_sel = jQuery("#SingleOptionSelector-0").val() + " / " + jQuery("#SingleOptionSelector-1").val();
	var did_get_select = false;
	var preorder_text = jQuery("#AddToCart-product-template #AddToCartText-product-template").attr('data-preorder-btn');

	jQuery(".product-form__variants").find('option').each(function (ix, em) {
		if (jQuery(em).text().trim() == final_var_sel) {
			did_get_select = true;
			if (jQuery(window).width() > 991) {
				if (preorder_text) {
					jQuery(".product-form__cart-submit").removeAttr("disabled");
					jQuery(".product-form__cart-submit #AddToCartText-product-template").text(preorder_text);
				} else {
					jQuery(".product-form__cart-submit").removeAttr("disabled");
					jQuery(".product-form__cart-submit #AddToCartText-product-template").text("Add to Cart");
				}
			} else {
				if (preorder_text) {
					jQuery(".product-form__cart-submit").removeAttr("disabled");
					jQuery(".product-form__cart-submit #AddToCartText-product-template").text(preorder_text);
					jQuery(".mobile_popup .product-form__cart-submit").removeAttr("disabled");
					jQuery(".mobile_popup .product-form__cart-submit #AddToCartText-product-template").text(preorder_text);
				} else {
					jQuery(".product-form__cart-submit").removeAttr("disabled");
					jQuery(".product-form__cart-submit #AddToCartText-product-template").text("Add to Cart");
					jQuery(".product-form__cart-submit").attr("disabled", "disabled");
					jQuery(".mobile_popup .product-form__cart-submit").removeAttr("disabled");
					jQuery(".mobile_popup .product-form__cart-submit #AddToCartText-product-template").text("Ok");
				}
			}
			var selected_variant_id = jQuery(em).attr('value');
			jQuery(em).val(selected_variant_id);
			debugger;
			jQuery(em).prop('selected', true);
			jQuery(em).trigger('change');
		} else {
			jQuery(em).prop('selected',false);
		}
	});
	if (did_get_select == false) {

		jQuery(".product-form__cart-submit").attr("disabled", "disabled");
		jQuery(".product-form__cart-submit #AddToCartText-product-template").text("Sold Out");

	}
}

function get_single_variant_id() {

	var final_var_sel = jQuery("#SingleOptionSelector-0").val();
	var did_get_select = false;
	var preorder_text = jQuery("#AddToCart-product-template #AddToCartText-product-template").attr('data-preorder-btn');


	jQuery(".product-form__variants").find('option').each(function (ix, em) {
		if (jQuery(em).text().trim() == final_var_sel) {
			did_get_select = true;
			if (jQuery(window).width() > 991) {
				if (preorder_text) {
					jQuery(".product-form__cart-submit").removeAttr("disabled");
					jQuery(".product-form__cart-submit #AddToCartText-product-template").text(preorder_text);
				} else {
					jQuery(".product-form__cart-submit").removeAttr("disabled");
					jQuery(".product-form__cart-submit #AddToCartText-product-template").text("Add to Cart");
				}
			} else {
				if (preorder_text) {
					jQuery(".product-form__cart-submit").removeAttr("disabled");
					jQuery(".product-form__cart-submit #AddToCartText-product-template").text(preorder_text);
					jQuery(".mobile_popup .product-form__cart-submit").removeAttr("disabled");
					jQuery(".mobile_popup .product-form__cart-submit #AddToCartText-product-template").text(preorder_text);
				} else {
					jQuery(".product-form__cart-submit").removeAttr("disabled");
					jQuery(".product-form__cart-submit #AddToCartText-product-template").text("Add to Cart");
					jQuery(".product-form__cart-submit").attr("disabled", "disabled");
					jQuery(".mobile_popup .product-form__cart-submit").removeAttr("disabled");
					jQuery(".mobile_popup .product-form__cart-submit #AddToCartText-product-template").text("Ok");
				}
			}
			var selected_variant_id = jQuery(em).attr('value');
			jQuery(em).val(selected_variant_id);
			debugger;
			jQuery(em).prop('selected', true);
			jQuery(em).trigger('change');
		} else {
			jQuery(em).prop('selected',false);
		}
	});

	if (did_get_select == false) {
		jQuery(".product-form__cart-submit").attr("disabled", "disabled");
		jQuery(".product-form__cart-submit #AddToCartText-product-template").text("Sold Out");
	}
}

// Function for Skincare and wellness form

function GetURLParameter(sParam) {
	var sPageURL = window.location.search.substring(1);
	var sURLVariables = sPageURL.split('&');
	for (var i = 0; i < sURLVariables.length; i++) {
		var sParameterName = sURLVariables[i].split('=');
		if (sParameterName[0] == sParam) {
			return sParameterName[1];
		}
	}
}
// Skincare and welness form
jQuery(document).ready(function (e) {
	var success = '';
	success = GetURLParameter('s');


	if (success == '1') {
		swal(
			'Success',
			'Thank You! Your form is submitted successfully. Our team will contact you shortly.',
			'success'
		);
	}
	if (success == '2') {
		swal(
			'Error',
			'Oops! Form data not submitted. Please try again after some time.',
			'error'
		);
	}
	$ = jQuery;
	// on fileinput change
	jQuery('#file1').change(function () {
		var fileExtension = ['png', 'jpg', 'jpeg', 'gif'];
		if (jQuery.inArray(jQuery(this).val().split('.').pop().toLowerCase(), fileExtension) == -1) {
			jQuery('.error_msg_for_file_formate_1').show();
			jQuery('#file1').val('');
			if (this.files[0].size > 2097152) {
				alert("Try to upload file less than 2MB!");
				this.value = ''; // Clean field
				return false;
			}
		} else {
			jQuery('.error_msg_for_file_formate_1').hide();
		}
	});
	$ = jQuery;
	jQuery('#file2').change(function () {
		var fileExtension = ['png', 'jpg', 'jpeg', 'gif'];
		if (jQuery.inArray(jQuery(this).val().split('.').pop().toLowerCase(), fileExtension) == -1) {
			jQuery('.error_msg_for_file_formate_2').show();
			jQuery('#file2').val('');
			if (this.files[0].size > 2097152) {
				alert("Try to upload file less than 2MB!");
				this.value = ''; // Clean field
				return false;
			}
		} else {
			jQuery('.error_msg_for_file_formate_2').hide();
		}
	});
	$ = jQuery;

	// benifit div hide show
	jQuery(".subscribe_info input").on('change', function () {
		var name = jQuery(this).val();
		if (name == 'onetime') {
			jQuery('.cbb-frequently-bought-container').show();
			jQuery('.subscription_benifits').hide();
			jQuery('.free_shipping-text').show();
		} else {
			jQuery('.cbb-frequently-bought-container').hide();
			jQuery('.subscription_benifits').show();
			jQuery('.free_shipping-text').hide();
		}
	});
	// Header search popup js
	jQuery(".nav-item.nav-search .nav-link").on("click", function (e) {
		e.preventDefault();
		if (jQuery(this).hasClass("is-open")) {
			jQuery(".nav-item.nav-search .nav-link").removeClass('is-open');
			jQuery(".header_search-bar").removeClass("is_show");
			jQuery('body').removeClass('overflow-hidden');
		} else {
			jQuery(this).addClass('is-open');

			jQuery(".header_search-bar").addClass("is_show");
			jQuery('body').addClass("overflow-hidden");
		}
	});
	jQuery(".close_searchbox").on("click", function (e) {
		e.preventDefault();
		jQuery(".nav-item.nav-search .nav-link").removeClass('is-open');
		jQuery(".header_search-bar").removeClass("is_show");
		jQuery('body').removeClass('overflow-hidden');
	});
	$ = jQuery;
	// Benfit Popup
	jQuery('[data-toggle="tooltip"]').tooltip();
	jQuery(document).on('click', ".beni_url a", function (e) {
		e.preventDefault();
		var popup_subscriptioninfo = "";
		popup_subscriptioninfo = jQuery(".beni_url a").attr('data-swal-info');
		var popup_subscriptioninfo_div = document.createElement('div');
		popup_subscriptioninfo_div.innerHTML = popup_subscriptioninfo;
		swal({
			title: "COMMUNITEA MEMBERSHIP BENEFITS:",
			content: popup_subscriptioninfo_div,
			button: "GOT IT!",
			showCloseButton: true,
			closeModal: true
		});
	});

	jQuery(".cart-h3").each(function (ix, em) {
		if (jQuery(em).text().indexOf('Auto renew') !== -1) {
			jQuery('#cart-discount-data').fadeOut(100);
		}
	});
	$ = jQuery;
	// chnage price of top products when sub-value change
	jQuery(document).on('change', ".subscription_value.sub_save_section .subscription-freq", function (e) {
		var subscription_val = this.value;
		console.log("call this also");
		if (subscription_val == 'subscribe-save') {
			//Sub & Save
			console.log("subscribe call this also");
			
			var dis_price = jQuery(this).find(':selected').attr('data-discount-price');
			var original_price = jQuery(this).find(':selected').attr('data-original-price');
			jQuery(this).parents('.product-item').find('.subscribe_one_purchase .subscribe_price .one_time_price').text(original_price);
			if($(`[data-variant-sponge-radio-select]`).length > 0 ) {
				original_price = $(`.product-cart-box [data-variant-sponge-radio-select]:checked`).attr('data-price').replace(".","");
				original_price = Shopify.formatMoney(ori_price,theme.moneyFormat);
				dis_price = $(`.product-cart-box [data-variant-sponge-radio-select]:checked`).attr('data-sub-price').replace(".","");
				dis_price = Shopify.formatMoney(dis_price,theme.moneyFormat);
			} else if($(`[data-variant-radio-select]`).length > 0 ) {
				original_price = $(`.product-cart-box [data-variant-radio-select]:checked`).attr('data-price').replace(".","");
				original_price = Shopify.formatMoney(ori_price,theme.moneyFormat);
				dis_price = $(`.product-cart-box [data-variant-radio-select]:checked`).attr('data-sub-price').replace(".","");
				
				dis_price = Shopify.formatMoney(dis_price,theme.moneyFormat);
			}
			
			jQuery(this).parents('.product-item').find('.price').text(dis_price);
			jQuery(this).parents('.product-item').find('.discount-price').show();
			jQuery(this).parents('.product-item').find('.discount-price').text(original_price);
			jQuery(this).parents('.product-item').find('.add-subscribe').text('Subscribe');
			
			//jQuery(this).parents('.product-item').find('.subscribe_one_purchase .subscribe_price .one_time_price').text(original_price);
			/*
				var subs_id = jQuery(this).parents('.product-item').find('.add-subscribe').attr('data-product-subs-id');
				jQuery(this).parents('.product-item').find('.add-subscribe').attr('data-product-id-to-add', subs_id);
			*/
			jQuery(this).parents('.product-content').find('.product-cart-box .add-cart-div .btn-dark-color').html("Subscribe and Save " + "<span class='sub-price'>(" + dis_price + ")</span>");
			jQuery(this).parents('.product-content').find('.product-cart-box .add-cart-div .btn-dark-color').removeClass('easeter_popup_product');

			var ispro_avail = jQuery(this).parents('.product-content.product-item').attr('data-check-available');
			if (ispro_avail == 'not-available') {
				jQuery(this).parents('.product-content').find('.product-cart-box .add-cart-div .btn-dark-color').html(" Out of Stock " + "<span class='sub-price'></span>");
			}
			if (jQuery('.form-check-wrapper').length) {
				//var product_id = jQuery('.form-check-wrapper .form-check input:checked').attr('data-subs-id');
				var product_id = jQuery('.form-check-wrapper .form-check input:checked').val();
				jQuery(".hidden_input_value").val(product_id);
			} else {
				//var prod_id = jQuery(this).find(':selected').attr('data-subscription-id');
				var prod_id = jQuery(this).find(':selected').attr('data-variant-id');
				jQuery(".hidden_input_value").val(prod_id);
			}
		} else {
			//OTP
			var ori_price = jQuery(this).find(':selected').attr('data-original-price');
			if( $(`[data-variant-sponge-radio-select]`).length > 0){
				ori_price = $(`.product-cart-box [data-variant-sponge-radio-select]:checked`).attr('data-price').replace(",","").replace(".","");
				ori_price = Shopify.formatMoney(ori_price,theme.moneyFormat);
		} 
            else if( $(`[data-variant-radio-select]`).length > 0 ) {
				ori_price = $(`.product-cart-box [data-variant-radio-select]:checked`).attr('data-price').replace(",","").replace(".","");
                console.log(ori_price,theme.moneyFormat)
				ori_price = Shopify.formatMoney(ori_price,theme.moneyFormat);
			}		
			jQuery(this).parents('.product-item').find('.price').text(ori_price);
			jQuery(this).parents('.product-item').find('.add-subscribe').text('Add to Bag');
			jQuery(this).parents('.product-item').find('.discount-price').hide();
			var variant_id = jQuery(this).parents('.product-item').find('.add-subscribe').attr('data-product-variant-id');
			jQuery(this).parents('.product-item').find('.add-subscribe').attr('data-product-id-to-add', variant_id);
			console.log("!!",ori_price)

			jQuery(this).parents('.product-item').find('.subscribe_one_purchase .subscribe_price .one_time_price').text(ori_price);
			jQuery(this).parents('.product-content').find('.product-cart-box .add-cart-div .btn-dark-color').html("Add to Cart " + "<span class='sub-price'>(" + ori_price + ")</span>");
			var is_easter_enable = jQuery(this).find(':selected').attr('data-is_easter');
			if (is_easter_enable == 'true') {
				var is_popup_atc = jQuery('#crtbtn1').attr('data-enable-atc-popup');
				if (is_popup_atc == 'true') {
					jQuery(this).parents('.product-content').find('.product-cart-box .add-cart-div .btn-dark-color').addClass('easeter_popup_product');
				}
			}
			if (jQuery('.form-check-wrapper').length) {
				var prod_id = jQuery('.form-check-wrapper .form-check input:checked').val();
				jQuery(".hidden_input_value").val(prod_id);
			} else {
				var prod_id = jQuery('.subscription_value.product_add .subscription-freq option:selected').attr('data-subscription-id');
				jQuery(".hidden_input_value").val(prod_id);
			}
			if (ispro_avail == 'not-available') {
				jQuery(this).parents('.product-content').find('.product-cart-box .add-cart-div .btn-dark-color').html(" Out of Stock " + "<span class='sub-price'></span>");
			}
		}
	});

	jQuery(document).on('change', ".subscription_value.top_products .subscription-freq", function (e) {
		var subscription_val = this.value;
		if (subscription_val == 'subscribe-save') {
			var dis_price = jQuery(this).find(':selected').attr('data-discount-price');
			var original_price = jQuery(this).find(':selected').attr('data-original-price');
			jQuery(this).parents('.product-item').find('.price').text(dis_price);
			jQuery(this).parents('.product-item').find('.discount-price').show();
			jQuery(this).parents('.product-item').find('.discount-price').text(original_price);
			/*
			var subs_id = jQuery(this).parents('.product-item').find('.add-top-product').attr('data-product-subs-id');
			jQuery(this).parents('.product-item').find('.add-top-product').attr('data-product-id-to-add', subs_id);
			*/
		} else {
			var ori_price = jQuery(this).find(':selected').attr('data-original-price');
			jQuery(this).parents('.product-item').find('.price').text(ori_price);
			jQuery(this).parents('.product-item').find('.discount-price').hide();
			var variant_id = jQuery(this).parents('.product-item').find('.add-top-product').attr('data-product-variant-id');
			jQuery(this).parents('.product-item').find('.add-top-product').attr('data-product-id-to-add', variant_id);
		}
	});

	// Scroll Header text	
	// Srcoll Text
	!function (n) { var e, o, t, i, r, l, a, s, c = { container: ".scroll_content", sections: "li", duration: 1e3, loop: !0, currentClass: "current", direction: "up" }, u = {}, d = 0, f = [], h = n.fn.scrollText = function (h) { return u = n.extend({}, c, h || {}), e = n(u.container), e.find(u.sections).each(function (n, e) { f.push(e) }), this.children("ul").addClass("ulzone"), o = n(".ulzone").eq(0), do_console(o), t = o.height(), i = o.children().eq(0).height(), r = i, s = u.duration, l = u.currentClass, this.each(function () { var e, t; t = e = this, o.clone().insertAfter(o), function (e) { (f = n(e).find("li")).length, f.eq(d).addClass(l) }(t), v(), function (n) { n.hover(function () { clearInterval(a) }, function () { v() }) }(n(e)) }) }; function v() { a = setInterval(h.up, s) } h.up = function () { o.animate({ marginTop: "-" + i }), f.removeClass(l), n(f[d += 1]).addClass(l), t === i ? o.animate({ marginTop: "-" + i }, "normal", h.over) : i += r }, h.over = function () { o.attr("style", "margin-top:0"), i = r, d = 0, f.removeClass(l), n(f[d]).addClass(l) } }(jQuery);
	setTimeout(function () {
		jQuery(".scroll_content").scrollText({
			'duration': 2000
		});
	}, 2000);

	// FB-PIXEl-2021 initchekout-event

	jQuery(".btn_checkout_green").on("click", function () {
		fbq('track', 'InitiateCheckout');
		setTimeout(function () {
		}, 200);
	});

	// Ing Slider
	jQuery(".ingredients-section").slick({
		slidesToShow: 2,
		slidesToScroll: 1,
		dots: true,
		arrow: false,
		responsive: [
			{
				breakpoint: 767,
				settings: {
					slidesToShow: 1,
					slidesToScroll: 1,
					arrow: false,
					dots: true
				}
			},
			{
				breakpoint: 480,
				settings: {
					slidesToShow: 1,
					slidesToScroll: 1,
					arrow: false,
					dots: true
				}
			}
		]
	});

	jQuery("#product-accordion .nav-tabs li.nav-item a.nav-link").click(function () {
		jQuery(".nav-tabs li.nav-item a.nav-link").removeClass('active');
	});

	/* Single Product Ajax */
	jQuery("a.add-to.add-to-single-product").on('click', function (e) {
		do_console(4512);
		e.preventDefault;
		var currentElement = e.target;
		var $this = jQuery(this).parents('#addtocart');
		var totalquantity = parseInt(jQuery("#item_Quantity", $this).val());
		var product_id = jQuery("input[name='id']", $this).attr('data-single-product');
		$this.find('.product-ajax-loader').fadeIn(300);
		if (product_id) {
			var data_to_send = {
				'quantity': totalquantity,
				'id': product_id
			}
			//MAKE AJAX CALLS
			do_console(4515);
			jQuery.ajax({
				url: '/cart/add.js',
				method: "POST",
				dataType: "JSON",
				data: data_to_send,
				success: function (data) {
					update_cart_popup();
					if(typeof window.customer_email !== 'undefined') {
						window.liQ = window.liQ || [];
						window.liQ.push({
						"event": "addToCart",
						"email": window.customer_email
						});
					}
					$this.find('.product-ajax-loader').fadeOut(300);
					jQuery(".nav-item.nav-shop .badge").show();
					jQuery(".nav-shop-mobile .badge").show();
					var valueToUpdate = parseInt(jQuery(".nav-item.nav-shop .badge").text()) + totalquantity;
					jQuery(".nav-shop-mobile .badge").text(valueToUpdate.toString());
					jQuery(".nav-item.nav-shop .badge").text(valueToUpdate.toString());

				},
				error: function (data) {
					$this.find('.product-ajax-loader').fadeOut(300);
					if (typeof data.responseJSON.description !== "undefined") {
						var message = data.responseJSON.description;
					} else {
						var message = "Please try again later!";
					}
					swal({
						title: "Oops!!",
						text: message,
						icon: "error",
						className: "add-ajax-outofstock",
						buttons: false,
						timer: 1500
					});
				}
			});
		}
		return false;
	});

	// Variant popup js
	
	jQuery(document).on("click", ".btn-subs", function (e) {
		e.preventDefault();
		do_console('open popup');
		
		jQuery("#variant_popup .product_inner .product_img img").attr('');
		jQuery("#variant_popup .product_inner .pro_desc .prod_title").text('');
		jQuery("#variant_popup .product_inner .pro_desc .prod_review").html('');
		jQuery("#variant_popup .product_inner .pro_desc .price_wrapper .original_price").text('');
		jQuery("#variant_popup .product_inner .pro_desc .price_wrapper .discount_price").text('');
		jQuery("#variant_popup #addtocart_popup .benifit_wrapper").html('');
		jQuery("#variant_popup .product_inner .pro_desc  .sub_title .bold_field").text('');
		jQuery("#variant_popup .product_inner .pro_desc  .sub_title .thin_filed").text('');
		jQuery("#variant_popup .sub_info .quantity_subs_wrapper .freq_wrap").html('');
		jQuery("#variant_popup .variant_wrapper").html('');
		jQuery("#variant_popup #addtocart_popup .pro_id").val('');
		jQuery("#variant_popup #addtocart_popup input[name='id']").val('');
		jQuery(".add_to_cart_popup").text('Add to Cart');
		jQuery("#variant_popup #item_Quantity").val('1');

		var discount_per = jQuery(this).attr('data-discount');
		var pro_img = jQuery(this).attr('data-pro-img');do_console(pro_img);
		var pro_title = jQuery(this).attr('data-title');
		var pro_price = jQuery(this).attr('data-pro-price');
		var pro_disc_price = jQuery(this).attr('data-pro-disc-price');
		var product_review = jQuery(this).attr('data-review-widget');
		var freq_code = jQuery(this).attr('data-fre-unit');
		var benifit_url = jQuery(this).attr('data-sub-benifit');
		var bold_text = jQuery(this).attr('data-bold-text');
		var light_text = jQuery(this).attr('data-light-text');
		var variant_ui = jQuery(this).attr('data-variant-ui');
		var prod_id = jQuery(this).attr('data-por-id');
		debugger
		var pre_order = jQuery(this).attr('data-preorder-btn');
		var compare_at_price = jQuery(this).attr('data-is-compare-at-price');

		jQuery("#variant_popup .product_inner .product_img img").attr('src', pro_img);
		jQuery("#variant_popup .product_inner .pro_desc .prod_title").text(pro_title);
		jQuery("#variant_popup .product_inner .pro_desc .prod_review").html(product_review);

		jQuery("#variant_popup #addtocart_popup input[name='id']").val(prod_id);
		if (typeof benifit_url !== typeof undefined && benifit_url !== false) {
			jQuery("#variant_popup #addtocart_popup .benifit_wrapper").html(benifit_url);
		}

		if (typeof bold_text !== typeof undefined && bold_text !== false) {
			jQuery("#variant_popup .product_inner .pro_desc  .sub_title .bold_field").text(bold_text);
		}
		if (typeof light_text !== typeof undefined && light_text !== false) {
			jQuery("#variant_popup .product_inner .pro_desc  .sub_title .thin_filed").text(light_text);
		}

		if (typeof freq_code !== typeof undefined && freq_code !== false) {
			jQuery("#variant_popup .sub_info .quantity_subs_wrapper .freq_wrap").html(freq_code);
		}

		if (typeof variant_ui !== typeof undefined && variant_ui !== false) {
			jQuery("#variant_popup .variant_wrapper").html(variant_ui);
		}

		if (typeof pre_order !== typeof undefined && pre_order !== false) {
			jQuery("#variant_popup #AddToCartText-product-template #AddToCartText-product-template").attr('data-preorder-btn', pre_order);
		}
		if (jQuery("#variant_popup .selector-wrapper.product-form__item").length > 1) {
			jQuery('#variant_popup .single-option-selector').on('change', function () {
				popup_get_variant_id();
				do_console("is changes double");
			});
		} else {
			jQuery('#variant_popup .single-option-selector').on('change', function () {
				do_console("is changes");
				popup_get_single_variant_id();
			});
		}

		var sub_val = '';
		jQuery(this).parents('.product-item').find(".subscription_value .subscription-freq option:selected").each(function (ix, em) {
			sub_val = jQuery(em).text().trim();
		});

		if (jQuery('#variant_popup .quantity_subs_wrapper .freq_wrap .subscription_value.sub_save_popup .subscription-freq').length) {
			do_console('there is subs');
			jQuery("#variant_popup .sub_info .quantity_subs_wrapper .subscription_value .subscription-freq option").each(function (ix, ex) {
				if (sub_val == 'One-time') {
					debugger
					jQuery('#variant_popup .add_to_cart_btn .add_to_cart_popup').html("Add to Cart " + "<span id='AddToCartText-product-template'>(" + pro_price + ")</span>");
				} else {
					jQuery('#variant_popup .add_to_cart_btn .add_to_cart_popup').html("Subscribe - " + "<span id='AddToCartText-product-template'>(" + pro_disc_price + ")</span>");
				}
				debugger;
				if (jQuery(ex).text().trim() == sub_val) {
					var selected_freq = jQuery(ex).attr('value');
					jQuery(ex).val(selected_freq);
					debugger;
					jQuery(ex).prop('selected', true);
					jQuery(ex).trigger('change');
				}
			});
		} else {
			do_console('there is no subs');
			if(typeof  jQuery("#variant_popup #ProductSelect-product-template-popup option:selected").attr('data-p-price') != 'undefined'){
				pro_o_price = jQuery("#variant_popup #ProductSelect-product-template-popup option:selected").attr('data-p-price');
			}else{
				pro_o_price = jQuery("#variant_popup #ProductSelect-product-template-popup option:selected").attr('data-original-price');
			}
			jQuery('#variant_popup .add_to_cart_btn .add_to_cart_popup').html("Add to Cart " + "<span id='AddToCartText-product-template'>(" + pro_o_price + ")</span>");
		}

		// disable which option not available in variantpopup
		//IF single 
		if (jQuery("#variant_popup .single-option-selector").length == 1) {
			//DISABLE THE ONES NOT AVAILABLE
			jQuery("#variant_popup .single-option-selector").find('option').each(function (ix, em) {
				var option_val = jQuery(em).text().trim();
				debugger
				jQuery("#variant_popup select[name='product_variant_popup']").find('option').each(function (ix2, em2) {
					var option_val_2 = jQuery(em2).text().trim().replace(" - Sold out", "");
					if (option_val == option_val_2) {
						if (jQuery(em2).attr('disabled')) {
							jQuery(em).attr('disabled', 'disabled');
						} else {
							jQuery(em).removeAttr('disabled');
						}
					}
				});
			});
		} else if (jQuery("#variant_popup .single-option-selector").length == 2) {
			//DISABLE THE ONES NOT AVAILABLE
			function enable_disable_selection() {
				jQuery("#variant_popup .single-option-selector").eq(0).find('option').each(function (ix, em) {
					var option_val = jQuery(em).text().trim();
					debugger;
					var option_2_val = jQuery("#variant_popup .single-option-selector").eq(1).val();
					option_val = option_val + " / " + option_2_val;
					jQuery("#variant_popup select[name='product_variant_popup']").find('option').each(function (ix2, em2) {
						var option_val_2 = jQuery(em2).text().trim().replace(" - Sold out", "");
						if (option_val == option_val_2) {
							if (jQuery(em2).attr('disabled')) {
								jQuery(em).attr('disabled', 'disabled');
							} else {
								jQuery(em).removeAttr('disabled');
							}
						}
					});
				});

				jQuery("#variant_popup .single-option-selector").eq(1).find('option').each(function (ix, em) {
					var option_val = jQuery(em).text().trim();
					debugger
					var option_1_val = jQuery("#variant_popup .single-option-selector").eq(0).val();
					option_val = option_1_val + " / " + option_val;
					jQuery("#variant_popup select[name='product_variant_popup']").find('option').each(function (ix2, em2) {
						var option_val_2 = jQuery(em2).text().trim().replace(" - Sold out", "");
						if (option_val == option_val_2) {
							if (jQuery(em2).attr('disabled')) {
								jQuery(em).attr('disabled', 'disabled');
							} else {
								jQuery(em).removeAttr('disabled');
							}
						}
					});
				});
			} //function ends
			enable_disable_selection();
			jQuery(document).on('change', "#variant_popup .single-option-selector", function (e) {
				enable_disable_selection();
			});
		}

		var pro_img = jQuery("#variant_popup #ProductSelect-product-template-popup option:selected").attr('data-variant-image');
		jQuery("#variant_popup .product_inner .product_img img").attr('src', pro_img);
        // $('.subscription-freq option').not('.subs_save').prop('selected','selected');	
		// $('.subscription-freq option.subs_save').hide();
	});

	jQuery('#addtocart_popup').on('submit', function (e) {
		e.preventDefault();
		var $this = jQuery(this);
		var qnty = jQuery("#item_Quantity", $this).val();
		var totalquantity = parseInt(qnty);
		$this.find(".product-ajax-loader").fadeIn();
		var data_to_send = '';
		// check there is sub or not

		debugger;

		if ($this.find('.subscription_value.sub_save_popup').length) {
			jQuery(".subscription_value.sub_save_popup .subscription-freq option:selected").each(function (ix, em) {
				//var sub_info = '';
				var is_subs = jQuery(em).val();
				if (is_subs == 'subscribe-save') {
					/*
					var subscription_variant_id = jQuery("#ProductSelect-product-template-popup option:selected").attr('data-d-id');
					*/
					var subscription_variant_id = jQuery(".product-form__variants_popup[data-variant-select-value-popup]", $this).val();
					var selectedfrequency = jQuery(em).attr("data-freq");
					var selectedfrequencyunit = jQuery(em).attr('data-unit');
					let selling_plan_id = $(em).attr('data-subscription-id-to-add');
					/*
					var line_properties = {};
					line_properties.subscription_id = subscription_variant_id;
					line_properties.shipping_interval_frequency = selectedfrequency;
					line_properties.shipping_interval_unit_type = selectedfrequencyunit;
					line_properties.selling_plan_id = $(this).attr('selling_plan_id');
					*/
					data_to_send = {
						'quantity': totalquantity,
						'id': subscription_variant_id,
						'selling_plan' : selling_plan_id
						/*properties: line_properties*/
					}
				} else {
					if (jQuery(".product-form__variants_popup[data-variant-select-value-popup]", $this).length) {
						var varianttoadd = jQuery(".product-form__variants_popup[data-variant-select-value-popup]", $this).val();
					} else {
						var varianttoadd = jQuery("#variant_drfault").attr('data-varint-default');
					}
					data_to_send = {
						'quantity': totalquantity,
						'id': varianttoadd
					}
				}
			});

		} else {
			if (jQuery(".product-form__variants_popup[data-variant-select-value-popup]", $this).length) {
				var varianttoadd = jQuery(".product-form__variants_popup[data-variant-select-value-popup]", $this).val();
			} else {
				var varianttoadd = jQuery("#variant_drfault").attr('data-varint-default');
			}
			data_to_send = {
				'quantity': totalquantity,
				'id': varianttoadd
			}
		}
		do_console(4771);
		debugger;
		jQuery.ajax({
			url: '/cart/add.js',
			method: "POST",
			dataType: "JSON",
			data: data_to_send,
			success: function (data) {
				$this.find(".product-ajax-loader").fadeOut();
				jQuery(".add_to_cart_popup").text('Product added to the cart');
				if(typeof window.customer_email !== 'undefined') {
					window.liQ = window.liQ || [];
					window.liQ.push({
					"event": "addToCart",
					"email": window.customer_email
					});
				}
				jQuery(".nav-item.nav-shop .badge").show();
				jQuery(".nav-shop-mobile .badge").show();
				jQuery(".nav-item.nav-shop .badge").show();
				jQuery(".nav-shop-mobile .badge").show();
				var valueToUpdate = parseInt(jQuery(".nav-item.nav-shop .badge").text()) +
					totalquantity;
				jQuery(".nav-shop-mobile .badge").text(valueToUpdate.toString());
				jQuery(".nav-item.nav-shop .badge").text(valueToUpdate.toString());
				jQuery("#variant_popup .close").trigger("click");
				update_cart_popup();
			},
			error: function (data) {
				if (typeof data.responseJSON.description !== "undefined") {
					var message = data.responseJSON.description;
				} else {
					var message = "Please try again later!";
				}
			}
		});
	})

function onPopupFrequencyChange(final_var_sel,did_get_select,pro_price,pro_disc_price){
	jQuery("#variant_popup .product-form__variants_popup").find('option').each(function (ix, em) {
		debugger;
		let val = jQuery(em).text().trim();
		console.log(val == final_var_sel);
		if (jQuery(em).text().trim() == final_var_sel.trim()) {
			console.log(val); 
			console.log(final_var_sel)
			did_get_select = true;
			if(typeof pro_disc_price != 'undefined'){
			jQuery('#variant_popup .add_to_cart_btn .add_to_cart_popup').html("Subscribe - " + "<span id='AddToCartText-product-template'>(" + pro_disc_price + ")</span>");
			}else{
				jQuery('#variant_popup .add_to_cart_btn .add_to_cart_popup').html("Add To Cart " + "<span id='AddToCartText-product-template'>(" + pro_price + ")</span>");
			}
		} else {
			jQuery(em).prop('selected',false);
		}
	});
	if (did_get_select == false) {
		jQuery("#variant_popup .add_to_cart_btn .add_to_cart_popup .product-form__cart-submit").attr("disabled", "disabled");
		jQuery("#variant_popup .add_to_cart_btn .add_to_cart_popup").text("Sold Out");
	}
}

	jQuery(document).on('change', "#variant_popup .subscription_value.sub_save_popup .subscription-freq", function (e) {
		var subscription_val = this.value;
		let pro_disc_price = jQuery(this).children("option:selected").attr('data-discount-price');
		var pro_price = jQuery(this).children("option:selected").attr('data-original-price');

		// if(typeof jQuery(this).children("option:selected").attr('data-discount-price') == 'undefined'){
		// pro_disc_price = jQuery(this).children("option:selected").attr('data-original-price');
		// }
		if (subscription_val == 'subscribe-save') {
			if (jQuery(".variant_wrapper .selector-wrapper.product-form__item").length > 1) {
				var final_var_sel = jQuery("#variant_popup #SingleOptionSelector-0").val() + " / " 
				+ jQuery("#variant_popup #SingleOptionSelector-1").val()+"/Delivery "
				+$('#variant_popup .subscription-freq option:selected').text().split("(")[0].toLowerCase().replace('days',"Days").trim();;
				jQuery('#variant_popup .product-form__variants_popup option').each(function(ix,em){
					var get_val = jQuery(em).text().trim();
					if(final_var_sel === get_val){
						$(em).attr('selected','selected');
						var did_get_select = false;
						console.log(1);
						pro_price = $(em).attr('data-p-price');
						pro_disc_price = $(em).attr('data-d-price');
						onPopupFrequencyChange(final_var_sel,did_get_select,pro_price,pro_disc_price);
					}else{
						$(em).removeAttr('selected');
					}
				});
				// var did_get_select = false;
				// console.log(1)
				// onPopupFrequencyChange(final_var_sel,did_get_select,pro_price,pro_disc_price);
			} else {
				var final_var_sel = jQuery("#variant_popup #SingleOptionSelector-0").val();
				var did_get_select = false;
				console.log(2)
				let new_final_var_sel = jQuery("#variant_popup #SingleOptionSelector-0").val()
				+"/Delivery "+$('#variant_popup .subscription-freq option:selected').text().split("(")[0].toLowerCase().replace('days',"Days").trim();
				
				jQuery('#variant_popup .product-form__variants_popup option').each(function(ix,em){
					var get_val = jQuery(em).text().trim();
					if(new_final_var_sel === get_val){
						$(em).attr('selected','selected');
						pro_price = $(em).attr('data-p-price');
						pro_disc_price = $(em).attr('data-d-price');
						onPopupFrequencyChange(new_final_var_sel,did_get_select,pro_price,pro_disc_price);
					}else{
						$(em).removeAttr('selected');
					}
				});	
			}
		}
		else {
			if (jQuery("#variant_popup .selector-wrapper.product-form__item").length > 1) {
				var final_var_sel = jQuery("#variant_popup #SingleOptionSelector-0").val() 
				+ " / " + jQuery("#SingleOptionSelector-1").val()+"/ "+
				$('#variant_popup .subscription-freq option:selected').text().split("(")[0].toLowerCase().replace('days',"Days").trim();;
				var did_get_select = false;
				console.log(3)
				onPopupFrequencyChange(final_var_sel,did_get_select,pro_price,pro_disc_price);
			} else {
				var final_var_sel = jQuery("#variant_popup #SingleOptionSelector-0").val()+"/"
				+$('#variant_popup .subscription-freq option:selected').text().split("(")[0].toLowerCase().replace('days',"Days").trim();
				jQuery('#variant_popup .product-form__variants_popup option').each(function(ix,em){
					var get_val = jQuery(em).text().trim();

					if(final_var_sel === get_val){
						$(em).attr('selected','selected');
						pro_price = $(em).attr('data-pro-price');
						var did_get_select = false;
						console.log(4)
						onPopupFrequencyChange(final_var_sel,did_get_select,pro_price,pro_disc_price);
					}else{
						$(em).removeAttr('selected');
					}
				});	
				
			}
		}
	});

	// product-page-ballon-popup
	jQuery('.ballon_popup.easeter_popup_product').on('click', function (e) {
		e.preventDefault();
		jQuery('#easter_popup_overlay_product').fadeIn();
		jQuery('#easter_popup').addClass('collection_popup');
		jQuery('#easter_popup').fadeIn();
		jQuery('body').addClass("is_easterpopup_open");
		jQuery('body').addClass("overflow-hidden");
		var $this = jQuery(this);
		var easter_image = $this.attr("data-e-image");
		var discount_code = $this.attr("data-e-dcode");
		var easter_desc = $this.attr("data-e-desc");
		var easter_howto = $this.attr("data-e-redeem");
		var hover_info_text = $this.attr("data-e-info");

		jQuery("#easter_popup .popup_modal .popup-body .popup_code .popup_img img").attr("src", easter_image);
		jQuery("#easter_popup .popup_modal .popup-body .popup_code .popup_code_text p span b").text(discount_code);
		jQuery("#easter_popup .popup_modal .popup-body .popup_code .popup_code_text p.deal span").text(easter_desc);
		jQuery("#easter_popup .popup_modal .popup-body .popup_code .popup_code_text .prod_info h2").text(easter_howto);
		jQuery("#easter_popup .popup_modal .popup-body .popup_code .popup_code_text .prod_info .icon_info .eag-note").text(hover_info_text);

	});
	jQuery('.ballon_popup').on('click', function (e) {
		e.preventDefault();
	});

	jQuery(document).on('click','.data-open-url',function(e){
		e.preventDefault();
		window.location = jQuery(e.target).attr('href').toString().trim();
	})

	// Prop Warn 65 
	let califorina_stop = ['plant-based-protein-powder', 'plant-based-protein-powder-vanilla', 'matcha-powder-1', 'super-smoothie-kit', 'super-inner-wellness-kit', 'wellness-essentials-duo', 'matcha-powder-1', 'matcha-starter-set'];
	let allowed_with_sku_in_ca = ['plant-based-protein-powder-vanilla','plant-based-protein-powder'];
	jQuery.ajax({
		type: "GET",
		url: 'https://api.ipstack.com/check?access_key=c1faa041771b160efc0792f442dea5ab',
		dataType: "json",
		success: function (data) {
			let did_process_for_CA_allowed = false;
			if (typeof data.region_code != 'undefined' && data.region_code) {
				var r_code = data.region_code;
				var c_code = data.country_code;
				if ( (r_code == 'CA' && c_code == 'US' && jQuery(`[data-allowedinca="true"]`).length > 0) || test_ca == true ) {
					did_process_for_CA_allowed = true;
					jQuery(`[data-allowedinca="false"]`).remove();
					jQuery(`[data-allowedinca="true"]`).addClass('displayinca');
					jQuery(`[data-allowedinca="true"] input`).removeAttr('disabled');
                    jQuery(`[data-allowedinca="true"] input`).prop('checked',true);
					jQuery(`[data-allowedinca="true"]`).eq(0).trigger('click');
                    jQuery(`[data-allowedinca="true"]`).eq(0).trigger('change');
					jQuery(".subscription-freq").trigger('change');
					jQuery(`[id="SingleOptionSelector-0"]`).find('option').each(function(ix,em){
						let did_find = false;
						jQuery(`[data-allowedinca="true"]`).each(function(ix2,em2){
							let variant_title = jQuery(em2).find('label').text().trim();
							debugger
							if(jQuery(em).text().trim() == variant_title) {
								did_find = true;
								do_console('Found ' + variant_title)
							}
						});
						if(did_find == false ) {
							jQuery(em).remove();
						}
					});
					jQuery(`[id="SingleOptionSelector-0"]`).trigger('change');
					jQuery('.form-check[data-allowedinca="true"]').eq(0).find('input').trigger('change')
				}
			}

			if (typeof data.region_code != 'undefined' && data.region_code) {
				var r_code = data.region_code;
				var c_code = data.country_code;
				/*
				do_console('Region-cod--' + r_code);
				do_console('Country-cod--' + c_code);
				*/
				if (jQuery('.wraningin_wrapper').length) {
					if ( (r_code == 'CA' && c_code == 'US') || test_ca == true ) {
						jQuery('.wraningin_wrapper').show();
					} else {
						jQuery('.wraningin_wrapper').hide();
					}
				}
			} else {
				do_console('ERROR');
			}
			if (typeof data.region_code != 'undefined' && data.region_code) {
				var r_code = data.region_code;
				var c_code = data.country_code;
				if ( (r_code == 'CA' && c_code == 'US' && did_process_for_CA_allowed == false) || test_ca == true ) {
					let current_url = window.location.href.toString();
					jQuery.each(califorina_stop, function (ix, em) {
						if (current_url.indexOf(em) !== -1) {
							jQuery('#crtbtn1,#AddToCart-product-template').prop('disabled', 'disabled').text('Unavailable').css('cursor', 'no-drop').css('pointer-events', 'none');
							jQuery("#addtocartsection .one_time_wrapper").remove(0);
						}
					});
					jQuery(".products-slider-top-products .product-item").each(function (ix, em) {
						let a_tag = jQuery(em).find('a').eq(0);
						let location = jQuery(a_tag).attr('href').toString().trim();
						jQuery.each(califorina_stop, function (ix2, em2) {
							if (location.indexOf(em2) !== -1) {
								let element = jQuery(em).find('.add-to-bag').eq(0);
								jQuery(element).prop('disabled', 'disabled').text('Unavailable').css('cursor', 'no-drop').css('pointer-events', 'none');
							}
						});
					});

					jQuery(".products-slider-subscribe-save .product-item").each(function (ix, em) {
						let a_tag = jQuery(em).find('a').eq(0);
						let location = jQuery(a_tag).attr('href').toString().trim();
						jQuery.each(califorina_stop, function (ix2, em2) {
							if (location.indexOf(em2) !== -1) {
								let element = jQuery(em).find('.add-to-bag').eq(0);
								jQuery(element).prop('disabled', 'disabled').text('Unavailable').css('cursor', 'no-drop').css('pointer-events', 'none');
							}
						});
					});

					jQuery("section.product-category .product-item").each(function (ix, em) {
						let a_tag = jQuery(em).find('a').eq(0);
						let location = jQuery(a_tag).attr('href').toString().trim();
						let did_find = false;
						jQuery.each(allowed_with_sku_in_ca, function (ix2, em2) {
							if (location.indexOf(em2) !== -1) {
								let element = jQuery(em).find('.add-to-bag').eq(0);
								jQuery(element).text('View Product').addClass('data-open-url');
								jQuery(element).removeAttr('data-toggle');
								jQuery(element).removeAttr('data-target');
								did_find = true;
							}
						});

						if( did_find == false ){
							jQuery.each(califorina_stop, function (ix2, em2) {
								if (location.indexOf(em2) !== -1) {
									let element = jQuery(em).find('.add-to-bag').eq(0);
									jQuery(element).prop('disabled', 'disabled').text('Unavailable').css('cursor', 'no-drop').css('pointer-events', 'none');
								}
							});
						}
					});
				}
			} else {

			}

			
		},
		error: function (data) {
			if (typeof data.responseJSON !== "undefined") {
				var message = data.responseJSON.description;
			} else {
				var message = "Please try again later!";
			}
		}
	});
});

function popup_get_variant_id() {

	var final_var_sel = jQuery("#addtocart_popup #SingleOptionSelector-0").val() + " / " + jQuery("#addtocart_popup #SingleOptionSelector-1").val();
	var did_get_select = false;
	var preorder_text = jQuery("#AddToCart-product-template #AddToCartText-product-template").attr('data-preorder-btn');
	var product_price = jQuery("#addtocart_popup #ProductSelect-product-template-popup option:selected").attr('data-p-price');
	var product_d_price = jQuery("#addtocart_popup #ProductSelect-product-template-popup option:selected").attr('data-d-price');


	jQuery("#addtocart_popup .product-form__variants_popup").find('option').each(function (ix, em) {
		debugger
		if (jQuery(em).text().trim() == final_var_sel) {
			var selected_variant_id = jQuery(em).attr('value');
			jQuery(em).val(selected_variant_id);
			debugger;
			jQuery(em).prop('selected', true);
			jQuery(em).trigger('change');
			jQuery("#addtocart_popup input[name='id']").val(selected_variant_id);
			var check_sub = jQuery(em).attr('data-d-id');
			did_get_select = true;
			if (preorder_text) {
				jQuery("#addtocart_popup .product-form__cart-submit").removeAttr("disabled");
				jQuery("#addtocart_popup .product-form__cart-submit #AddToCartText-product-template").text(preorder_text);
			} else {
				jQuery("#addtocart_popup .product-form__cart-submit").removeAttr("disabled");
				debugger
				if (jQuery('#addtocart_popup .subscription_value.sub_save_popup').length) {
					jQuery("#addtocart_popup .subscription_value.sub_save_popup .subscription-freq option:selected").each(function (ix, em) {
						var is_subs = jQuery(em).val();
						if (is_subs == 'subscribe-save') {
							if (typeof check_sub !== typeof undefined && check_sub !== false) {
								jQuery('#variant_popup .add_to_cart_btn .add_to_cart_popup').html("Subscribe - " + "<span id='AddToCartText-product-template'>(" + product_d_price + ")</span>");
							} else {
								debugger
								jQuery('#variant_popup .add_to_cart_btn .add_to_cart_popup').html("Add to Cart " + "<span id='AddToCartText-product-template'>(" + product_price + ")</span>");
							}
						} else {
							jQuery('#variant_popup .add_to_cart_btn .add_to_cart_popup').html("Add to Cart " + "<span id='AddToCartText-product-template'>(" + product_price + ")</span>");
						}
					});
				} else {
					if(typeof jQuery("#variant_popup #ProductSelect-product-template-popup option:selected").attr('data-p-price') != 'undefined'){
					pro_o_price = jQuery("#variant_popup #ProductSelect-product-template-popup option:selected").attr('data-p-price');
					}else{
						pro_o_price = jQuery("#variant_popup #ProductSelect-product-template-popup option:selected").attr('data-original-price');
					}
					jQuery('#variant_popup .add_to_cart_btn .add_to_cart_popup').html("Add to Cart " + "<span id='AddToCartText-product-template'>(" + pro_o_price + ")</span>");
				}
			}
			var product_variant_img = jQuery("#addtocart_popup #ProductSelect-product-template-popup option:selected").attr('data-variant-image');
			jQuery('#variant_popup #addtocart_popup .product_inner .product_img img').attr('src', product_variant_img);
		} else {
			jQuery(em).prop('selected',false);
		}
	});
	if (did_get_select == false) {
		jQuery("#addtocart_popup.product-form__cart-submit").attr("disabled", "disabled");
		jQuery("#addtocart_popup .product-form__cart-submit").text("Sold Out");

	}
}
function popup_get_single_variant_id() {

	$('#variant_popup .subscription_value.sub_save_popup .subscription-freq').trigger('change')
	var final_var_sel = jQuery("#addtocart_popup #SingleOptionSelector-0").val();
	var did_get_select = false;
	var preorder_text = jQuery("#AddToCart-product-template #AddToCartText-product-template").attr('data-preorder-btn');
	var product_price = jQuery("#addtocart_popup #ProductSelect-product-template-popup option:selected").attr('data-p-price');
	var product_d_price = jQuery("#addtocart_popup #ProductSelect-product-template-popup option:selected").attr('data-d-price');

	jQuery("#addtocart_popup .product-form__variants_popup").find('option').each(function (ix, em) {
		let val = jQuery(em).text().trim();
		// console.log(jQuery(em))
		// console.log(val); //full
		let new_final_val = ""
		if($('#variant_popup .subscription-freq option:selected').length>0){
		if($('#variant_popup .subscription-freq option:selected').text().split("(")[0].toLowerCase().replace('days',"Days").trim().indexOf('one-time') != -1){
			new_final_val = final_var_sel+"/"+ $('#variant_popup .subscription-freq option:selected').text().split("(")[0].toLowerCase().replace('days',"Days").trim();
			setTimeout(function () {
				var get_p_price = $('#variant_popup .product-form__variants_popup option:selected').attr('data-pro-price');			
				jQuery('#variant_popup .add_to_cart_btn .add_to_cart_popup').html("Add to Cart " + "<span id='AddToCartText-product-template'>(" + get_p_price + ")</span>");
			},  1000);
		}else{
			new_final_val = final_var_sel+"/Delivery "+ $('#variant_popup .subscription-freq option:selected').text().split("(")[0].toLowerCase().replace('days',"Days").trim();
			setTimeout(function () {
				var get_d_price = $('#variant_popup .product-form__variants_popup option:selected').attr('data-d-price');
				jQuery('#variant_popup .add_to_cart_btn .add_to_cart_popup').html("Subscribe - " + "<span id='AddToCartText-product-template'>(" + get_d_price + ")</span>");
			},  1000);
		}
		}else{
			new_final_val = final_var_sel
		}
		// console.log(new_final_val);
		debugger
		if (jQuery(em).text().trim() == new_final_val) {
			do_console("check-sele-text-" + jQuery(em).text().trim());
			do_console("check-mathctext-" + final_var_sel);

			var selected_variant_id = jQuery(em).attr('value');
			jQuery(em).val(selected_variant_id);
			debugger;
			jQuery(em).prop('selected', true);
			jQuery(em).trigger('change');
			jQuery("#addtocart_popup input[name='id']").val(selected_variant_id);
			var check_sub = jQuery(em).attr('data-d-id');
			did_get_select = true;
			if (preorder_text) {
				jQuery("#addtocart_popup .product-form__cart-submit").removeAttr("disabled");
				jQuery("#addtocart_popup .product-form__cart-submit #AddToCartText-product-template").text(preorder_text);
			} else {
				jQuery("#addtocart_popup .product-form__cart-submit").removeAttr("disabled");
				if (jQuery('#addtocart_popup .subscription_value.sub_save_popup').length) {
					jQuery("#addtocart_popup .subscription_value.sub_save_popup .subscription-freq option:selected").each(function (ix, em) {
						var is_subs = jQuery(em).val();
						if (is_subs == 'subscribe-save') {
							if (typeof check_sub !== typeof undefined && check_sub !== false) {
								var get_d_price = $('#variant_popup .product-form__variants_popup option:selected').attr('data-d-price');
								setTimeout(function () {
									jQuery('#variant_popup .add_to_cart_btn .add_to_cart_popup').html("Subscribe - " + "<span id='AddToCartText-product-template'>(" + get_d_price + ")</span>");
								},  1000);
							} else {
								debugger
								jQuery('#variant_popup .add_to_cart_btn .add_to_cart_popup').html("Add to Cart " + "<span id='AddToCartText-product-template'>(" + product_price + ")</span>");
							}
						} else {
							debugger
							var get_p_price = $('#variant_popup .product-form__variants_popup option:selected').attr('data-pro-price');
							setTimeout(function () {
									
									jQuery('#variant_popup .add_to_cart_btn .add_to_cart_popup').html("Add to Cart " + "<span id='AddToCartText-product-template'>(" + get_p_price + ")</span>");
							},  1000);
						}
					});
				} else {
					var pro_o_price = jQuery("#variant_popup #ProductSelect-product-template-popup option:selected").attr('data-p-price');
					debugger
					jQuery('#variant_popup .add_to_cart_btn .add_to_cart_popup').html("Add to Cart " + "<span id='AddToCartText-product-template'>(" + pro_o_price + ")</span>");
				}
			}
			var product_variant_img = jQuery("#addtocart_popup #ProductSelect-product-template-popup option:selected").attr('data-variant-image');
			jQuery('#variant_popup #addtocart_popup  .product_inner .product_img img').attr('src', product_variant_img);
		} else {
			jQuery(em).prop('selected',false);
		}
	});

	if (did_get_select == false) {
		jQuery("#addtocart_popup .product-form__cart-submit").attr("disabled", "disabled");
		jQuery("#addtocart_popup .product-form__cart-submit").text("Sold Out");
	}


}

// Free Shipping Bar

function freeshippingbar(cart_json) {
	var cart_total_price = cart_json.items_subtotal_price;
	do_console(cart_total_price);
	var bar = jQuery('.free_shipping_progress_bar span');
	var total = jQuery(".subtotal.js-cart_subtotal .price").text().replace(/\D/g, '');
	var subtotal = (parseFloat(cart_total_price) / 100);
	var free_max_value = jQuery('.free_shipping_progress').attr('data-max-free-charge');
	var free_shipping = Math.abs(free_max_value - subtotal).toFixed(2);
	var bar_width = (subtotal / free_max_value) * 100;
	if (subtotal < free_max_value) {
		jQuery(".free_shipping_progress p").html("You are " + Shopify.formatMoney(free_shipping, theme.moneyFormat) + " away from FREE shipping (U.S. only)");
		bar.animate({
			width: bar_width + '%'
		}, 100);
	}
	else {
		jQuery(".free_shipping_progress p").text("Your shipping is FREE (U.S. only)");
		bar.animate({
			width: 100 + '%'
		}, 100);
	}
}

//   Top header Sticky

jQuery(window).on('scroll', function () {
	var window_top = jQuery(window).scrollTop();
	var final_height = 0;

	if (jQuery(".header-top").length) {
		var top_header = jQuery(".header-top").outerHeight();
		final_height = top_header;
	}

	if (jQuery(".header-timer").length) {
		var timer_header = jQuery(".header-timer").outerHeight();
		final_height = timer_header;
	}

	var new_final_height = final_height + 95;

	if (window_top > new_final_height) {
		jQuery('.navbar-nav-logo').fadeIn();
		jQuery('.navbar-custom').addClass('issticky');
	} else {
		jQuery('.navbar-nav-logo').fadeOut();
		jQuery('.navbar-custom').removeClass('issticky');
	}
});

// window resize
jQuery(window).on('resize', function () {
	setTimeout(function () {
		//jQuery('.top-products .product-item a').matchHeight({ byRow: false });
		//jQuery('.collection_page .product-item a').matchHeight({ byRow: false });
		//jQuery('.top-products .product-item .wrapper_div').matchHeight({ byRow: false });
		//jQuery('.subscribe-save-products .top-products .product-item .wrapper_div').matchHeight({ byRow: false });
	}, 3000);
});

jQuery(document).ready(function () {
	// Mobile Menu JS
	jQuery('.mobile_menu .dropdown-menu a.dropdown-toggle').on('click', function (e) {
		if (!jQuery(this).next().hasClass('show')) {
			jQuery(this).parents('.dropdown-menu').first().find('.show').removeClass("show");
		}
		var $subMenu = jQuery(this).next(".dropdown-menu");
		$subMenu.toggleClass('show');
		jQuery(this).parents('li.nav-item.dropdown.show').on('hidden.bs.dropdown', function (e) {
			jQuery('.dropdown-submenu .show').removeClass("show");
		});
		return false;
	});

	/*
	let califorina_stop = ['plant-based-protein-powder', 'plant-based-protein-powder-vanilla', 'matcha-powder-1', 'super-smoothie-kit', 'super-inner-wellness-kit', 'wellness-essentials-duo', 'matcha-powder-1', 'matcha-starter-set'];
	jQuery.ajax({
		type: "GET",
		url: 'https://api.ipstack.com/check?access_key=c1faa041771b160efc0792f442dea5ab',
		dataType: "json",
		success: function (data) {
			if (typeof data.region_code != 'undefined' && data.region_code) {
				var r_code = data.region_code;
				var c_code = data.country_code;
				if (r_code == 'CA' && c_code == 'US') {
					let current_url = window.location.href.toString();
					jQuery.each(califorina_stop, function (ix, em) {
						if (current_url.indexOf(em) !== -1) {
							jQuery('#crtbtn1,#AddToCart-product-template').prop('disabled', 'disabled').text('Unavailable').css('cursor', 'no-drop').css('pointer-events', 'none');
							jQuery("#addtocartsection .one_time_wrapper").remove(0);
						}
					});
					jQuery(".products-slider-top-products .product-item").each(function (ix, em) {
						let a_tag = jQuery(em).find('a').eq(0);
						let location = jQuery(a_tag).attr('href').toString().trim();
						jQuery.each(califorina_stop, function (ix2, em2) {
							if (location.indexOf(em2) !== -1) {
								let element = jQuery(em).find('.add-to-bag').eq(0);
								jQuery(element).prop('disabled', 'disabled').text('Unavailable').css('cursor', 'no-drop').css('pointer-events', 'none');
							}
						});
					});
					jQuery(".products-slider-subscribe-save .product-item").each(function (ix, em) {
						let a_tag = jQuery(em).find('a').eq(0);
						let location = jQuery(a_tag).attr('href').toString().trim();
						jQuery.each(califorina_stop, function (ix2, em2) {
							if (location.indexOf(em2) !== -1) {
								let element = jQuery(em).find('.add-to-bag').eq(0);
								jQuery(element).prop('disabled', 'disabled').text('Unavailable').css('cursor', 'no-drop').css('pointer-events', 'none');
							}
						});
					});
					jQuery("section.product-category .product-item").each(function (ix, em) {
						let a_tag = jQuery(em).find('a').eq(0);
						let location = jQuery(a_tag).attr('href').toString().trim();
						jQuery.each(califorina_stop, function (ix2, em2) {
							if (location.indexOf(em2) !== -1) {
								let element = jQuery(em).find('.add-to-bag').eq(0);
								jQuery(element).prop('disabled', 'disabled').text('Unavailable').css('cursor', 'no-drop').css('pointer-events', 'none');
							}
						});
					});
				}
			} else {
			}
		},
		error: function (data) {
		}
	});
	*/


	// Customer Review POPUP
	function readURL(input, imgControlName) {
		if (input.files && input.files[0]) {
		  var reader = new FileReader();
		  reader.onload = function(e) {
			jQuery(imgControlName).attr('src', e.target.result);
		  }
		  reader.readAsDataURL(input.files[0]);
		}
	}

	jQuery("#imag1").change(function() {
		// add your logic to decide which image control you'll use
		var imgControlName = "#ImgPreview1";
		readURL(this, imgControlName);
		jQuery('.preview1').addClass('it');
		jQuery('.btn-rmv1').addClass('rmv');
	  });
	
	  jQuery("#removeImage1").click(function(e) {
		e.preventDefault();
		jQuery("#imag1").val("");
		jQuery("#ImgPreview1").attr("src", "");
		jQuery('.preview1').removeClass('it');
		jQuery('.btn-rmv1').removeClass('rmv');
	  });
	  jQuery("#imag2").change(function() {
		// add your logic to decide which image control you'll use
		var imgControlName = "#ImgPreview2";
		readURL(this, imgControlName);
		jQuery('.preview2').addClass('it');
		jQuery('.btn-rmv2').addClass('rmv');
	  });
	
	  jQuery("#removeImage2").click(function(e) {
		e.preventDefault();
		jQuery("#imag2").val("");
		jQuery("#ImgPreview2").attr("src", "");
		jQuery('.preview2').removeClass('it');
		jQuery('.btn-rmv2').removeClass('rmv');
	  });

	jQuery('.back_to_link a').on('click', function(e){
		e.preventDefault();
		window.history.back();
	}); 

	// Add Back icon on portal acoount page
	if(jQuery("#customer_tab_content.rc_layout__full").length){
		jQuery("#customer_tab_content.rc_layout__full").prepend("<p class='text-left back_to_link'><a href='/account'><img src='//cdn.shopify.com/s/files/1/0191/6439/7668/t/1/assets/arrow-left-account.png?v=3158433559246080487' class='img-fluid'></a></p>");
	}
// });



// $(document).ready(function(e){
	// benifit div hide show
	$(".subscribe_info input[type='radio']").on('change', function () {
		var name = $(this).val();
		if (name == 'onetime') {
			$('.cbb-frequently-bought-container').show();
			$('.subscription_benifits').hide();
			$('.free_shipping-text').show();
			$(".product-info .subscription-freq").val('onetime').trigger('change');
		} else {
			$('.cbb-frequently-bought-container').hide();
			$('.subscription_benifits').show();
			$('.free_shipping-text').hide();
			adjust_sub_options()
		}
	});

    $(document).on('change','#frequency-select',function(e){
		adjust_sub_options()
		$("#is_subscribed_yes").prop('checked',true);
		$("#is_subscribed_yes").trigger('change');
	});

	// changes for product page 
	// update variant/frequence
	
});

// for subscribe and save update price as first plan selected
$(document).ready(function(){
	$('.products-slider-subscribe-save .subscription-freq').each(function(){
		$(this).find('option:first').trigger('change')
	 })
})